
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hpUsb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $lgqac = parcelRequire("lgqac");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $lAJUP = parcelRequire("lAJUP");


var $fBMbo = parcelRequire("fBMbo");


var $dQl1W = parcelRequire("dQl1W");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $ivUmx = parcelRequire("ivUmx");


var $5MkWK = parcelRequire("5MkWK");


var $9E8aG = parcelRequire("9E8aG");


var $l6tPN = parcelRequire("l6tPN");


var $5Tie7 = parcelRequire("5Tie7");


const $494a9ab126f82b16$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $42omo.lazy)(()=>(0, $ivUmx.importWithRetry)(()=>(parcelRequire("lb0pH"))));
const $494a9ab126f82b16$export$e00a7788e30dc998 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CardWithURLRenderer(props) {
    const $ = (0, $frIzR.c)(61);
    (0, $fBMbo.di)($494a9ab126f82b16$export$a7690c318cd6a95e);
    let t0;
    if ($[0] !== props.id) {
        t0 = ()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        $[0] = props.id;
        $[1] = t0;
    } else t0 = $[1];
    const [id] = (0, $42omo.useState)(t0);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[2] !== id) {
        t1 = ()=>()=>{
                (0, $l6tPN.clearMarks)(id);
                (0, $l6tPN.clearMeasures)(id);
            };
        t2 = [
            id
        ];
        $[2] = id;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    let t3;
    if ($[5] !== children || $[6] !== ui) {
        t3 = (0, $9E8aG.isFlexibleUiCard)(children, ui);
        $[5] = children;
        $[6] = ui;
        $[7] = t3;
    } else t3 = $[7];
    const isFlexibleUi = t3;
    const t4 = isFlexibleUi ? "flexible" : appearance;
    const t5 = url ?? "";
    let t6;
    if ($[8] !== id || $[9] !== t4 || $[10] !== t5) {
        t6 = {
            display: t4,
            id: id,
            url: t5
        };
        $[8] = id;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)(t6);
    let t7;
    if ($[12] !== analyticsContext?.attributes || $[13] !== appearance || $[14] !== fireEvent || $[15] !== id || $[16] !== isFlexibleUi || $[17] !== onError || $[18] !== url) {
        t7 = (error, info)=>{
            const { componentStack: componentStack } = info;
            const errorInfo = {
                componentStack: componentStack
            };
            if (error.name === "ChunkLoadError") fireEvent("operational.smartLink.chunkLoadFailed", {
                ...analyticsContext?.attributes,
                display: appearance,
                error: error,
                errorInfo: errorInfo,
                definitionId: null
            });
            else if (error.name !== "APIError") {
                (0, $bIll3.startUfoExperience)("smart-link-rendered", id || "NULL");
                (0, $bIll3.failUfoExperience)("smart-link-rendered", id || "NULL");
                (0, $bIll3.failUfoExperience)("smart-link-authenticated", id || "NULL");
                fireEvent("ui.smartLink.renderFailed", {
                    ...analyticsContext?.attributes,
                    display: isFlexibleUi ? "flexible" : appearance,
                    id: id ?? null,
                    error: error,
                    errorInfo: errorInfo
                });
            }
            onError && onError({
                status: "errored",
                url: url ?? "",
                err: error
            });
        };
        $[12] = analyticsContext?.attributes;
        $[13] = appearance;
        $[14] = fireEvent;
        $[15] = id;
        $[16] = isFlexibleUi;
        $[17] = onError;
        $[18] = url;
        $[19] = t7;
    } else t7 = $[19];
    analyticsContext?.attributes;
    const errorHandler = t7;
    if (!url) throw new Error("@atlaskit/smart-card: url property is missing.");
    const defaultFallBackComponent = $494a9ab126f82b16$var$_temp;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    let t8;
    if ($[20] !== FallbackComponent) {
        t8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FallbackComponent, null);
        $[20] = FallbackComponent;
        $[21] = t8;
    } else t8 = $[21];
    const ErrorFallback = t8;
    const effectiveAppearance = isFlexibleUi && (0, $dh538.fg)("platform_smartlink_inline_resolve_optimization") ? "block" : appearance;
    let t9;
    if ($[22] !== CompetitorPrompt || $[23] !== actionOptions || $[24] !== container || $[25] !== disablePreviewPanel || $[26] !== effectiveAppearance || $[27] !== embedIframeRef || $[28] !== embedIframeUrlType || $[29] !== frameStyle || $[30] !== hoverPreviewOptions || $[31] !== id || $[32] !== inheritDimensions || $[33] !== inlinePreloaderStyle || $[34] !== isHovered || $[35] !== isSelected || $[36] !== onClick || $[37] !== onError || $[38] !== onResolve || $[39] !== placeholder || $[40] !== platform || $[41] !== removeTextHighlightingFromTitle || $[42] !== resolvingPlaceholder || $[43] !== showHoverPreview || $[44] !== testId || $[45] !== truncateInline || $[46] !== ui || $[47] !== url) {
        t9 = {
            id: id,
            url: url,
            appearance: effectiveAppearance,
            onClick: onClick,
            isSelected: isSelected,
            isHovered: isHovered,
            frameStyle: frameStyle,
            container: container,
            onResolve: onResolve,
            onError: onError,
            testId: testId,
            actionOptions: actionOptions,
            inheritDimensions: inheritDimensions,
            platform: platform,
            embedIframeRef: embedIframeRef,
            embedIframeUrlType: embedIframeUrlType,
            inlinePreloaderStyle: inlinePreloaderStyle,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            placeholder: placeholder,
            removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
            resolvingPlaceholder: resolvingPlaceholder,
            truncateInline: truncateInline,
            CompetitorPrompt: CompetitorPrompt,
            disablePreviewPanel: disablePreviewPanel
        };
        $[22] = CompetitorPrompt;
        $[23] = actionOptions;
        $[24] = container;
        $[25] = disablePreviewPanel;
        $[26] = effectiveAppearance;
        $[27] = embedIframeRef;
        $[28] = embedIframeUrlType;
        $[29] = frameStyle;
        $[30] = hoverPreviewOptions;
        $[31] = id;
        $[32] = inheritDimensions;
        $[33] = inlinePreloaderStyle;
        $[34] = isHovered;
        $[35] = isSelected;
        $[36] = onClick;
        $[37] = onError;
        $[38] = onResolve;
        $[39] = placeholder;
        $[40] = platform;
        $[41] = removeTextHighlightingFromTitle;
        $[42] = resolvingPlaceholder;
        $[43] = showHoverPreview;
        $[44] = testId;
        $[45] = truncateInline;
        $[46] = ui;
        $[47] = url;
        $[48] = t9;
    } else t9 = $[48];
    const cardWithUrlProps = t9;
    let t10;
    if ($[49] !== cardWithUrlProps) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardWithUrlProps);
        $[49] = cardWithUrlProps;
        $[50] = t10;
    } else t10 = $[50];
    let t11;
    if ($[51] !== cardWithUrlProps || $[52] !== children) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($494a9ab126f82b16$export$a7690c318cd6a95e, cardWithUrlProps, children);
        $[51] = cardWithUrlProps;
        $[52] = children;
        $[53] = t11;
    } else t11 = $[53];
    let t12;
    if ($[54] !== t10 || $[55] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: t10
        }, t11);
        $[54] = t10;
        $[55] = t11;
        $[56] = t12;
    } else t12 = $[56];
    let t13;
    if ($[57] !== ErrorFallback || $[58] !== errorHandler || $[59] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            FallbackComponent: ErrorFallback,
            onError: errorHandler
        }, t12);
        $[57] = ErrorFallback;
        $[58] = errorHandler;
        $[59] = t12;
        $[60] = t13;
    } else t13 = $[60];
    return t13;
} : function CardWithURLRenderer(props) {
    (0, $fBMbo.di)($494a9ab126f82b16$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $l6tPN.clearMarks)(id);
            (0, $l6tPN.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $9E8aG.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $42omo.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FallbackComponent, null);
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring complete response.
    // Override appearance to 'block' for all FlexibleCards when FG is enabled.
    const effectiveAppearance = isFlexibleUi && (0, $dh538.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : appearance;
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: effectiveAppearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($494a9ab126f82b16$export$a7690c318cd6a95e, cardWithUrlProps, children)));
};
function $494a9ab126f82b16$var$_temp() {
    return null;
}


class $b7b2971f0774cd45$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $494a9ab126f82b16$export$e00a7788e30dc998), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: "en"
        }, content);
    }
}
const $b7b2971f0774cd45$export$60332b2344f7fe41 = (0, $ggbZE.default)((0, $lgqac.context))((0, $1DWH0.default)()((0, $aXWIB.injectIntl)($b7b2971f0774cd45$var$PlainCard, {
    enforceContext: false
})));
module.exports["Card"] = $b7b2971f0774cd45$export$60332b2344f7fe41;

});

parcelRegister("9E8aG", function(module, exports) {

var $42omo = parcelRequire("42omo");



var $2c99834a6fa1d6ad$exports = {};
$parcel$export($2c99834a6fa1d6ad$exports, "FooterBlock", () => (parcelRequire("8NpDA")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "MetadataBlock", () => (parcelRequire("1lLfV")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "PreviewBlock", () => (parcelRequire("Y5kOr")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "SnippetBlock", () => (parcelRequire("8zS2j")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "TitleBlock", () => (parcelRequire("5znEc")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "CustomBlock", () => (parcelRequire("2R1C4")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "InternalFooterBlock", () => (parcelRequire("jsdg1")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AISummaryBlock", () => (parcelRequire("eqpYq")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "AIFooterBlock", () => (parcelRequire("MlN47")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "ResolvedHoverCardFooterBlock", () => (parcelRequire("7Twup")).default);
$parcel$export($2c99834a6fa1d6ad$exports, "ActionBlock", () => (parcelRequire("f0wtW")).default);

var $8NpDA = parcelRequire("8NpDA");


var $1lLfV = parcelRequire("1lLfV");


var $Y5kOr = parcelRequire("Y5kOr");


var $8zS2j = parcelRequire("8zS2j");


var $5znEc = parcelRequire("5znEc");


var $2R1C4 = parcelRequire("2R1C4");


var $jsdg1 = parcelRequire("jsdg1");


var $eqpYq = parcelRequire("eqpYq");


var $MlN47 = parcelRequire("MlN47");


var $7Twup = parcelRequire("7Twup");


var $f0wtW = parcelRequire("f0wtW");




var $2gWqY = parcelRequire("2gWqY");

const $c224b37846f1c464$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).some((child)=>$c224b37846f1c464$export$df0092b19156b140(child))) return true;
    return false;
};
const $c224b37846f1c464$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $c224b37846f1c464$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($2c99834a6fa1d6ad$exports).some((type)=>type === node.type)) return true;
    return false;
};
const $c224b37846f1c464$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (Object.values($2gWqY).some((type)=>type === node.type)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $5znEc.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return false;
    if (node.type === (0, $Y5kOr.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $8NpDA.default);
module.exports["isFlexibleUiCard"] = $c224b37846f1c464$export$3c94e0f4719f5c2a;
module.exports["isStyleCacheProvider"] = $c224b37846f1c464$export$14ff825bfe645006;
module.exports["isFlexibleUiBlock"] = $c224b37846f1c464$export$b56fc89cf6e7d1e9;
module.exports["isFlexibleUiElement"] = $c224b37846f1c464$export$d7fc505bb0bd5756;
module.exports["isFlexibleUiPreviewBlock"] = $c224b37846f1c464$export$c0547b4405cae584;

});

parcelRegister("8NpDA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jsdg1 = parcelRequire("jsdg1");

/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $64d13bf310395f75$var$FooterBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let alwaysShow;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ testId: t1, alwaysShow: alwaysShow, ...props } = t0);
        $[0] = t0;
        $[1] = alwaysShow;
        $[2] = props;
        $[3] = t1;
    } else {
        alwaysShow = $[1];
        props = $[2];
        t1 = $[3];
    }
    const testId = t1 === undefined ? "smart-footer-block" : t1;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    const t2 = props.size ?? cardContext?.ui?.size;
    let t3;
    if ($[4] !== props || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jsdg1.default), {
            ...props,
            size: t2,
            testId: testId
        });
        $[4] = props;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jsdg1.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $64d13bf310395f75$export$2e2bcd8739ae039 = $64d13bf310395f75$var$FooterBlock;
module.exports["default"] = $64d13bf310395f75$export$2e2bcd8739ae039;

});

parcelRegister("fUfR2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $6e7308c6380408ec$export$13dde4423ab71d62 = (0, $42omo.createContext)(undefined);
const $6e7308c6380408ec$export$a8c4167e4e9f26ab = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($6e7308c6380408ec$export$13dde4423ab71d62);
} : ()=>(0, $42omo.useContext)($6e7308c6380408ec$export$13dde4423ab71d62);
const $6e7308c6380408ec$export$61d7957a243df7aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return $6e7308c6380408ec$export$a8c4167e4e9f26ab()?.data;
} : ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.data;
const $6e7308c6380408ec$export$e6b5ad18b56e8f51 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return $6e7308c6380408ec$export$a8c4167e4e9f26ab()?.ui;
} : ()=>$6e7308c6380408ec$export$a8c4167e4e9f26ab()?.ui;
module.exports["FlexibleCardContext"] = $6e7308c6380408ec$export$13dde4423ab71d62;
module.exports["useFlexibleCardContext"] = $6e7308c6380408ec$export$a8c4167e4e9f26ab;
module.exports["useFlexibleUiContext"] = $6e7308c6380408ec$export$61d7957a243df7aa;
module.exports["useFlexibleUiOptionContext"] = $6e7308c6380408ec$export$e6b5ad18b56e8f51;

});

parcelRegister("jsdg1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4P6U3 = parcelRequire("4P6U3");


var $4JDbp = parcelRequire("4JDbp");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $2ZgNz = parcelRequire("2ZgNz");


var $7d67T = parcelRequire("7d67T");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $a5a88c936354623c$var$actionGroupStyles = null;
const $a5a88c936354623c$var$safariStyles = null;
const $a5a88c936354623c$var$providerStyles = null;
const $a5a88c936354623c$var$rovoActionStyles = null;
const $a5a88c936354623c$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5TXU5.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const rovoChatAction = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const hasPreview = !!rovoChatAction && !!rovoChatAction?.product && rovoChatAction?.product === 'CONFLUENCE' && !!context?.preview && !isPreviewBlockErrored;
    const hasActions = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $42omo.useMemo)(()=>(0, $4P6U3.browser)(), []);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]); // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(undefined);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $42omo.createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $gMc0m.default)([
            !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' && "_1wpz1h6o"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        testId: "smart-element-group-actions",
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq",
            !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' && "_kqswh2mm"
        ])
    }, !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' && /*#__PURE__*/ $42omo.createElement((0, $4JDbp.default), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' ? 'subtle' : 'default',
        size: !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' ? (0, $5TXU5.SmartLinkSize).Small : size,
        containerWidth: !!rovoChatAction && rovoChatAction?.product === 'CONFLUENCE' ? containerWidth : undefined
    })) : null);
};
var $a5a88c936354623c$export$2e2bcd8739ae039 = $a5a88c936354623c$var$FooterBlockResolvedView;
module.exports["default"] = $a5a88c936354623c$export$2e2bcd8739ae039;

});

parcelRegister("l17Fn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $cc85c7b3ba72e34b$var$useRovoConfig = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { rovoOptions: rovoOptions, product: product } = (0, $eIleF.useSmartLinkContext)();
    let t0;
    if ($[0] !== product || $[1] !== rovoOptions) {
        t0 = {
            rovoOptions: rovoOptions,
            product: product
        };
        $[0] = product;
        $[1] = rovoOptions;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $cc85c7b3ba72e34b$export$2e2bcd8739ae039 = $cc85c7b3ba72e34b$var$useRovoConfig;
module.exports["default"] = $cc85c7b3ba72e34b$export$2e2bcd8739ae039;

});

parcelRegister("7r4Rz", function(module, exports) {
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $6iY4P = parcelRequire("6iY4P");


var $j6GAe = parcelRequire("j6GAe");


var $7CgcZ = parcelRequire("7CgcZ");

const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $6iY4P.default), (0, $j6GAe.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;
module.exports["default"] = $a1b21c3b6fc75776$export$2e2bcd8739ae039;

});

parcelRegister("GFtWS", function(module, exports) {
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $66dpz = parcelRequire("66dpz");


var $fAGae = parcelRequire("fAGae");


var $7CgcZ = parcelRequire("7CgcZ");

const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $66dpz.default), (0, $fAGae.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;
module.exports["default"] = $fc75dd15b55d0661$export$2e2bcd8739ae039;

});

parcelRegister("7d67T", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $hArLp = parcelRequire("hArLp");


var $eEA8O = parcelRequire("eEA8O");


var $52EPl = parcelRequire("52EPl");


var $9VJDA = parcelRequire("9VJDA");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $l17Fn = parcelRequire("l17Fn");


var $4I8po = parcelRequire("4I8po");


var $hJgLA = parcelRequire("hJgLA");


var $l7DP7 = parcelRequire("l7DP7");











var $jlQ9A = parcelRequire("jlQ9A");

const $98cfef5f1319cffc$var$ActionGroupItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick } = t0;
    let hideContent;
    let hideIcon;
    let isDisabled;
    let name;
    let onClick;
    let props;
    if ($[0] !== item) {
        ({ name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item);
        $[0] = item;
        $[1] = hideContent;
        $[2] = hideIcon;
        $[3] = isDisabled;
        $[4] = name;
        $[5] = onClick;
        $[6] = props;
    } else {
        hideContent = $[1];
        hideIcon = $[2];
        isDisabled = $[3];
        name = $[4];
        onClick = $[5];
        props = $[6];
    }
    let t1;
    if ($[7] !== onActionItemClick || $[8] !== onClick) {
        t1 = ()=>{
            if (onActionItemClick) onActionItemClick();
            if (onClick) onClick();
        };
        $[7] = onActionItemClick;
        $[8] = onClick;
        $[9] = t1;
    } else t1 = $[9];
    const handleOnClick = t1;
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    let actionProps;
    if ($[10] !== asDropDownItems || $[11] !== hideContent || $[12] !== hideIcon || $[13] !== item.entryPointWrapper || $[14] !== props) {
        actionProps = {
            ...props
        };
        if (hideContent && !asDropDownItems) actionProps.content = "";
        if (hideIcon) actionProps.icon = undefined;
        if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
        $[10] = asDropDownItems;
        $[11] = hideContent;
        $[12] = hideIcon;
        $[13] = item.entryPointWrapper;
        $[14] = props;
        $[15] = actionProps;
    } else actionProps = $[15];
    let t2;
    if ($[16] !== Action || $[17] !== actionProps || $[18] !== appearance || $[19] !== asDropDownItems || $[20] !== handleOnClick || $[21] !== isDisabled || $[22] !== size) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Action, {
            asDropDownItem: asDropDownItems,
            size: size,
            appearance: appearance,
            onClick: handleOnClick,
            isDisabled: isDisabled,
            ...actionProps
        });
        $[16] = Action;
        $[17] = actionProps;
        $[18] = appearance;
        $[19] = asDropDownItems;
        $[20] = handleOnClick;
        $[21] = isDisabled;
        $[22] = size;
        $[23] = t2;
    } else t2 = $[23];
    return t2;
} : ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $98cfef5f1319cffc$export$2e2bcd8739ae039 = $98cfef5f1319cffc$var$ActionGroupItem;


const $56632f4bfc993cb1$var$styles = null;
const $56632f4bfc993cb1$var$FULL_ACTIONS_SIZE = 450;
const $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE = 360;
const $56632f4bfc993cb1$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $56632f4bfc993cb1$var$renderActionItems = (items = [], size = (0, $5TXU5.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $98cfef5f1319cffc$export$2e2bcd8739ae039), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        })); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $56632f4bfc993cb1$var$ActionGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(46);
    const { items: t1, size: t2, appearance: appearance, visibleButtonsNum: t3, onDropdownOpenChange: onDropdownOpenChange, containerWidth: t4 } = t0;
    let t5;
    if ($[0] !== t1) {
        t5 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t5;
    } else t5 = $[1];
    const items = t5;
    const size = t2 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t2;
    const visibleButtonsNum = t3 === undefined ? 2 : t3;
    const containerWidth = t4 === undefined ? Infinity : t4;
    (0, $fBMbo.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const { product: product } = (0, $l17Fn.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    let t6;
    if ($[2] !== context || $[3] !== items || $[4] !== product) {
        t6 = (0, $l7DP7.filterActionItems)(items, context, product);
        $[2] = context;
        $[3] = items;
        $[4] = product;
        $[5] = t6;
    } else t6 = $[5];
    const renderableActionItems = t6;
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    let t7;
    if ($[6] !== onDropdownOpenChange) {
        t7 = (attrs)=>{
            setIsOpen(attrs.isOpen);
            if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
        };
        $[6] = onDropdownOpenChange;
        $[7] = t7;
    } else t7 = $[7];
    const onOpenChange = t7;
    let t8;
    if ($[8] !== isOpen || $[9] !== onOpenChange) {
        t8 = ()=>{
            if (isOpen) onOpenChange({
                isOpen: false
            });
        };
        $[8] = isOpen;
        $[9] = onOpenChange;
        $[10] = t8;
    } else t8 = $[10];
    const onActionItemClick = t8;
    let t9;
    bb0: {
        if (!!rovoChatAction && rovoChatAction.product === "CONFLUENCE") {
            let t10;
            if ($[11] !== appearance || $[12] !== containerWidth || $[13] !== onActionItemClick || $[14] !== renderableActionItems || $[15] !== size || $[16] !== visibleButtonsNum) {
                const rovoActions = [
                    ...containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                    ...containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                        {
                            name: (0, $5TXU5.ActionName).RovoChatAction,
                            prompts: [
                                (0, $4I8po.RovoChatPromptKey).ASK_ROVO_ANYTHING
                            ],
                            iconSize: "small",
                            cardAppearance: (0, $5TXU5.CardDisplay).Block,
                            hideContent: containerWidth < $56632f4bfc993cb1$var$FULL_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE || containerWidth < $56632f4bfc993cb1$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE
                        },
                        {
                            name: (0, $5TXU5.ActionName).CopyLinkAction,
                            hideContent: true,
                            iconSize: "small"
                        },
                        {
                            name: (0, $5TXU5.ActionName).PreviewAction,
                            hideContent: true,
                            iconSize: "small"
                        }
                    ] : []
                ];
                t10 = $56632f4bfc993cb1$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
                $[11] = appearance;
                $[12] = containerWidth;
                $[13] = onActionItemClick;
                $[14] = renderableActionItems;
                $[15] = size;
                $[16] = visibleButtonsNum;
                $[17] = t10;
            } else t10 = $[17];
            t9 = t10;
            break bb0;
        }
        let t10;
        if ($[18] !== isMoreThenTwoItems || $[19] !== renderableActionItems || $[20] !== visibleButtonsNum) {
            t10 = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
            $[18] = isMoreThenTwoItems;
            $[19] = renderableActionItems;
            $[20] = visibleButtonsNum;
            $[21] = t10;
        } else t10 = $[21];
        const actionItems = t10;
        let t11;
        if ($[22] !== actionItems || $[23] !== appearance || $[24] !== onActionItemClick || $[25] !== size) {
            t11 = $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
            $[22] = actionItems;
            $[23] = appearance;
            $[24] = onActionItemClick;
            $[25] = size;
            $[26] = t11;
        } else t11 = $[26];
        t9 = t11;
    }
    const actionButtons = t9;
    let t10;
    if ($[27] !== appearance || $[28] !== containerWidth || $[29] !== isMoreThenTwoItems || $[30] !== isOpen || $[31] !== onActionItemClick || $[32] !== onOpenChange || $[33] !== renderableActionItems || $[34] !== rovoChatAction || $[35] !== size || $[36] !== ui?.zIndex || $[37] !== visibleButtonsNum) {
        t10 = ()=>{
            let actionItems_0;
            if (!!rovoChatAction && rovoChatAction.product === "CONFLUENCE" && containerWidth < $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems_0 = [
                ...renderableActionItems,
                {
                    name: (0, $5TXU5.ActionName).RovoChatAction,
                    prompts: [
                        (0, $4I8po.RovoChatPromptKey).ASK_ROVO_ANYTHING
                    ],
                    iconSize: "small",
                    cardAppearance: (0, $5TXU5.CardDisplay).Block
                },
                {
                    name: (0, $5TXU5.ActionName).CopyLinkAction,
                    iconSize: "small"
                },
                {
                    name: (0, $5TXU5.ActionName).PreviewAction,
                    iconSize: "small"
                }
            ];
            else if (!!rovoChatAction && rovoChatAction.product === "CONFLUENCE" && containerWidth < $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE) actionItems_0 = renderableActionItems;
            else actionItems_0 = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
            if (actionItems_0.length > 0) {
                const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
                const moreIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: "more",
                    color: "currentColor"
                });
                const formatMessage = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).more_actions);
                return /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    trigger: (t11)=>{
                        const { triggerRef: triggerRef, ...props } = t11;
                        return /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                            content: formatMessage,
                            hideTooltipOnClick: true,
                            testId: "action-group-more-button-tooltip",
                            tag: "span"
                        }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                            ...props,
                            spacing: !!rovoChatAction && rovoChatAction.product === "CONFLUENCE" ? size === (0, $5TXU5.SmartLinkSize).XLarge ? "default" : "compact" : spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef,
                            ...!!rovoChatAction && rovoChatAction.product === "CONFLUENCE" ? {
                                appearance: appearance
                            } : {}
                        }));
                    },
                    testId: "action-group-dropdown",
                    zIndex: ui?.zIndex
                }, $56632f4bfc993cb1$var$renderActionItems(actionItems_0, size, appearance, true, onActionItemClick));
            }
            return null;
        };
        $[27] = appearance;
        $[28] = containerWidth;
        $[29] = isMoreThenTwoItems;
        $[30] = isOpen;
        $[31] = onActionItemClick;
        $[32] = onOpenChange;
        $[33] = renderableActionItems;
        $[34] = rovoChatAction;
        $[35] = size;
        $[36] = ui?.zIndex;
        $[37] = visibleButtonsNum;
        $[38] = t10;
    } else t10 = $[38];
    ui?.zIndex;
    let t11;
    if ($[39] !== t10) {
        t11 = t10();
        $[39] = t10;
        $[40] = t11;
    } else t11 = $[40];
    const moreActionDropdown = t11;
    let t12;
    if ($[41] !== actionButtons || $[42] !== isOpen || $[43] !== moreActionDropdown || $[44] !== renderableActionItems.length) {
        t12 = renderableActionItems.length > 0 ? /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0c116y _dzc21h6o _1ilq1i6y",
                "actions-button-group"
            ]),
            "data-action-open": isOpen
        }, /*#__PURE__*/ $42omo.createElement((0, $hArLp.default), null, actionButtons, moreActionDropdown)) : null;
        $[41] = actionButtons;
        $[42] = isOpen;
        $[43] = moreActionDropdown;
        $[44] = renderableActionItems.length;
        $[45] = t12;
    } else t12 = $[45];
    return t12;
} : ({ items: items = [], size: size = (0, $5TXU5.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    (0, $fBMbo.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const { product: product } = (0, $l17Fn.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const renderableActionItems = (0, $42omo.useMemo)(()=>(0, $l7DP7.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const onOpenChange = (0, $42omo.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $42omo.useMemo)(()=>{
        if (!!rovoChatAction && rovoChatAction.product === 'CONFLUENCE') {
            const rovoActions = [
                ...containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $5TXU5.ActionName).RovoChatAction,
                        prompts: [
                            (0, $4I8po.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $5TXU5.CardDisplay).Block,
                        hideContent: containerWidth < $56632f4bfc993cb1$var$FULL_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE || containerWidth < $56632f4bfc993cb1$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $5TXU5.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $5TXU5.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $56632f4bfc993cb1$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        rovoChatAction,
        containerWidth
    ]);
    const moreActionDropdown = (0, $42omo.useMemo)(()=>{
        let actionItems_0;
        if (!!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && containerWidth < $56632f4bfc993cb1$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems_0 = [
            ...renderableActionItems,
            {
                name: (0, $5TXU5.ActionName).RovoChatAction,
                prompts: [
                    (0, $4I8po.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $5TXU5.CardDisplay).Block
            },
            {
                name: (0, $5TXU5.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (!!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && containerWidth < $56632f4bfc993cb1$var$REDUCED_ACTIONS_SIZE) actionItems_0 = renderableActionItems;
        else actionItems_0 = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems_0.length > 0) {
            const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).more_actions);
            return /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
                        ...props,
                        spacing: !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' ? size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact' : spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef,
                        ...!!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' ? {
                            appearance: appearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $56632f4bfc993cb1$var$renderActionItems(actionItems_0, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum,
        rovoChatAction,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $42omo.createElement((0, $hArLp.default), null, actionButtons, moreActionDropdown)) : null;
};
var $56632f4bfc993cb1$export$2e2bcd8739ae039 = $56632f4bfc993cb1$var$ActionGroup;
module.exports["default"] = $56632f4bfc993cb1$export$2e2bcd8739ae039;

});

parcelRegister("4I8po", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4ymXE = parcelRequire("4ymXE");


var $lDwiy = parcelRequire("lDwiy");


var $a6IPc = parcelRequire("a6IPc");


var $cOQz3 = parcelRequire("cOQz3");


var $lAFHW = parcelRequire("lAFHW");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $gMc0m = parcelRequire("gMc0m");

const $d24cc54ef12e71e2$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $d24cc54ef12e71e2$var$AiChapterIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("g", {
            clipPath: "url(#paint0_angular_1804_15128_clip_path)",
            "data-figma-skip-parse": "true"
        }, /*#__PURE__*/ $42omo.createElement("g", {
            transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
        }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
            x: "-1047.5",
            y: "-1047.5",
            width: "2095.01",
            height: "2095.01"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $d24cc54ef12e71e2$var$style.foreignObject
            ])
        }))));
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
            "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":16.000001907348633,\"m01\":20.036861419677734,\"m02\":-6.0184345245361328,\"m10\":-18.784559249877930,\"m11\":15.000002861022949,\"m12\":14.392276763916016},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
            id: "paint0_angular_1804_15128_clip_path"
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
        })));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== props) {
        t3 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t0, t1, t2);
        $[3] = props;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $d24cc54ef12e71e2$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$d24cc54ef12e71e2$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $d24cc54ef12e71e2$export$2e2bcd8739ae039 = $d24cc54ef12e71e2$var$AiChapterIcon;














const $f48d50acd0691865$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $f48d50acd0691865$var$AiEditIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("g", {
            clipPath: "url(#paint0_angular_1804_16152_clip_path)",
            "data-figma-skip-parse": "true"
        }, /*#__PURE__*/ $42omo.createElement("g", {
            transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
        }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
            x: "-1041.51",
            y: "-1041.51",
            width: "2083.02",
            height: "2083.02"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $f48d50acd0691865$var$style.foreignObject
            ])
        }))));
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z",
            "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":15.982254981994629,\"m01\":20.014636993408203,\"m02\":-6.0073223114013672,\"m10\":-20.036954879760742,\"m11\":16.000076293945312,\"m12\":14.018474578857422},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $42omo.createElement("g", {
            clipPath: "url(#paint1_angular_1804_16152_clip_path)",
            "data-figma-skip-parse": "true"
        }, /*#__PURE__*/ $42omo.createElement("g", {
            transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
        }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
            x: "-1041.51",
            y: "-1041.51",
            width: "2083.02",
            height: "2083.02"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $f48d50acd0691865$var$style.foreignObject
            ])
        }))));
        t3 = /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z",
            "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":15.982254981994629,\"m01\":20.014636993408203,\"m02\":-6.0073223114013672,\"m10\":-20.036954879760742,\"m11\":16.000076293945312,\"m12\":14.018474578857422},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
        });
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $42omo.createElement("clipPath", {
            id: "paint0_angular_1804_16152_clip_path"
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ $42omo.createElement("defs", null, t4, /*#__PURE__*/ $42omo.createElement("clipPath", {
            id: "paint1_angular_1804_16152_clip_path"
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z"
        })));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props) {
        t6 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t0, t1, t2, t3, t5);
        $[6] = props;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
} : (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_16152_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1041.51",
        y: "-1041.51",
        width: "2083.02",
        height: "2083.02"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $f48d50acd0691865$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":15.982254981994629,"m01":20.014636993408203,"m02":-6.0073223114013672,"m10":-20.036954879760742,"m11":16.000076293945312,"m12":14.018474578857422},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint1_angular_1804_16152_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00799113 -0.0100185 0.0100073 0.00800004 11.9911 12)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1041.51",
        y: "-1041.51",
        width: "2083.02",
        height: "2083.02"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $f48d50acd0691865$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":15.982254981994629,"m01":20.014636993408203,"m02":-6.0073223114013672,"m10":-20.036954879760742,"m11":16.000076293945312,"m12":14.018474578857422},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_16152_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8358 9.85361C16.6169 9.07256 17.8832 9.07256 18.6642 9.85361L19.3965 10.5858C20.1775 11.3669 20.1775 12.6332 19.3965 13.4143L14.2594 18.5513C14.019 18.7917 13.7214 18.9668 13.3946 19.0602L10.2061 19.9712C9.94416 20.046 9.66229 19.973 9.46969 19.7804C9.27709 19.5878 9.20405 19.3059 9.27888 19.044L10.1899 15.8555C10.2833 15.5286 10.4584 15.231 10.6987 14.9907L15.8358 9.85361ZM17.6036 10.9143C17.4083 10.719 17.0917 10.719 16.8965 10.9143L16.3107 11.5001L17.75 12.9394L18.3358 12.3536C18.5311 12.1583 18.5311 11.8418 18.3358 11.6465L17.6036 10.9143ZM16.6894 14.0001L15.25 12.5607L11.7594 16.0513C11.6993 16.1114 11.6555 16.1858 11.6322 16.2675L11.092 18.158L12.9825 17.6179C13.0642 17.5946 13.1386 17.5508 13.1987 17.4907L16.6894 14.0001Z"
    })), /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint1_angular_1804_16152_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.75 4C9.05931 4 9.3369 4.18989 9.449 4.47817L10.4494 7.0506L13.0218 8.051C13.3101 8.16311 13.5 8.44069 13.5 8.75C13.5 9.05931 13.3101 9.3369 13.0218 9.449L10.4494 10.4494L9.449 13.0218C9.3369 13.3101 9.05931 13.5 8.75 13.5C8.44069 13.5 8.16311 13.3101 8.051 13.0218L7.0506 10.4494L4.47817 9.449C4.18989 9.3369 4 9.05931 4 8.75C4 8.44069 4.18989 8.16311 4.47817 8.051L7.0506 7.0506L8.051 4.47817C8.16311 4.18989 8.44069 4 8.75 4ZM8.75 6.81927L8.329 7.90183C8.25279 8.09781 8.09781 8.25279 7.90183 8.329L6.81927 8.75L7.90183 9.171C8.09781 9.24721 8.25279 9.40219 8.329 9.59817L8.75 10.6807L9.171 9.59817C9.24721 9.40219 9.40219 9.24721 9.59817 9.171L10.6807 8.75L9.59817 8.329C9.40219 8.25279 9.24721 8.09781 9.171 7.90183L8.75 6.81927Z"
    }))));
$f48d50acd0691865$var$AiEditIcon.displayName = 'AiEditIcon';
var $f48d50acd0691865$export$2e2bcd8739ae039 = $f48d50acd0691865$var$AiEditIcon;














const $851aea84cbe6a73c$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $851aea84cbe6a73c$var$AiSearchIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("g", {
            clipPath: "url(#paint0_angular_1804_8080_clip_path)",
            "data-figma-skip-parse": "true"
        }, /*#__PURE__*/ $42omo.createElement("g", {
            transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
        }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
            x: "-1058.95",
            y: "-1058.95",
            width: "2117.91",
            height: "2117.91"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $851aea84cbe6a73c$var$style.foreignObject
            ])
        }))));
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
            "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":14.030276298522949,\"m01\":17.570167541503906,\"m02\":-3.7850868701934814,\"m10\":-18.822471618652344,\"m11\":15.030277252197266,\"m12\":13.411232948303223},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $42omo.createElement("g", {
            clipPath: "url(#paint1_angular_1804_8080_clip_path)",
            "data-figma-skip-parse": "true"
        }, /*#__PURE__*/ $42omo.createElement("g", {
            transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
        }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
            x: "-1058.95",
            y: "-1058.95",
            width: "2117.91",
            height: "2117.91"
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $851aea84cbe6a73c$var$style.foreignObject
            ])
        }))));
        t3 = /*#__PURE__*/ $42omo.createElement("path", {
            d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
            "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.65490198135375977,\"b\":0.0,\"a\":1.0},\"position\":0.20192027091979980},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.20202027261257172},{\"color\":{\"r\":0.41662007570266724,\"g\":0.60310000181198120,\"b\":0.13690000772476196,\"a\":1.0},\"position\":0.46637400984764099},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.46647399663925171},{\"color\":{\"r\":0.094117648899555206,\"g\":0.40784314274787903,\"b\":0.85882353782653809,\"a\":1.0},\"position\":0.70185315608978271},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":0.70195317268371582},{\"color\":{\"r\":0.68627452850341797,\"g\":0.34901961684226990,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":14.030276298522949,\"m01\":17.570167541503906,\"m02\":-3.7850868701934814,\"m10\":-18.822471618652344,\"m11\":15.030277252197266,\"m12\":13.411232948303223},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
        });
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $42omo.createElement("clipPath", {
            id: "paint0_angular_1804_8080_clip_path"
        }, /*#__PURE__*/ $42omo.createElement("path", {
            d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ $42omo.createElement("defs", null, t4, /*#__PURE__*/ $42omo.createElement("clipPath", {
            id: "paint1_angular_1804_8080_clip_path"
        }, /*#__PURE__*/ $42omo.createElement("path", {
            d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
        })));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props) {
        t6 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t0, t1, t2, t3, t5);
        $[6] = props;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
} : (props)=>/*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $851aea84cbe6a73c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $42omo.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $42omo.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $851aea84cbe6a73c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $42omo.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $42omo.createElement("defs", null, /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $42omo.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $42omo.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$851aea84cbe6a73c$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $851aea84cbe6a73c$export$2e2bcd8739ae039 = $851aea84cbe6a73c$var$AiSearchIcon;


/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $bKVdz = parcelRequire("bKVdz");

var $iJQnc = parcelRequire("iJQnc");

var $caRYB = parcelRequire("caRYB");

var $5x0y1 = parcelRequire("5x0y1");

var $eyfm5 = parcelRequire("eyfm5");

var $2FFuS = parcelRequire("2FFuS");

var $aoDcQ = parcelRequire("aoDcQ");

var $36XMI = parcelRequire("36XMI");

const $e264bb7b4e675ff3$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $e264bb7b4e675ff3$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $e264bb7b4e675ff3$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $e264bb7b4e675ff3$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $e264bb7b4e675ff3$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $e264bb7b4e675ff3$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent?.trim()) tokens.push({
                type: 'text',
                content: $e264bb7b4e675ff3$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $e264bb7b4e675ff3$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $eyfm5.listItem)([
        (0, $2FFuS.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $eyfm5.listItem)(content);
};
const $e264bb7b4e675ff3$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $2FFuS.paragraph)(...content);
        case 'ul':
            return (0, $36XMI.bulletList)(...content);
        case 'li':
            return $e264bb7b4e675ff3$var$buildListItem(content);
    }
};
const $e264bb7b4e675ff3$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $bKVdz.strong)(content);
        case 'code':
            return (0, $iJQnc.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $5x0y1.inlineCard)({
                url: content
            });
        default:
            return (0, $aoDcQ.text)(content);
    }
};
const $e264bb7b4e675ff3$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    const inlineAdfNode = $e264bb7b4e675ff3$var$inlineToAdf(currentMarks?.[0]?.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($e264bb7b4e675ff3$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($e264bb7b4e675ff3$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $e264bb7b4e675ff3$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $e264bb7b4e675ff3$var$blockToAdf(closed?.type, closed?.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $e264bb7b4e675ff3$var$htmlToAdf = (html)=>{
    try {
        const tokens = $e264bb7b4e675ff3$var$tokenizeHtml(html);
        const adfContent = $e264bb7b4e675ff3$var$parseTokensToAdf(tokens);
        return (0, $caRYB.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $e264bb7b4e675ff3$export$2e2bcd8739ae039 = $e264bb7b4e675ff3$var$htmlToAdf;


var $476623ad9baccc7b$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["RECOMMEND_OTHER_SOURCES"] = "recommend-other-sources";
    RovoChatPromptKey["SHOW_OTHER_MENTIONS"] = "show-other-mentions";
    RovoChatPromptKey["SUGGEST_IMPROVEMENT"] = "suggest-improvement";
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    RovoChatPromptKey["SUMMARIZE_DOCUMENT"] = "summarize-document";
    RovoChatPromptKey["SUMMARIZE_PRESENTATION"] = "summarize-presentation";
    RovoChatPromptKey["EXPLAIN_CODE"] = "explain-code";
    RovoChatPromptKey["CATCH_UP"] = "catch-up";
    RovoChatPromptKey["SALESFORCE_PREP"] = "salesforce-prep";
    return RovoChatPromptKey;
}({});
const $476623ad9baccc7b$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_confluence_page),
                contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_confluence_page_short)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_jira_work_item),
                contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_jira_work_item_short)
            };
    }
};
const $476623ad9baccc7b$export$35d7b8e732470f9f = ({ promptKey: promptKey, intl: intl, url: url = '', product: product, iconSize: iconSize, cardAppearance: cardAppearance, provider: provider })=>{
    const { contextLong: contextLong, contextShort: contextShort } = $476623ad9baccc7b$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_generic),
        contextShort: intl.formatMessage((0, $afp1H.messages).rovo_prompt_context_generic)
    };
    switch(promptKey){
        case "recommend-other-sources":
            const label_recommend = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_recommend_other_sources);
            const html_recommend = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_recommend_other_sources, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f48d50acd0691865$export$2e2bcd8739ae039), null),
                content: label_recommend,
                tooltipMessage: label_recommend,
                data: {
                    name: label_recommend,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_recommend)
                }
            };
        case "show-other-mentions":
            const label_other_mentions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_show_other_mentions);
            const html_other_mentions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_show_other_mentions, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d24cc54ef12e71e2$export$2e2bcd8739ae039), null),
                content: label_other_mentions,
                tooltipMessage: label_other_mentions,
                data: {
                    name: label_other_mentions,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_other_mentions)
                }
            };
        case "suggest-improvement":
            const label_improvement = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_suggest_improvement, {
                context: contextShort
            });
            const html_improvement = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_suggest_improvement, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $851aea84cbe6a73c$export$2e2bcd8739ae039), null),
                content: label_improvement,
                tooltipMessage: label_improvement,
                data: {
                    name: label_improvement,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_improvement)
                }
            };
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $afp1H.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_summarize,
                    size: iconSize
                }),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d24cc54ef12e71e2$export$2e2bcd8739ae039), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $5TXU5.CardDisplay).Block && !!product && product === 'CONFLUENCE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall',
                    shouldUseHexLogo: true
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $851aea84cbe6a73c$export$2e2bcd8739ae039), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_find_open_questions)
                }
            };
        case "summarize-document":
            const label_summarize_document = intl.formatMessage((0, $afp1H.messages).ai_summarize);
            const html_summarize_document = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize_document, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_document,
                tooltipMessage: label_summarize_document,
                data: {
                    name: label_summarize_document,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize_document)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_summarize_document,
                    size: iconSize
                })
            };
        case "summarize-presentation":
            const label_summarize_presentation = intl.formatMessage((0, $afp1H.messages).ai_summarize);
            const html_summarize_presentation = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_summarize_presentation, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_presentation,
                tooltipMessage: label_summarize_presentation,
                data: {
                    name: label_summarize_presentation,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_summarize_presentation)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_summarize_presentation,
                    size: iconSize
                })
            };
        case "explain-code":
            const label_explain_code = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_explain_code);
            const html_explain_code = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_explain_code, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_explain_code,
                tooltipMessage: label_explain_code,
                data: {
                    name: label_explain_code,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_explain_code)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_explain_code,
                    size: iconSize
                })
            };
        case "catch-up":
            const label_catch_up = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_catch_up);
            const html_catch_up = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_catch_up, {
                url: url,
                provider: provider
            }, {
                ignoreTag: true
            });
            return {
                content: label_catch_up,
                tooltipMessage: label_catch_up,
                data: {
                    name: label_catch_up,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_catch_up)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_catch_up,
                    size: iconSize
                })
            };
        case "salesforce-prep":
            const label_overview = intl.formatMessage((0, $afp1H.messages).rovo_prompt_button_salesforce_prep);
            const html_overview = intl.formatMessage((0, $afp1H.messages).rovo_prompt_message_salesforce_prep, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_overview,
                tooltipMessage: label_overview,
                data: {
                    name: label_overview,
                    dialogues: [],
                    prompt: (0, $e264bb7b4e675ff3$export$2e2bcd8739ae039)(html_overview)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                    label: label_overview,
                    size: iconSize
                })
            };
    }
};
module.exports["RovoChatPromptKey"] = $476623ad9baccc7b$export$a9f8723a23072cb8;
module.exports["getPromptAction"] = $476623ad9baccc7b$export$35d7b8e732470f9f;

});

parcelRegister("bKVdz", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $12b0f1868a399867$export$59ae2c325a998f89 = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'strong'
    }, maybeNode);
module.exports["strong"] = $12b0f1868a399867$export$59ae2c325a998f89;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("36XMI", function(module, exports) {
const $1ea2bb3e2633a104$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });
module.exports["bulletList"] = $1ea2bb3e2633a104$export$a140c94e5ea26bee;

});

parcelRegister("l7DP7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $9E8aG = parcelRequire("9E8aG");


var $2gWqY = parcelRequire("2gWqY");


var $7d67T = parcelRequire("7d67T");


var $1RvsP = parcelRequire("1RvsP");

const $304e11160ef9ec7e$export$f942619ce67b1a41 = {
    [(0, $5TXU5.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Location]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Preview]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).State]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Title]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).HostName]: [
        'inline'
    ]
};
const $304e11160ef9ec7e$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1;
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $304e11160ef9ec7e$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && node.type === (0, $7d67T.default);
const $304e11160ef9ec7e$var$isElementDisplayValid = (name, display)=>{
    return $304e11160ef9ec7e$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $304e11160ef9ec7e$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $304e11160ef9ec7e$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node) && ((0, $9E8aG.isFlexibleUiElement)(node) || node.type === (0, $1RvsP.default));
const $304e11160ef9ec7e$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5TXU5.ActionName).DeleteAction:
            case (0, $5TXU5.ActionName).EditAction:
            case (0, $5TXU5.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5TXU5.ActionName)[item.name]);
            case (0, $5TXU5.ActionName).RovoChatAction:
                if (!!product && product === 'CONFLUENCE') return Boolean((0, $5TXU5.ActionName)[item.name]);
                // same as default case below
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $304e11160ef9ec7e$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child)=>{
        if ($304e11160ef9ec7e$var$isElementOrElementGroup(child) || $304e11160ef9ec7e$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $304e11160ef9ec7e$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2gWqY[name];
        const typedProps = props;
        if (Element && $304e11160ef9ec7e$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$304e11160ef9ec7e$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};
module.exports["filterActionItems"] = $304e11160ef9ec7e$export$adbd04236f07a7d8;
module.exports["renderChildren"] = $304e11160ef9ec7e$export$cd762ccf1a583d69;
module.exports["renderElementItems"] = $304e11160ef9ec7e$export$9678d3ca18bd7526;

});

parcelRegister("aIzVM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $hJgLA = parcelRequire("hJgLA");

const $1ecffae6e6a717dc$var$baseStyle = null;
const $1ecffae6e6a717dc$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $1ecffae6e6a717dc$export$79422073c7118b5b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { content: content, maxLines: t1, message: message, name: name, className: className, testId: t2, hideFormat: t3, color: color, fontSize: fontSize } = t0;
    const maxLines = t1 === undefined ? 1 : t1;
    const testId = t2 === undefined ? "smart-element-text" : t2;
    const hideFormat = t3 === undefined ? false : t3;
    if (!message && !content) return null;
    let t4;
    if ($[0] !== content || $[1] !== hideFormat || $[2] !== message) {
        t4 = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
        $[0] = content;
        $[1] = hideFormat;
        $[2] = message;
        $[3] = t4;
    } else t4 = $[3];
    const formattedContent = t4;
    const t5 = fontSize !== undefined && $1ecffae6e6a717dc$var$fontOverrideStyleMap[fontSize];
    let t6;
    if ($[4] !== className || $[5] !== t5) {
        t6 = (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            t5,
            "_1yyjr31u _102k1dud",
            className
        ]);
        $[4] = className;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== maxLines) {
        t7 = (0, $7sObp.default)(maxLines);
        $[7] = maxLines;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== color || $[10] !== t7) {
        t8 = {
            color: color,
            "--_1erfju8": t7
        };
        $[9] = color;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== formattedContent || $[13] !== name || $[14] !== t6 || $[15] !== t8 || $[16] !== testId) {
        t9 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-text": true,
            "data-testid": testId,
            className: t6,
            style: t8
        }, formattedContent);
        $[12] = formattedContent;
        $[13] = name;
        $[14] = t6;
        $[15] = t8;
        $[16] = testId;
        $[17] = t9;
    } else t9 = $[17];
    return t9;
} : ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $1ecffae6e6a717dc$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $7sObp.default)(maxLines)
        }
    }, formattedContent);
};
var $1ecffae6e6a717dc$export$2e2bcd8739ae039 = $1ecffae6e6a717dc$export$79422073c7118b5b;
const $1ecffae6e6a717dc$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $1ecffae6e6a717dc$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
module.exports["default"] = $1ecffae6e6a717dc$export$2e2bcd8739ae039;
module.exports["toFormattedTextProps"] = $1ecffae6e6a717dc$export$b9738bf28fb14829;
module.exports["toTextProps"] = $1ecffae6e6a717dc$export$f12aecc78be3c7bb;

});

parcelRegister("kexiH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $0c173ce05ce57544$var$CommentCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(14);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.commentCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== props) {
        t1 = props || {};
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let onRender;
    let restProps;
    if ($[4] !== t1) {
        ({ onRender: onRender, ...restProps } = t1);
        $[4] = t1;
        $[5] = onRender;
        $[6] = restProps;
    } else {
        onRender = $[5];
        restProps = $[6];
    }
    let t2;
    let t3;
    if ($[7] !== data || $[8] !== onRender) {
        t2 = ()=>{
            onRender?.(!!data);
        };
        t3 = [
            data,
            onRender
        ];
        $[7] = data;
        $[8] = onRender;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== data || $[12] !== restProps) {
        t4 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Comment,
            ...data,
            ...restProps,
            name: (0, $5TXU5.ElementName).CommentCount
        }) : null;
        $[11] = data;
        $[12] = restProps;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).CommentCount
    }) : null;
};
var $0c173ce05ce57544$export$2e2bcd8739ae039 = $0c173ce05ce57544$var$CommentCountElement;
module.exports["default"] = $0c173ce05ce57544$export$2e2bcd8739ae039;

});

parcelRegister("1vH0y", function(module, exports) {
/**
 * The enum that describes Smart Link action types
 */ var $01539ca40ed3f421$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $01539ca40ed3f421$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}
module.exports["SmartLinkActionType"] = $01539ca40ed3f421$export$6324b7946ad663e9;
module.exports["InvokeError"] = $01539ca40ed3f421$export$d4d72202bff63658;

});

parcelRegister("jI5eg", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4NlKF = parcelRequire("4NlKF");

const $99638138120cbe3d$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $99638138120cbe3d$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $99638138120cbe3d$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $99638138120cbe3d$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $99638138120cbe3d$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType?.trim();
    if (!trimmed) return undefined;
    if ($99638138120cbe3d$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $99638138120cbe3d$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $99638138120cbe3d$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($99638138120cbe3d$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom


const $b061eed85b2a3300$var$LinkIconElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(17);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $dh538.fg)("platform_navx_smart_link_icon_label_a11y")) {
        let linkIconProps;
        let t0;
        let t1;
        if ($[0] !== context.linkIcon || $[1] !== context.meta?.resourceType || $[2] !== context.type || $[3] !== props.label) {
            t1 = Symbol.for("react.early_return_sentinel");
            bb0: {
                linkIconProps = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
                if (!linkIconProps) {
                    t1 = null;
                    break bb0;
                }
                t0 = (0, $99638138120cbe3d$export$3422b5d26145468d)(context.meta?.resourceType) ?? linkIconProps.label?.trim() ?? props.label;
            }
            $[0] = context.linkIcon;
            $[1] = context.meta?.resourceType;
            $[2] = context.type;
            $[3] = props.label;
            $[4] = linkIconProps;
            $[5] = t0;
            $[6] = t1;
        } else {
            linkIconProps = $[4];
            t0 = $[5];
            t1 = $[6];
        }
        if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
        const label = t0;
        let t2;
        if ($[7] !== label || $[8] !== linkIconProps || $[9] !== props) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
                ...linkIconProps,
                ...props,
                label: label,
                name: (0, $5TXU5.ElementName).LinkIcon
            });
            $[7] = label;
            $[8] = linkIconProps;
            $[9] = props;
            $[10] = t2;
        } else t2 = $[10];
        return t2;
    }
    const t0 = context?.linkIcon;
    let t1;
    if ($[11] !== context.type || $[12] !== t0) {
        t1 = (0, $4NlKF.toLinkIconProps)(t0, context.type);
        $[11] = context.type;
        $[12] = t0;
        $[13] = t1;
    } else t1 = $[13];
    const data = t1;
    let t2;
    if ($[14] !== data || $[15] !== props) {
        t2 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).LinkIcon
        }) : null;
        $[14] = data;
        $[15] = props;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const linkIconProps = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
        if (!linkIconProps) return null;
        const label = (0, $99638138120cbe3d$export$3422b5d26145468d)(context.meta?.resourceType) ?? linkIconProps.label?.trim() ?? props.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
            ...linkIconProps,
            ...props,
            label: label,
            name: (0, $5TXU5.ElementName).LinkIcon
        });
    }
    const data = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NlKF.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LinkIcon
    }) : null;
};
var $b061eed85b2a3300$export$2e2bcd8739ae039 = $b061eed85b2a3300$var$LinkIconElement;
module.exports["default"] = $b061eed85b2a3300$export$2e2bcd8739ae039;

});

parcelRegister("4NlKF", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $i7jPX = parcelRequire("i7jPX");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");


var $b6b6P = parcelRequire("b6b6P");


var $iFRRf = parcelRequire("iFRRf");


var $hJgLA = parcelRequire("hJgLA");

const $5f41eba93c8538ef$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $5f41eba93c8538ef$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $5f41eba93c8538ef$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $5f41eba93c8538ef$var$renderAtlaskitIcon = (icon, testId, size = (0, $5TXU5.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $42omo.createElement((0, $iFRRf.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {
            'aria-hidden': true,
            label: ''
        },
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $5f41eba93c8538ef$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $5f41eba93c8538ef$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $5f41eba93c8538ef$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $5TXU5.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $5f41eba93c8538ef$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $5f41eba93c8538ef$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            label: label
        } : {},
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $5f41eba93c8538ef$var$IconElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: t1, className: className, render: render, size: t2, testId: t3, url: url, appearance: t4, hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon } = t0;
    const position = t1 === undefined ? (0, $5TXU5.SmartLinkPosition).Top : t1;
    const size = t2 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t2;
    const testId = t3 === undefined ? "smart-element-icon" : t3;
    const appearance = t4 === undefined ? "square" : t4;
    const label = (0, $dh538.fg)("platform_navx_smart_link_icon_label_a11y") ? labelProp ?? "" : labelProp ?? "Link";
    let t5;
    if ($[0] !== appearance || $[1] !== hideLoadingSkeleton || $[2] !== icon || $[3] !== isTiledIcon || $[4] !== label || $[5] !== overrideIcon || $[6] !== render || $[7] !== size || $[8] !== testId || $[9] !== url) {
        const defaultIcon = $5f41eba93c8538ef$var$renderDefaultIcon(label, testId);
        t5 = overrideIcon || render?.() || ((0, $dh538.fg)("platform_sl_3p_preauth_better_hovercard_killswitch") ? $5f41eba93c8538ef$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)("platform_navx_smart_link_icon_label_a11y") ? label : undefined, isTiledIcon) : $5f41eba93c8538ef$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)("platform_navx_smart_link_icon_label_a11y") ? label : undefined)) || $5f41eba93c8538ef$var$renderAtlaskitIcon(icon, testId, size, (0, $dh538.fg)("platform_navx_smart_link_icon_label_a11y") ? label : undefined, isTiledIcon) || defaultIcon;
        $[0] = appearance;
        $[1] = hideLoadingSkeleton;
        $[2] = icon;
        $[3] = isTiledIcon;
        $[4] = label;
        $[5] = overrideIcon;
        $[6] = render;
        $[7] = size;
        $[8] = testId;
        $[9] = url;
        $[10] = t5;
    } else t5 = $[10];
    const element = t5;
    let t6;
    if ($[11] !== size) {
        t6 = (0, $hJgLA.getIconWidth)(size);
        $[11] = size;
        $[12] = t6;
    } else t6 = $[12];
    const width = t6;
    const t7 = $5f41eba93c8538ef$var$positionStyleMap[position];
    const t8 = render && $5f41eba93c8538ef$var$customRenderStyleMap[size];
    let t9;
    if ($[13] !== className || $[14] !== t7 || $[15] !== t8) {
        t9 = (0, $gMc0m.default)([
            $5f41eba93c8538ef$var$styles.container,
            t7,
            t8,
            className
        ]);
        $[13] = className;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== element || $[18] !== isTiledIcon || $[19] !== label || $[20] !== size || $[21] !== testId || $[22] !== width) {
        t10 = isTiledIcon ? /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
            size: size,
            hasBorder: true,
            backgroundColor: "white",
            label: label,
            testId: `${testId}-tile`
        }, element) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $5f41eba93c8538ef$var$styles.iconWrapperStyle,
            testId: `${testId}-box`,
            style: {
                width: width,
                height: width
            }
        }, element);
        $[17] = element;
        $[18] = isTiledIcon;
        $[19] = label;
        $[20] = size;
        $[21] = testId;
        $[22] = width;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== name || $[25] !== t10 || $[26] !== t9 || $[27] !== testId) {
        t11 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-smart-element": name,
            "data-smart-element-icon": true,
            "data-testid": testId,
            className: t9
        }, t10);
        $[24] = name;
        $[25] = t10;
        $[26] = t9;
        $[27] = testId;
        $[28] = t11;
    } else t11 = $[28];
    return t11;
} : ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $5TXU5.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? labelProp ?? '' : labelProp ?? 'Link';
    const element = (0, $42omo.useMemo)(()=>{
        const defaultIcon = $5f41eba93c8538ef$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || ((0, $dh538.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $5f41eba93c8538ef$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) : $5f41eba93c8538ef$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined)) || $5f41eba93c8538ef$var$renderAtlaskitIcon(icon, testId, size, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : undefined, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $5f41eba93c8538ef$var$styles.container,
            $5f41eba93c8538ef$var$positionStyleMap[position],
            render && $5f41eba93c8538ef$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $5f41eba93c8538ef$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $5f41eba93c8538ef$export$2e2bcd8739ae039 = $5f41eba93c8538ef$var$IconElement;
const $5f41eba93c8538ef$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $ivUmx.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
module.exports["default"] = $5f41eba93c8538ef$export$2e2bcd8739ae039;
module.exports["toLinkIconProps"] = $5f41eba93c8538ef$export$6d33abd591a3f700;

});

parcelRegister("1WqHG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $eaad8a74af19aa38$var$ModifiedOnElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(14);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $6wR2f.toDateTimeProps)("modified", context.modifiedOn) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== props) {
        t1 = props || {};
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let onRender;
    let restProps;
    if ($[4] !== t1) {
        ({ onRender: onRender, ...restProps } = t1);
        $[4] = t1;
        $[5] = onRender;
        $[6] = restProps;
    } else {
        onRender = $[5];
        restProps = $[6];
    }
    let t2;
    let t3;
    if ($[7] !== data || $[8] !== onRender) {
        t2 = ()=>{
            onRender?.(!!data);
        };
        t3 = [
            data,
            onRender
        ];
        $[7] = data;
        $[8] = onRender;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== data || $[12] !== restProps) {
        t4 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
            ...data,
            ...restProps,
            name: (0, $5TXU5.ElementName).ModifiedOn
        }) : null;
        $[11] = data;
        $[12] = restProps;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ModifiedOn
    }) : null;
};
var $eaad8a74af19aa38$export$2e2bcd8739ae039 = $eaad8a74af19aa38$var$ModifiedOnElement;
module.exports["default"] = $eaad8a74af19aa38$export$2e2bcd8739ae039;

});

parcelRegister("ful5o", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $42f47b467fa462a3$var$OwnedByElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(16);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== props) {
        t0 = props || {};
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let onRender;
    let restProps;
    let t1;
    if ($[2] !== t0) {
        ({ onRender: onRender, textPrefix: t1, ...restProps } = t0);
        $[2] = t0;
        $[3] = onRender;
        $[4] = restProps;
        $[5] = t1;
    } else {
        onRender = $[3];
        restProps = $[4];
        t1 = $[5];
    }
    const textPrefix = t1 === undefined ? "owned_by" : t1;
    let t2;
    if ($[6] !== context || $[7] !== textPrefix) {
        t2 = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages)[textPrefix], context?.ownedBy) : null;
        $[6] = context;
        $[7] = textPrefix;
        $[8] = t2;
    } else t2 = $[8];
    const data = t2;
    let t3;
    let t4;
    if ($[9] !== data || $[10] !== onRender) {
        t3 = ()=>{
            onRender?.(!!data);
        };
        t4 = [
            data,
            onRender
        ];
        $[9] = data;
        $[10] = onRender;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[13] !== data || $[14] !== restProps) {
        t5 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...restProps,
            name: (0, $5TXU5.ElementName).OwnedBy
        }) : null;
        $[13] = data;
        $[14] = restProps;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages)[textPrefix], context?.ownedBy) : null;
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedBy
    }) : null;
};
var $42f47b467fa462a3$export$2e2bcd8739ae039 = $42f47b467fa462a3$var$OwnedByElement;
module.exports["default"] = $42f47b467fa462a3$export$2e2bcd8739ae039;

});

parcelRegister("41AV3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $085ad7f5d3b72529$var$OwnedByGroupElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(14);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9mMJ0.toAvatarGroupProps)(context.ownedByGroup, false) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== props) {
        t1 = props || {};
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let onRender;
    let restProps;
    if ($[4] !== t1) {
        ({ onRender: onRender, ...restProps } = t1);
        $[4] = t1;
        $[5] = onRender;
        $[6] = restProps;
    } else {
        onRender = $[5];
        restProps = $[6];
    }
    let t2;
    let t3;
    if ($[7] !== data || $[8] !== onRender) {
        t2 = ()=>{
            onRender?.(!!data);
        };
        t3 = [
            data,
            onRender
        ];
        $[7] = data;
        $[8] = onRender;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== data || $[12] !== restProps) {
        t4 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
            ...data,
            ...restProps,
            name: (0, $5TXU5.ElementName).OwnedByGroup
        }) : null;
        $[11] = data;
        $[12] = restProps;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).OwnedByGroup
    }) : null;
};
var $085ad7f5d3b72529$export$2e2bcd8739ae039 = $085ad7f5d3b72529$var$OwnedByGroupElement;
module.exports["default"] = $085ad7f5d3b72529$export$2e2bcd8739ae039;

});

parcelRegister("iuEuh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5efcddd7e05f410f$var$ReactCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(14);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.reactCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== props) {
        t1 = props || {};
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let onRender;
    let restProps;
    if ($[4] !== t1) {
        ({ onRender: onRender, ...restProps } = t1);
        $[4] = t1;
        $[5] = onRender;
        $[6] = restProps;
    } else {
        onRender = $[5];
        restProps = $[6];
    }
    let t2;
    let t3;
    if ($[7] !== data || $[8] !== onRender) {
        t2 = ()=>{
            onRender?.(!!data);
        };
        t3 = [
            data,
            onRender
        ];
        $[7] = data;
        $[8] = onRender;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== data || $[12] !== restProps) {
        t4 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).React,
            ...data,
            ...restProps,
            name: (0, $5TXU5.ElementName).ReactCount
        }) : null;
        $[11] = data;
        $[12] = restProps;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $42omo.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5TXU5.ElementName).ReactCount
    }) : null;
};
var $5efcddd7e05f410f$export$2e2bcd8739ae039 = $5efcddd7e05f410f$var$ReactCountElement;
module.exports["default"] = $5efcddd7e05f410f$export$2e2bcd8739ae039;

});

parcelRegister("gHW9t", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $b6969367f8b7bc15$var$TitleElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    let t0;
    if ($[0] !== data || $[1] !== props) {
        t0 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).Title
        }) : null;
        $[0] = data;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Title
    }) : null;
};
var $b6969367f8b7bc15$export$2e2bcd8739ae039 = $b6969367f8b7bc15$var$TitleElement;
module.exports["default"] = $b6969367f8b7bc15$export$2e2bcd8739ae039;

});

parcelRegister("1RvsP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $16630f477b2fdaf3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $16630f477b2fdaf3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $16630f477b2fdaf3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $16630f477b2fdaf3$var$baseStyles = null;
const $16630f477b2fdaf3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $16630f477b2fdaf3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $16630f477b2fdaf3$var$horizontalStyleBase = null;
const $16630f477b2fdaf3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $16630f477b2fdaf3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $16630f477b2fdaf3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $16630f477b2fdaf3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $16630f477b2fdaf3$var$ElementGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { align: t1, children: children, direction: t2, size: t3, testId: t4, width: t5, position: t6, className: className } = t0;
    const align = t1 === undefined ? (0, $5TXU5.SmartLinkAlignment).Left : t1;
    const direction = t2 === undefined ? (0, $5TXU5.SmartLinkDirection).Horizontal : t2;
    const size = t3 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t3;
    const testId = t4 === undefined ? "smart-element-group" : t4;
    const width = t5 === undefined ? (0, $5TXU5.SmartLinkWidth).FitToContent : t5;
    const position = t6 === undefined ? (0, $5TXU5.SmartLinkPosition).Center : t6;
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    const t7 = $16630f477b2fdaf3$var$baseStyleBySize[size];
    const t8 = $16630f477b2fdaf3$var$baseStyleByDirection[direction];
    const t9 = $16630f477b2fdaf3$var$alignmentStyleMap[align];
    const t10 = $16630f477b2fdaf3$var$widthStyle[width];
    const t11 = isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9";
    const t12 = isHorizontal && $16630f477b2fdaf3$var$horizontalStyleByHeight[size];
    const t13 = isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size];
    const t14 = isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size];
    const t15 = $16630f477b2fdaf3$var$positionStyle[position];
    let t16;
    if ($[0] !== className || $[1] !== t10 || $[2] !== t11 || $[3] !== t12 || $[4] !== t13 || $[5] !== t14 || $[6] !== t15 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t16 = (0, $gMc0m.default)([
            t7,
            t8,
            "_fiawglyw",
            t9,
            "_1ul99by0",
            t10,
            t11,
            t12,
            t13,
            t14,
            t15,
            className
        ]);
        $[0] = className;
        $[1] = t10;
        $[2] = t11;
        $[3] = t12;
        $[4] = t13;
        $[5] = t14;
        $[6] = t15;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t16;
    } else t16 = $[10];
    let t17;
    if ($[11] !== children || $[12] !== size) {
        t17 = (0, $l7DP7.renderChildren)(children, size);
        $[11] = children;
        $[12] = size;
        $[13] = t17;
    } else t17 = $[13];
    let t18;
    if ($[14] !== t16 || $[15] !== t17 || $[16] !== testId) {
        t18 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-smart-element-group": true,
            "data-testid": testId,
            className: t16
        }, t17);
        $[14] = t16;
        $[15] = t17;
        $[16] = testId;
        $[17] = t18;
    } else t18 = $[17];
    return t18;
} : ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5TXU5.SmartLinkWidth).FitToContent, position: position = (0, $5TXU5.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $16630f477b2fdaf3$var$baseStyleBySize[size],
            $16630f477b2fdaf3$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $16630f477b2fdaf3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $16630f477b2fdaf3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $16630f477b2fdaf3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size],
            $16630f477b2fdaf3$var$positionStyle[position],
            className
        ])
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $16630f477b2fdaf3$export$2e2bcd8739ae039 = $16630f477b2fdaf3$var$ElementGroup;
module.exports["default"] = $16630f477b2fdaf3$export$2e2bcd8739ae039;

});

parcelRegister("bRnvt", function(module, exports) {

let $8a26e0dc99c728f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a26e0dc99c728f8$var$load("6wr18"),
    $8a26e0dc99c728f8$var$load("ffEVr"),
    $8a26e0dc99c728f8$var$load("3wY4G")
]).then(()=>parcelRequire('7EiCp'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9RQQm", function(module, exports) {

let $72f20de99433ea06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72f20de99433ea06$var$load("6wr18"),
    $72f20de99433ea06$var$load("ffEVr"),
    $72f20de99433ea06$var$load("88r9N")
]).then(()=>parcelRequire('lwRK9'));

});

parcelRegister("lVA2Y", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $a1261186af9b2859$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $a1261186af9b2859$var$UnresolvedAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { testId: t1, hasPadding: t2 } = t0;
    const testId = t1 === undefined ? "unresolved-action" : t1;
    const hasPadding = t2 === undefined ? false : t2;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const t3 = `${testId}-errored-view-message`;
    const t4 = hasAction ? 0 : undefined;
    const t5 = hasPadding && $a1261186af9b2859$var$styles.padding;
    let t6;
    if ($[0] !== t5) {
        t6 = (0, $1Whri.cx)($a1261186af9b2859$var$styles.message, t5);
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    let t7;
    if ($[2] !== descriptor || $[3] !== values) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...descriptor,
            values: values
        });
        $[2] = descriptor;
        $[3] = values;
        $[4] = t7;
    } else t7 = $[4];
    let t8;
    if ($[5] !== t3 || $[6] !== t4 || $[7] !== t6 || $[8] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: t3,
            tabIndex: t4,
            xcss: t6
        }, t7);
        $[5] = t3;
        $[6] = t4;
        $[7] = t6;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    const message = t8;
    let t9;
    if ($[10] !== data.onClick || $[11] !== hasAction || $[12] !== message) {
        t9 = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            onClick: data.onClick,
            style: {
                color: "inherit",
                font: "inherit",
                textAlign: "inherit"
            },
            xcss: $a1261186af9b2859$var$styles.button
        }, message) : message;
        $[10] = data.onClick;
        $[11] = hasAction;
        $[12] = message;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $1Whri.cx)($a1261186af9b2859$var$styles.message, hasPadding && $a1261186af9b2859$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $a1261186af9b2859$var$styles.button
    }, message) : message;
};
var $a1261186af9b2859$export$2e2bcd8739ae039 = $a1261186af9b2859$var$UnresolvedAction;
module.exports["default"] = $a1261186af9b2859$export$2e2bcd8739ae039;

});

parcelRegister("6KV13", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a1WXB = parcelRequire("a1WXB");


var $kKODE = parcelRequire("kKODE");


var $bIll3 = parcelRequire("bIll3");


var $lz9QA = parcelRequire("lz9QA");











var $aXWIB = parcelRequire("aXWIB");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $dDhJe = parcelRequire("dDhJe");

const $80037b55255ba382$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $80037b55255ba382$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $80037b55255ba382$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $80037b55255ba382$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $80037b55255ba382$export$ff2962de2b2c930f = (product)=>{
    if ($80037b55255ba382$var$isJiraProduct(product)) return $80037b55255ba382$var$AiMateJiraXProduct[product];
    return product;
};


async function* $ac7ab9469e66450d$export$e45226161c660403(response) {
    const reader = (0, $80037b55255ba382$export$f6383c3ea1307da9)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}


class $518e18325393707f$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $518e18325393707f$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];



const $b962d377d695bb74$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $b962d377d695bb74$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $518e18325393707f$export$fcec967a4b7ebd84)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $518e18325393707f$export$fcec967a4b7ebd84) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
                return (0, $80037b55255ba382$export$4c25481b843feb0b)(baseUrl, $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
            }
            return (0, $80037b55255ba382$export$4c25481b843feb0b)('/gateway/api/', $b962d377d695bb74$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $ac7ab9469e66450d$export$e45226161c660403)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $80037b55255ba382$export$ff2962de2b2c930f)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}



var $9trs7 = parcelRequire("9trs7");

const $ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE = 100;
const $ae7dbc37116e63f9$export$6979339b6d41707e = new (0, $9trs7.LRUMap)($ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE);


const $78ebc629fd62f804$export$becd8f2eba1bbd96 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(18);
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    let t0;
    if ($[0] !== url) {
        t0 = (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.state || {
            status: "ready",
            content: ""
        };
        $[0] = url;
        $[1] = t0;
    } else t0 = $[1];
    const [state, setState] = (0, $42omo.useState)(t0);
    const { locale: locale } = (0, $aXWIB.useIntl)();
    let t1;
    let t2;
    if ($[2] !== ari || $[3] !== baseUrl || $[4] !== envKey || $[5] !== locale || $[6] !== onError || $[7] !== onStart || $[8] !== onSuccess || $[9] !== product || $[10] !== url) {
        t1 = ()=>{
            if (url && !(0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)) (0, $ae7dbc37116e63f9$export$6979339b6d41707e).set(url, new (0, $b962d377d695bb74$export$73e4b807d5bd74b6)({
                url: url,
                ari: ari,
                baseUrl: baseUrl,
                product: product,
                envKey: envKey,
                locale: locale,
                onError: onError,
                onStart: onStart,
                onSuccess: onSuccess
            }));
            return (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.subscribe(setState);
        };
        t2 = [
            url,
            baseUrl,
            onError,
            onStart,
            onSuccess,
            product,
            ari,
            envKey,
            locale
        ];
        $[2] = ari;
        $[3] = baseUrl;
        $[4] = envKey;
        $[5] = locale;
        $[6] = onError;
        $[7] = onStart;
        $[8] = onSuccess;
        $[9] = product;
        $[10] = url;
        $[11] = t1;
        $[12] = t2;
    } else {
        t1 = $[11];
        t2 = $[12];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[13] !== url) {
        t3 = ()=>(0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.summariseUrl();
        $[13] = url;
        $[14] = t3;
    } else t3 = $[14];
    const summariseUrl = t3;
    let t4;
    if ($[15] !== state || $[16] !== summariseUrl) {
        t4 = {
            summariseUrl: summariseUrl,
            state: state
        };
        $[15] = state;
        $[16] = summariseUrl;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $42omo.useState)((0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)) (0, $ae7dbc37116e63f9$export$6979339b6d41707e).set(url, new (0, $b962d377d695bb74$export$73e4b807d5bd74b6)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $ae7dbc37116e63f9$export$6979339b6d41707e).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};



var $i8IAc = parcelRequire("i8IAc");

const $c75904359bba5163$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $c75904359bba5163$var$useAISummaryAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (url)=>{
    const $ = (0, $frIzR.c)(16);
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    let t0;
    if ($[0] !== data) {
        t0 = data && (0, $a1WXB.extractAri)(data);
        $[0] = data;
        $[1] = t0;
    } else t0 = $[1];
    const ari = t0;
    let t1;
    if ($[2] !== data) {
        t1 = data && (0, $a1WXB.extractLink)(data) || "";
        $[2] = data;
        $[3] = t1;
    } else t1 = $[3];
    const dataUrl = t1;
    const onStart = $c75904359bba5163$var$_temp;
    let t2;
    if ($[4] !== fireEvent) {
        t2 = (id_0)=>{
            fireEvent("operational.summary.success", {});
            (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id_0);
        };
        $[4] = fireEvent;
        $[5] = t2;
    } else t2 = $[5];
    const onSuccess = t2;
    let t3;
    if ($[6] !== fireEvent) {
        t3 = (id_1, reason)=>{
            const isSloError = reason === undefined ? true : ![
                "ACCEPTABLE_USE_VIOLATIONS",
                "HIPAA_CONTENT_DETECTED",
                "EXCEEDING_CONTEXT_LENGTH_ERROR"
            ].includes(reason);
            fireEvent("operational.summary.failed", {
                reason: reason || null,
                isSloError: isSloError
            });
            (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id_1);
        };
        $[6] = fireEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onError = t3;
    let t4;
    if ($[8] !== ari || $[9] !== baseUrl || $[10] !== dataUrl || $[11] !== envKey || $[12] !== onError || $[13] !== onSuccess || $[14] !== product) {
        t4 = {
            url: dataUrl,
            ari: ari,
            product: product,
            envKey: envKey,
            baseUrl: baseUrl,
            onStart: onStart,
            onSuccess: onSuccess,
            onError: onError
        };
        $[8] = ari;
        $[9] = baseUrl;
        $[10] = dataUrl;
        $[11] = envKey;
        $[12] = onError;
        $[13] = onSuccess;
        $[14] = product;
        $[15] = t4;
    } else t4 = $[15];
    return (0, $78ebc629fd62f804$export$becd8f2eba1bbd96)(t4);
} : (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $a1WXB.extractAri)(data);
    const dataUrl = data && (0, $a1WXB.extractLink)(data) || '';
    const onStart = (0, $42omo.useCallback)((id)=>{
        (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $42omo.useCallback)((id_0)=>{
        fireEvent('operational.summary.success', {});
        (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id_0);
    }, [
        fireEvent
    ]);
    const onError = (0, $42omo.useCallback)((id_1, reason)=>{
        /**
     * Errors should only be counted to the SLO if they are not due to acceptable use violations
     * HIPAA content detected or exceeding context length.
     */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id_1);
    }, [
        fireEvent
    ]);
    return (0, $78ebc629fd62f804$export$becd8f2eba1bbd96)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $c75904359bba5163$export$2e2bcd8739ae039 = $c75904359bba5163$var$useAISummaryAction;
function $c75904359bba5163$var$_temp(id) {
    (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
}
module.exports["default"] = $c75904359bba5163$export$2e2bcd8739ae039;

});

parcelRegister("i8IAc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $524481383d1e73c2$export$4480af2c00aa7ebe = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    const t0 = connections.client.envKey;
    let t1;
    if ($[0] !== connections.client.baseUrlOverride || $[1] !== isAdminHubAIEnabled || $[2] !== product || $[3] !== t0) {
        t1 = {
            baseUrl: connections.client.baseUrlOverride,
            envKey: t0,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        };
        $[0] = connections.client.baseUrlOverride;
        $[1] = isAdminHubAIEnabled;
        $[2] = product;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};
module.exports["useAISummaryConfig"] = $524481383d1e73c2$export$4480af2c00aa7ebe;

});

parcelRegister("kbh18", function(module, exports) {

var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");

const $681e47ebaeddecd0$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $681e47ebaeddecd0$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $afp1H.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5TXU5.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $afp1H.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $afp1H.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $afp1H.messages).ai_summary_error_generic_rebrand,
                url: (0, $5TXU5.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};
module.exports["getIsAISummaryEnabled"] = $681e47ebaeddecd0$export$d439c74cb206ff29;
module.exports["getAISummaryErrorMessage"] = $681e47ebaeddecd0$export$cd2e891d7f87074d;

});

parcelRegister("3eMTN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");











var $gdv5Z = parcelRequire("gdv5Z");

const $67004d95b34ee986$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $67004d95b34ee986$export$3e100bc08448f36c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    const onClick = $67004d95b34ee986$var$_temp;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            role: "none",
            xcss: $67004d95b34ee986$var$styles.wrapper,
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        role: "none",
        xcss: $67004d95b34ee986$var$styles.wrapper,
        onClick: onClick
    }, children);
};
function $67004d95b34ee986$var$_temp(e) {
    e.stopPropagation();
}


const $a2cc1d898ee1f610$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a2cc1d898ee1f610$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($a2cc1d898ee1f610$var$FALLBACK_API);
const $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children } = t0;
    const [element, setElement] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67004d95b34ee986$export$3e100bc08448f36c), null, modal))),
            close: ()=>setElement(null)
        };
        $[0] = t1;
    } else t1 = $[0];
    const api = t1;
    const fallbackRender = $a2cc1d898ee1f610$var$_temp;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setElement(null);
        $[1] = t2;
    } else t2 = $[1];
    const onReset = t2;
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
            value: api
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== element) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            fallbackRender: fallbackRender,
            onReset: onReset
        }, element);
        $[4] = element;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children })=>{
    const [element, setElement] = (0, $42omo.useState)(null);
    const api = (0, $42omo.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67004d95b34ee986$export$3e100bc08448f36c), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $42omo.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $42omo.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);
} : ()=>(0, $42omo.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);
function $a2cc1d898ee1f610$var$_temp(t0) {
    const { resetErrorBoundary: resetErrorBoundary } = t0;
    resetErrorBoundary();
    return null;
}
module.exports["SmartLinkModalProvider"] = $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8;
module.exports["useSmartLinkModal"] = $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8;

});

parcelRegister("cQF6P", function(module, exports) {

let $95aa3ac3c9e02f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95aa3ac3c9e02f57$var$load("6wr18"),
    $95aa3ac3c9e02f57$var$load("ffEVr"),
    $95aa3ac3c9e02f57$var$load("g4qer"),
    $95aa3ac3c9e02f57$var$load("kHOMt"),
    $95aa3ac3c9e02f57$var$load("hhss7"),
    $95aa3ac3c9e02f57$var$load("Wowvf"),
    $95aa3ac3c9e02f57$var$load("1F7LX"),
    $95aa3ac3c9e02f57$var$load("7EorR"),
    $95aa3ac3c9e02f57$var$load("cqZpg")
]).then(()=>parcelRequire('iWqmE'));

});

parcelRegister("kNkkl", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h982G = parcelRequire("h982G");


var $kCsup = parcelRequire("kCsup");


var $l17Fn = parcelRequire("l17Fn");

const $5b3a995bb43373af$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $5b3a995bb43373af$var$useRovoChat = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const { rovoOptions: config } = (0, $l17Fn.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $h982G.useRovoPostMessageToPubsub)();
    let t0;
    if ($[0] !== config) {
        t0 = (0, $kCsup.getIsRovoChatEnabled)(config);
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const isRovoChatEnabled = t0;
    let t1;
    if ($[2] !== publishWithPostMessage) {
        t1 = (data)=>{
            publishWithPostMessage({
                targetWindow: window.parent ?? window,
                payload: {
                    type: "chat-new",
                    source: $5b3a995bb43373af$var$SMART_LINK_TO_ROVO_SOURCE,
                    data: {
                        dialogues: [],
                        ...data,
                        agentId: undefined
                    },
                    openChat: true,
                    openChatMode: "sidebar"
                },
                onAcknowledgeTimeout: $5b3a995bb43373af$var$_temp
            });
        };
        $[2] = publishWithPostMessage;
        $[3] = t1;
    } else t1 = $[3];
    const sendPromptMessage = t1;
    let t2;
    if ($[4] !== isRovoChatEnabled || $[5] !== sendPromptMessage) {
        t2 = {
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        };
        $[4] = isRovoChatEnabled;
        $[5] = sendPromptMessage;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { rovoOptions: config } = (0, $l17Fn.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $h982G.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $kCsup.getIsRovoChatEnabled)(config);
    const sendPromptMessage = (0, $42omo.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $5b3a995bb43373af$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage
    ]);
    return (0, $42omo.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $5b3a995bb43373af$export$2e2bcd8739ae039 = $5b3a995bb43373af$var$useRovoChat;
function $5b3a995bb43373af$var$_temp() {}
module.exports["default"] = $5b3a995bb43373af$export$2e2bcd8739ae039;

});

parcelRegister("aPH2w", function(module, exports) {

let $7e300d9a577ef1a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e300d9a577ef1a9$var$load("hnGEQ"),
    $7e300d9a577ef1a9$var$load("gyh6H"),
    $7e300d9a577ef1a9$var$load("hhss7"),
    $7e300d9a577ef1a9$var$load("1F7LX"),
    $7e300d9a577ef1a9$var$load("aoU9B")
]).then(()=>parcelRequire('a6OFr'));

});

parcelRegister("2R1C4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $l7DP7 = parcelRequire("l7DP7");

const $1ab21bb04b9ccb77$var$baseBlockStyles = null;
const $1ab21bb04b9ccb77$var$highlightRemoveStyles = null;
const $1ab21bb04b9ccb77$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $1ab21bb04b9ccb77$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $1ab21bb04b9ccb77$var$Block = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { children: children, direction: t1, size: t2, testId: t3, className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId } = t0;
    const direction = t1 === undefined ? (0, $5TXU5.SmartLinkDirection).Horizontal : t1;
    const size = t2 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t2;
    const testId = t3 === undefined ? "smart-block" : t3;
    let t4;
    let t5;
    if ($[0] !== onRender) {
        t4 = ()=>{
            onRender && onRender();
        };
        t5 = [
            onRender
        ];
        $[0] = onRender;
        $[1] = t4;
        $[2] = t5;
    } else {
        t4 = $[1];
        t5 = $[2];
    }
    (0, $42omo.useEffect)(t4, t5);
    const t6 = $1ab21bb04b9ccb77$var$directionStyles[direction];
    const t7 = $1ab21bb04b9ccb77$var$gapStyles[size];
    let t8;
    if ($[3] !== className || $[4] !== t6 || $[5] !== t7) {
        t8 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            t6,
            t7,
            className
        ]);
        $[3] = className;
        $[4] = t6;
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children || $[8] !== size) {
        t9 = (0, $l7DP7.renderChildren)(children, size);
        $[7] = children;
        $[8] = size;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== blockRef || $[11] !== onTransitionEnd || $[12] !== placeholderId || $[13] !== style || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t10 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t8,
            "data-smart-block": true,
            "data-testid": testId,
            onTransitionEnd: onTransitionEnd,
            ref: blockRef,
            style: style,
            "data-ssr-placeholder": placeholderId,
            "data-ssr-placeholder-replace": placeholderId
        }, t9);
        $[10] = blockRef;
        $[11] = onTransitionEnd;
        $[12] = placeholderId;
        $[13] = style;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $42omo.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $1ab21bb04b9ccb77$var$directionStyles[direction],
            $1ab21bb04b9ccb77$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $l7DP7.renderChildren)(children, size));
};
var $1ab21bb04b9ccb77$export$2e2bcd8739ae039 = $1ab21bb04b9ccb77$var$Block;
module.exports["default"] = $1ab21bb04b9ccb77$export$2e2bcd8739ae039;

});

parcelRegister("1lLfV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");

const $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES = 1;
const $8e07cec8e3b2cb3b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $8e07cec8e3b2cb3b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $8e07cec8e3b2cb3b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES;
    if (maxLines < $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $8e07cec8e3b2cb3b$var$ElementItemRenderer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { align: t1, items: t2, display: t3, size: t4, maxLines: t5 } = t0;
    const align = t1 === undefined ? (0, $5TXU5.SmartLinkAlignment).Left : t1;
    let t6;
    if ($[0] !== t2) {
        t6 = t2 === undefined ? [] : t2;
        $[0] = t2;
        $[1] = t6;
    } else t6 = $[1];
    const items = t6;
    const display = t3 === undefined ? "inline" : t3;
    const size = t4 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t4;
    const maxLines = t5 === undefined ? $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES : t5;
    let t7;
    if ($[2] !== display || $[3] !== items) {
        t7 = (0, $l7DP7.renderElementItems)(items, display);
        $[2] = display;
        $[3] = items;
        $[4] = t7;
    } else t7 = $[4];
    const elements = t7;
    let t8;
    if ($[5] !== align || $[6] !== elements || $[7] !== maxLines || $[8] !== size) {
        t8 = elements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
            align: align,
            direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
            width: (0, $5TXU5.SmartLinkWidth).Flexible,
            size: size,
            className: (0, $gMc0m.default)([
                $8e07cec8e3b2cb3b$var$truncateStyles[maxLines],
                $8e07cec8e3b2cb3b$var$sizeStyles[size]
            ])
        }, elements);
        $[5] = align;
        $[6] = elements;
        $[7] = maxLines;
        $[8] = size;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5TXU5.SmartLinkSize).Medium, maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $l7DP7.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        align: align,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $gMc0m.default)([
            $8e07cec8e3b2cb3b$var$truncateStyles[maxLines],
            $8e07cec8e3b2cb3b$var$sizeStyles[size]
        ])
    }, elements);
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $8e07cec8e3b2cb3b$var$MetadataBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    let blockProps;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== t0) {
        ({ maxLines: t1, testId: t2, primary: t3, secondary: t4, ...blockProps } = t0);
        $[0] = t0;
        $[1] = blockProps;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else {
        blockProps = $[1];
        t1 = $[2];
        t2 = $[3];
        t3 = $[4];
        t4 = $[5];
    }
    const maxLines = t1 === undefined ? $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES : t1;
    const testId = t2 === undefined ? "smart-block-metadata" : t2;
    let t5;
    if ($[6] !== t3) {
        t5 = t3 === undefined ? [] : t3;
        $[6] = t3;
        $[7] = t5;
    } else t5 = $[7];
    const primary = t5;
    let t6;
    if ($[8] !== t4) {
        t6 = t4 === undefined ? [] : t4;
        $[8] = t4;
        $[9] = t6;
    } else t6 = $[9];
    const secondary = t6;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5TXU5.SmartLinkSize).Medium;
    let t7;
    if ($[10] !== maxLines) {
        t7 = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
        $[10] = maxLines;
        $[11] = t7;
    } else t7 = $[11];
    const maxLinesTotal = t7;
    const t8 = `${testId}-resolved-view`;
    let t9;
    if ($[12] !== maxLinesTotal || $[13] !== primary || $[14] !== size) {
        t9 = /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
            items: primary,
            size: size,
            maxLines: maxLinesTotal
        });
        $[12] = maxLinesTotal;
        $[13] = primary;
        $[14] = size;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== maxLinesTotal || $[17] !== secondary || $[18] !== size) {
        t10 = /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
            align: (0, $5TXU5.SmartLinkAlignment).Right,
            items: secondary,
            size: size,
            maxLines: maxLinesTotal
        });
        $[16] = maxLinesTotal;
        $[17] = secondary;
        $[18] = size;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== blockProps || $[21] !== size || $[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
            ...blockProps,
            size: size,
            testId: t8
        }, t9, t10);
        $[20] = blockProps;
        $[21] = size;
        $[22] = t10;
        $[23] = t8;
        $[24] = t9;
        $[25] = t11;
    } else t11 = $[25];
    return t11;
} : ({ maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5TXU5.SmartLinkSize).Medium;
    const maxLinesTotal = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $42omo.createElement($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};
var $8e07cec8e3b2cb3b$export$2e2bcd8739ae039 = $8e07cec8e3b2cb3b$var$MetadataBlock;
module.exports["default"] = $8e07cec8e3b2cb3b$export$2e2bcd8739ae039;

});

parcelRegister("Y5kOr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");











var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ikM9T = parcelRequire("ikM9T");


var $2R1C4 = parcelRequire("2R1C4");

const $2fe31e0809d9677b$var$previewBlockStyleCommon = null;
const $2fe31e0809d9677b$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $2fe31e0809d9677b$var$PreviewBlockResolvedView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    let blockProps;
    let className;
    let onError;
    let overrideUrl;
    let placement;
    let style;
    let t1;
    let testId;
    if ($[0] !== t0) {
        ({ ignoreContainerPadding: t1, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps } = t0);
        $[0] = t0;
        $[1] = blockProps;
        $[2] = className;
        $[3] = onError;
        $[4] = overrideUrl;
        $[5] = placement;
        $[6] = style;
        $[7] = t1;
        $[8] = testId;
    } else {
        blockProps = $[1];
        className = $[2];
        onError = $[3];
        overrideUrl = $[4];
        placement = $[5];
        style = $[6];
        t1 = $[7];
        testId = $[8];
    }
    const ignoreContainerPadding = t1 === undefined ? false : t1;
    let t2;
    if ($[9] !== ignoreContainerPadding || $[10] !== placement || $[11] !== style) {
        t2 = ()=>{
            if ((0, $dh538.fg)("dfo-fix-preview-dynamic-style")) {
                if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
                    const containerPadding = ignoreContainerPadding ? "0px" : "var(--container-padding)";
                    const newStyle = {
                        ...style,
                        position: "absolute",
                        top: containerPadding,
                        bottom: containerPadding,
                        width: `calc(var(--preview-block-width) - ${containerPadding})`,
                        ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                            left: containerPadding
                        } : {},
                        ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                            right: containerPadding
                        } : {}
                    };
                    return newStyle;
                }
            }
            return style ?? {};
        };
        $[9] = ignoreContainerPadding;
        $[10] = placement;
        $[11] = style;
        $[12] = t2;
    } else t2 = $[12];
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)(t2);
    let t3;
    if ($[13] !== ignoreContainerPadding || $[14] !== placement || $[15] !== style) {
        t3 = ()=>{
            if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
                const containerPadding_0 = ignoreContainerPadding ? "0px" : "var(--container-padding)";
                const newStyle_0 = {
                    ...style,
                    position: "absolute",
                    top: containerPadding_0,
                    bottom: containerPadding_0,
                    width: `calc(var(--preview-block-width) - ${containerPadding_0})`,
                    ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                        left: containerPadding_0
                    } : {},
                    ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                        right: containerPadding_0
                    } : {}
                };
                setDynamicStyles(newStyle_0);
            } else if (ignoreContainerPadding) setDynamicStyles({
                ...style
            });
        };
        $[13] = ignoreContainerPadding;
        $[14] = placement;
        $[15] = style;
        $[16] = t3;
    } else t3 = $[16];
    const updateStyles = t3;
    let t4;
    if ($[17] !== updateStyles) {
        t4 = ()=>{
            updateStyles();
        };
        $[17] = updateStyles;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== className || $[20] !== ignoreContainerPadding || $[21] !== placement || $[22] !== updateStyles) {
        t5 = [
            ignoreContainerPadding,
            placement,
            updateStyles,
            className
        ];
        $[19] = className;
        $[20] = ignoreContainerPadding;
        $[21] = placement;
        $[22] = updateStyles;
        $[23] = t5;
    } else t5 = $[23];
    (0, $42omo.useLayoutEffect)(t4, t5);
    let t6;
    if ($[24] !== updateStyles) {
        t6 = ()=>{
            updateStyles();
        };
        $[24] = updateStyles;
        $[25] = t6;
    } else t6 = $[25];
    const handleOnLoad = t6;
    let t7;
    if ($[26] !== onError) {
        t7 = ()=>{
            if (onError) onError();
        };
        $[26] = onError;
        $[27] = t7;
    } else t7 = $[27];
    const handleOnError = t7;
    const t8 = `${testId}-resolved-view`;
    const t9 = placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr";
    const t10 = !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9";
    let t11;
    if ($[28] !== className || $[29] !== t10 || $[30] !== t9) {
        t11 = (0, $gMc0m.default)([
            t9,
            t10,
            className
        ]);
        $[28] = className;
        $[29] = t10;
        $[30] = t9;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== handleOnError || $[33] !== handleOnLoad || $[34] !== overrideUrl) {
        t12 = /*#__PURE__*/ $42omo.createElement((0, $ikM9T.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        });
        $[32] = handleOnError;
        $[33] = handleOnLoad;
        $[34] = overrideUrl;
        $[35] = t12;
    } else t12 = $[35];
    let t13;
    if ($[36] !== blockProps || $[37] !== dynamicStyles || $[38] !== t11 || $[39] !== t12 || $[40] !== t8) {
        t13 = /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
            ...blockProps,
            testId: t8,
            style: dynamicStyles,
            className: t11
        }, t12);
        $[36] = blockProps;
        $[37] = dynamicStyles;
        $[38] = t11;
        $[39] = t12;
        $[40] = t8;
        $[41] = t13;
    } else t13 = $[41];
    return t13;
} : ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)(()=>{
        if ((0, $dh538.fg)('dfo-fix-preview-dynamic-style')) {
            if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
                const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
                const newStyle = {
                    ...style,
                    position: 'absolute',
                    top: containerPadding,
                    bottom: containerPadding,
                    width: `calc(var(--preview-block-width) - ${containerPadding})`,
                    ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                        left: containerPadding
                    } : {},
                    ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                        right: containerPadding
                    } : {}
                };
                return newStyle;
            }
        }
        return style ?? {};
    });
    const updateStyles = (0, $42omo.useCallback)(()=>{
        if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
            const containerPadding_0 = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle_0 = {
                ...style,
                position: 'absolute',
                top: containerPadding_0,
                bottom: containerPadding_0,
                width: `calc(var(--preview-block-width) - ${containerPadding_0})`,
                ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                    left: containerPadding_0
                } : {},
                ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                    right: containerPadding_0
                } : {}
            };
            setDynamicStyles(newStyle_0);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $42omo.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $42omo.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $42omo.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $gMc0m.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ikM9T.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $2fe31e0809d9677b$export$2e2bcd8739ae039 = $2fe31e0809d9677b$var$PreviewBlockResolvedView;


/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $3da662f4fc394f2e$var$PreviewBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let blockProps;
    let overrideUrl;
    let t1;
    if ($[0] !== t0) {
        ({ testId: t1, overrideUrl: overrideUrl, ...blockProps } = t0);
        $[0] = t0;
        $[1] = blockProps;
        $[2] = overrideUrl;
        $[3] = t1;
    } else {
        blockProps = $[1];
        overrideUrl = $[2];
        t1 = $[3];
    }
    const testId = t1 === undefined ? "smart-block-preview" : t1;
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const t2 = blockProps.size ?? ui?.size;
    let t3;
    if ($[4] !== blockProps || $[5] !== overrideUrl || $[6] !== t2 || $[7] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fe31e0809d9677b$export$2e2bcd8739ae039), {
            ...blockProps,
            size: t2,
            testId: testId,
            overrideUrl: overrideUrl
        });
        $[4] = blockProps;
        $[5] = overrideUrl;
        $[6] = t2;
        $[7] = testId;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fe31e0809d9677b$export$2e2bcd8739ae039), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $3da662f4fc394f2e$export$2e2bcd8739ae039 = $3da662f4fc394f2e$var$PreviewBlock;
module.exports["default"] = $3da662f4fc394f2e$export$2e2bcd8739ae039;

});

parcelRegister("8zS2j", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $4QzTV = parcelRequire("4QzTV");


var $49WiA = parcelRequire("49WiA");


var $hJgLA = parcelRequire("hJgLA");


var $2R1C4 = parcelRequire("2R1C4");

const $60c86a1fbc149797$var$DEFAULT_MAX_LINES = 3;
const $60c86a1fbc149797$var$MAXIMUM_MAX_LINES = 6;
const $60c86a1fbc149797$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $60c86a1fbc149797$var$SnippetBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(33);
    let blockProps;
    let t1;
    let t2;
    let t3;
    let t4;
    let text;
    if ($[0] !== t0) {
        ({ maxLines: t1, testId: t2, text: text, isHidden: t3, showFooter: t4, ...blockProps } = t0);
        $[0] = t0;
        $[1] = blockProps;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = text;
    } else {
        blockProps = $[1];
        t1 = $[2];
        t2 = $[3];
        t3 = $[4];
        t4 = $[5];
        text = $[6];
    }
    const maxLines = t1 === undefined ? $60c86a1fbc149797$var$DEFAULT_MAX_LINES : t1;
    const testId = t2 === undefined ? "smart-block-snippet" : t2;
    const isHidden = t3 === undefined ? false : t3;
    const showFooter = t4 === undefined ? true : t4;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $fUfR2.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    let t5;
    if ($[7] !== maxLines) {
        t5 = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
        $[7] = maxLines;
        $[8] = t5;
    } else t5 = $[8];
    const snippetMaxLines = t5;
    const statusTestId = !text ? "resolved" : "non-resolved";
    let t6;
    if ($[9] !== snippetMaxLines || $[10] !== text) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
            maxLines: snippetMaxLines,
            content: text
        });
        $[9] = snippetMaxLines;
        $[10] = text;
        $[11] = t6;
    } else t6 = $[11];
    const snippet = t6;
    if (!enableSnippetRenderer) {
        const t7 = blockProps.size ?? cardContext?.ui?.size;
        const t8 = `${testId}-${statusTestId}-view`;
        let t9;
        if ($[12] !== blockProps || $[13] !== snippet || $[14] !== t7 || $[15] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
                ...blockProps,
                size: t7,
                testId: t8
            }, snippet);
            $[12] = blockProps;
            $[13] = snippet;
            $[14] = t7;
            $[15] = t8;
            $[16] = t9;
        } else t9 = $[16];
        return t9;
    }
    const SnippetReplacement = renderers?.snippet;
    const t7 = blockProps.size ?? cardContext?.ui?.size;
    const t8 = `${testId}-${statusTestId}-view`;
    let t9;
    if ($[17] !== SnippetReplacement || $[18] !== context?.meta?.objectId || $[19] !== context?.meta?.resourceType || $[20] !== context?.meta?.tenantId || $[21] !== context?.snippet || $[22] !== isHidden || $[23] !== showFooter || $[24] !== snippet || $[25] !== snippetMaxLines || $[26] !== text) {
        t9 = SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? "",
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? "",
            contentType: context?.meta?.resourceType ?? "",
            cloudId: context?.meta?.tenantId ?? "",
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet;
        $[17] = SnippetReplacement;
        $[18] = context?.meta?.objectId;
        $[19] = context?.meta?.resourceType;
        $[20] = context?.meta?.tenantId;
        $[21] = context?.snippet;
        $[22] = isHidden;
        $[23] = showFooter;
        $[24] = snippet;
        $[25] = snippetMaxLines;
        $[26] = text;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== blockProps || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
            ...blockProps,
            size: t7,
            testId: t8
        }, t9);
        $[28] = blockProps;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
        $[32] = t10;
    } else t10 = $[32];
    return t10;
} : ({ maxLines: maxLines = $60c86a1fbc149797$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $fUfR2.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49WiA.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, snippet);
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SnippetReplacement, {
        fallbackText: (text || context?.snippet) ?? '',
        fallbackComponent: snippet,
        contentId: context?.meta?.objectId ?? '',
        contentType: context?.meta?.resourceType ?? '',
        cloudId: context?.meta?.tenantId ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};
var $60c86a1fbc149797$export$2e2bcd8739ae039 = $60c86a1fbc149797$var$SnippetBlock;
module.exports["default"] = $60c86a1fbc149797$export$2e2bcd8739ae039;

});

parcelRegister("4QzTV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $69abf735cbcf4e67$export$c3514c024fefef57 = ()=>{
    const context = (0, $eIleF.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $42omo.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};
module.exports["useSmartLinkRenderers"] = $69abf735cbcf4e67$export$c3514c024fefef57;

});

parcelRegister("5znEc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $fUfR2 = parcelRequire("fUfR2");


var $gHW9t = parcelRequire("gHW9t");


var $7d67T = parcelRequire("7d67T");











var $gdv5Z = parcelRequire("gdv5Z");








var $lVA2Y = parcelRequire("lVA2Y");


var $jI5eg = parcelRequire("jI5eg");


var $2R1C4 = parcelRequire("2R1C4");


var $1RvsP = parcelRequire("1RvsP");

const $7f525c54e6e1b7b1$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $7f525c54e6e1b7b1$var$TitleBlockErroredView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    let CompetitorPrompt;
    let actionGroup;
    let blockProps;
    let hideIcon;
    let hideRetry;
    let icon;
    let position;
    let testId;
    let title;
    if ($[0] !== t0) {
        const { actionGroup: t1, hideRetry: t2, retry: _retry, position: t3, testId: t4, title: t5, icon: t6, hideIcon: t7, CompetitorPrompt: t8, ...t9 } = t0;
        actionGroup = t1;
        hideRetry = t2;
        position = t3;
        testId = t4;
        title = t5;
        icon = t6;
        hideIcon = t7;
        CompetitorPrompt = t8;
        blockProps = t9;
        $[0] = t0;
        $[1] = CompetitorPrompt;
        $[2] = actionGroup;
        $[3] = blockProps;
        $[4] = hideIcon;
        $[5] = hideRetry;
        $[6] = icon;
        $[7] = position;
        $[8] = testId;
        $[9] = title;
    } else {
        CompetitorPrompt = $[1];
        actionGroup = $[2];
        blockProps = $[3];
        hideIcon = $[4];
        hideRetry = $[5];
        icon = $[6];
        position = $[7];
        testId = $[8];
        title = $[9];
    }
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]);
    let t1;
    if ($[10] !== CompetitorPrompt || $[11] !== context?.url) {
        t1 = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CompetitorPrompt, {
            sourceUrl: context?.url,
            linkType: "card"
        }) : null;
        $[10] = CompetitorPrompt;
        $[11] = context?.url;
        $[12] = t1;
    } else t1 = $[12];
    const competitorPrompt = t1;
    const t2 = `${testId}-errored-view`;
    let t3;
    if ($[13] !== hideIcon || $[14] !== icon || $[15] !== position) {
        t3 = !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
            overrideIcon: icon,
            position: position
        });
        $[13] = hideIcon;
        $[14] = icon;
        $[15] = position;
        $[16] = t3;
    } else t3 = $[16];
    let t4;
    if ($[17] !== competitorPrompt || $[18] !== title) {
        t4 = competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $7f525c54e6e1b7b1$var$styles.titleBoxCard
        }, title, competitorPrompt) : title;
        $[17] = competitorPrompt;
        $[18] = title;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== showRetry || $[21] !== testId) {
        t5 = showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RvsP.default), {
            align: (0, $5TXU5.SmartLinkAlignment).Right
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), {
            testId: testId
        }));
        $[20] = showRetry;
        $[21] = testId;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== actionGroup || $[24] !== blockProps || $[25] !== t2 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
            ...blockProps,
            testId: t2
        }, t3, t4, t5, actionGroup);
        $[23] = actionGroup;
        $[24] = blockProps;
        $[25] = t2;
        $[26] = t3;
        $[27] = t4;
        $[28] = t5;
        $[29] = t6;
    } else t6 = $[29];
    return t6;
} : ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7f525c54e6e1b7b1$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RvsP.default), {
        align: (0, $5TXU5.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lVA2Y.default), {
        testId: testId
    })), actionGroup);
};
var $7f525c54e6e1b7b1$export$2e2bcd8739ae039 = $7f525c54e6e1b7b1$var$TitleBlockErroredView;






























var $l7DP7 = parcelRequire("l7DP7");

const $c1792527dfb9ef73$var$style = null;
const $c1792527dfb9ef73$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $c1792527dfb9ef73$var$TitleBlockResolvedView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(50);
    let CompetitorPrompt;
    let actionGroup;
    let blockProps;
    let hideIcon;
    let hideIconLoadingSkeleton;
    let icon;
    let metadataPosition;
    let position;
    let t1;
    let t2;
    let testId;
    let title;
    let url;
    if ($[0] !== t0) {
        const { actionGroup: t3, metadata: t4, position: t5, subtitle: t6, testId: t7, text: _text, icon: t8, title: t9, metadataPosition: t10, hideIcon: t11, CompetitorPrompt: t12, url: t13, hideIconLoadingSkeleton: t14, ...t15 } = t0;
        actionGroup = t3;
        t1 = t4;
        position = t5;
        t2 = t6;
        testId = t7;
        icon = t8;
        title = t9;
        metadataPosition = t10;
        hideIcon = t11;
        CompetitorPrompt = t12;
        url = t13;
        hideIconLoadingSkeleton = t14;
        blockProps = t15;
        $[0] = t0;
        $[1] = CompetitorPrompt;
        $[2] = actionGroup;
        $[3] = blockProps;
        $[4] = hideIcon;
        $[5] = hideIconLoadingSkeleton;
        $[6] = icon;
        $[7] = metadataPosition;
        $[8] = position;
        $[9] = t1;
        $[10] = t2;
        $[11] = testId;
        $[12] = title;
        $[13] = url;
    } else {
        CompetitorPrompt = $[1];
        actionGroup = $[2];
        blockProps = $[3];
        hideIcon = $[4];
        hideIconLoadingSkeleton = $[5];
        icon = $[6];
        metadataPosition = $[7];
        position = $[8];
        t1 = $[9];
        t2 = $[10];
        testId = $[11];
        title = $[12];
        url = $[13];
    }
    let t3;
    if ($[14] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[14] = t1;
        $[15] = t3;
    } else t3 = $[15];
    const metadata = t3;
    let t4;
    if ($[16] !== t2) {
        t4 = t2 === undefined ? [] : t2;
        $[16] = t2;
        $[17] = t4;
    } else t4 = $[17];
    const subtitle = t4;
    const { size: size } = blockProps;
    let t5;
    if ($[18] !== metadata) {
        t5 = (0, $l7DP7.renderElementItems)(metadata);
        $[18] = metadata;
        $[19] = t5;
    } else t5 = $[19];
    const metadataElements = t5;
    let t6;
    if ($[20] !== subtitle) {
        t6 = (0, $l7DP7.renderElementItems)(subtitle);
        $[20] = subtitle;
        $[21] = t6;
    } else t6 = $[21];
    const subtitleElements = t6;
    const t7 = `${testId}-resolved-view`;
    let t8;
    if ($[22] !== hideIcon || $[23] !== hideIconLoadingSkeleton || $[24] !== icon || $[25] !== position || $[26] !== size) {
        t8 = !hideIcon && /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), {
            overrideIcon: icon,
            position: position,
            size: size,
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
        $[22] = hideIcon;
        $[23] = hideIconLoadingSkeleton;
        $[24] = icon;
        $[25] = position;
        $[26] = size;
        $[27] = t8;
    } else t8 = $[27];
    const t9 = blockProps.size;
    let t10;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $gMc0m.default)([
            "_zulp1b66"
        ]);
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== CompetitorPrompt || $[30] !== title || $[31] !== url) {
        t11 = CompetitorPrompt && url ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $c1792527dfb9ef73$var$styles.titleBox
        }, title, /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
            sourceUrl: url,
            linkType: "card"
        })) : title;
        $[29] = CompetitorPrompt;
        $[30] = title;
        $[31] = url;
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== subtitleElements) {
        t12 = subtitleElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
            direction: (0, $5TXU5.SmartLinkDirection).Horizontal
        }, subtitleElements);
        $[33] = subtitleElements;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== blockProps.size || $[36] !== t11 || $[37] !== t12) {
        t13 = /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
            direction: (0, $5TXU5.SmartLinkDirection).Vertical,
            width: (0, $5TXU5.SmartLinkWidth).Flexible,
            size: t9,
            className: t10
        }, t11, t12);
        $[35] = blockProps.size;
        $[36] = t11;
        $[37] = t12;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== blockProps.size || $[40] !== metadataElements || $[41] !== metadataPosition) {
        t14 = metadataElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
            direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
            align: (0, $5TXU5.SmartLinkAlignment).Right,
            position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
            size: blockProps.size
        }, metadataElements);
        $[39] = blockProps.size;
        $[40] = metadataElements;
        $[41] = metadataPosition;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== actionGroup || $[44] !== blockProps || $[45] !== t13 || $[46] !== t14 || $[47] !== t7 || $[48] !== t8) {
        t15 = /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
            ...blockProps,
            testId: t7
        }, t8, t13, t14, actionGroup);
        $[43] = actionGroup;
        $[44] = blockProps;
        $[45] = t13;
        $[46] = t14;
        $[47] = t7;
        $[48] = t8;
        $[49] = t15;
    } else t15 = $[49];
    return t15;
} : ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $l7DP7.renderElementItems)(metadata);
    const subtitleElements = (0, $l7DP7.renderElementItems)(subtitle);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $gMc0m.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c1792527dfb9ef73$var$styles.titleBox
    }, title, /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        align: (0, $5TXU5.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $c1792527dfb9ef73$export$2e2bcd8739ae039 = $c1792527dfb9ef73$var$TitleBlockResolvedView;















var $17It2 = parcelRequire("17It2");





var $hJgLA = parcelRequire("hJgLA");




/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $835b2d1437edfc5d$var$TitleBlockResolvingView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    let actionGroup;
    let blockProps;
    let hideIcon;
    let icon;
    let position;
    let size;
    let t1;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps } = t0);
        const { size: t2 } = blockProps;
        size = t2 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t2;
        t1 = (0, $hJgLA.getIconWidth)(size);
        $[0] = t0;
        $[1] = actionGroup;
        $[2] = blockProps;
        $[3] = hideIcon;
        $[4] = icon;
        $[5] = position;
        $[6] = size;
        $[7] = t1;
        $[8] = testId;
        $[9] = title;
    } else {
        actionGroup = $[1];
        blockProps = $[2];
        hideIcon = $[3];
        icon = $[4];
        position = $[5];
        size = $[6];
        t1 = $[7];
        testId = $[8];
        title = $[9];
    }
    const iconWidth = t1;
    const t2 = `${testId}-resolving-view`;
    let t3;
    if ($[10] !== hideIcon || $[11] !== icon || $[12] !== position || $[13] !== size) {
        t3 = !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
            overrideIcon: icon,
            position: position,
            size: size,
            hideLoadingSkeleton: true
        });
        $[10] = hideIcon;
        $[11] = icon;
        $[12] = position;
        $[13] = size;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== hideIcon || $[16] !== icon || $[17] !== iconWidth || $[18] !== testId) {
        t4 = !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: iconWidth,
                height: iconWidth
            },
            "data-testid": `${testId}-icon`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17It2.LoadingSkeleton), {
            width: iconWidth,
            height: iconWidth,
            testId: `${testId}-icon-loading`
        }));
        $[15] = hideIcon;
        $[16] = icon;
        $[17] = iconWidth;
        $[18] = testId;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== actionGroup || $[21] !== blockProps || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
            ...blockProps,
            testId: t2
        }, t3, t4, title, actionGroup);
        $[20] = actionGroup;
        $[21] = blockProps;
        $[22] = t2;
        $[23] = t3;
        $[24] = t4;
        $[25] = title;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
} : ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jI5eg.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17It2.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $835b2d1437edfc5d$export$2e2bcd8739ae039 = $835b2d1437edfc5d$var$TitleBlockResolvingView;


const $86a4ce57d2ec07f2$var$actionStyles = null;
const $86a4ce57d2ec07f2$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return 0, $835b2d1437edfc5d$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return 0, $c1792527dfb9ef73$export$2e2bcd8739ae039;
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return 0, $7f525c54e6e1b7b1$export$2e2bcd8739ae039;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $86a4ce57d2ec07f2$var$TitleBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(59);
    let CompetitorPrompt;
    let anchorRef;
    let anchorTarget;
    let className;
    let hideIconLoadingSkeleton;
    let hideRetry;
    let hideTitleTooltip;
    let icon;
    let maxLines;
    let metadataPosition;
    let onActionMenuOpenChange;
    let props;
    let showActionOnHover;
    let t1;
    let t2;
    let t3;
    let text;
    let url;
    if ($[0] !== t0) {
        ({ actions: t1, anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: t2, text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: t3, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props } = t0);
        $[0] = t0;
        $[1] = CompetitorPrompt;
        $[2] = anchorRef;
        $[3] = anchorTarget;
        $[4] = className;
        $[5] = hideIconLoadingSkeleton;
        $[6] = hideRetry;
        $[7] = hideTitleTooltip;
        $[8] = icon;
        $[9] = maxLines;
        $[10] = metadataPosition;
        $[11] = onActionMenuOpenChange;
        $[12] = props;
        $[13] = showActionOnHover;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
        $[17] = text;
        $[18] = url;
    } else {
        CompetitorPrompt = $[1];
        anchorRef = $[2];
        anchorTarget = $[3];
        className = $[4];
        hideIconLoadingSkeleton = $[5];
        hideRetry = $[6];
        hideTitleTooltip = $[7];
        icon = $[8];
        maxLines = $[9];
        metadataPosition = $[10];
        onActionMenuOpenChange = $[11];
        props = $[12];
        showActionOnHover = $[13];
        t1 = $[14];
        t2 = $[15];
        t3 = $[16];
        text = $[17];
        url = $[18];
    }
    let t4;
    if ($[19] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[19] = t1;
        $[20] = t4;
    } else t4 = $[20];
    const actions = t4;
    const testId = t2 === undefined ? "smart-block-title" : t2;
    const hideIcon = t3 === undefined ? false : t3;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    let t5;
    if ($[21] !== cardContext) {
        t5 = cardContext || {};
        $[21] = cardContext;
        $[22] = t5;
    } else t5 = $[22];
    const { status: t6, ui: ui } = t5;
    const status = t6 === undefined ? (0, $5TXU5.SmartLinkStatus).Fallback : t6;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $42omo.useState)(false);
    let t7;
    if ($[23] !== onActionMenuOpenChange) {
        t7 = (isOpen)=>{
            setActionDropdownOpen(isOpen);
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        };
        $[23] = onActionMenuOpenChange;
        $[24] = t7;
    } else t7 = $[24];
    const onDropdownOpenChange = t7;
    let t8;
    if ($[25] !== actions || $[26] !== onDropdownOpenChange || $[27] !== showActionOnHover) {
        t8 = actions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
            items: actions,
            visibleButtonsNum: showActionOnHover ? 1 : 2,
            onDropdownOpenChange: onDropdownOpenChange
        });
        $[25] = actions;
        $[26] = onDropdownOpenChange;
        $[27] = showActionOnHover;
        $[28] = t8;
    } else t8 = $[28];
    const actionGroup = t8;
    let t9;
    if ($[29] !== text) {
        t9 = !!text ? {
            text: text
        } : {};
        $[29] = text;
        $[30] = t9;
    } else t9 = $[30];
    const overrideText = t9;
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const t10 = ui?.theme;
    let t11;
    if ($[31] !== anchorRef || $[32] !== anchorTarget || $[33] !== hideTitleTooltip || $[34] !== maxLines || $[35] !== onMouseDown || $[36] !== overrideText || $[37] !== t10) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $gHW9t.default), {
            hideTooltip: hideTitleTooltip,
            maxLines: maxLines,
            onMouseDown: onMouseDown,
            target: anchorTarget,
            theme: t10,
            anchorRef: anchorRef,
            ...overrideText
        });
        $[31] = anchorRef;
        $[32] = anchorTarget;
        $[33] = hideTitleTooltip;
        $[34] = maxLines;
        $[35] = onMouseDown;
        $[36] = overrideText;
        $[37] = t10;
        $[38] = t11;
    } else t11 = $[38];
    const title = t11;
    let t12;
    if ($[39] !== status) {
        t12 = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent(status);
        $[39] = status;
        $[40] = t12;
    } else t12 = $[40];
    const Component = t12;
    const t13 = showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n";
    let t14;
    if ($[41] !== className || $[42] !== t13) {
        t14 = (0, $gMc0m.default)([
            t13,
            className
        ]);
        $[41] = className;
        $[42] = t13;
        $[43] = t14;
    } else t14 = $[43];
    const t15 = props.size ?? ui?.size;
    let t16;
    if ($[44] !== CompetitorPrompt || $[45] !== Component || $[46] !== actionGroup || $[47] !== hideIcon || $[48] !== hideIconLoadingSkeleton || $[49] !== hideRetry || $[50] !== icon || $[51] !== metadataPosition || $[52] !== props || $[53] !== t14 || $[54] !== t15 || $[55] !== testId || $[56] !== title || $[57] !== url) {
        t16 = /*#__PURE__*/ $42omo.createElement(Component, {
            ...props,
            actionGroup: actionGroup,
            className: t14,
            testId: testId,
            title: title,
            metadataPosition: metadataPosition,
            hideIcon: hideIcon,
            hideRetry: hideRetry,
            icon: icon,
            hideIconLoadingSkeleton: hideIconLoadingSkeleton,
            size: t15,
            CompetitorPrompt: CompetitorPrompt,
            url: url
        });
        $[44] = CompetitorPrompt;
        $[45] = Component;
        $[46] = actionGroup;
        $[47] = hideIcon;
        $[48] = hideIconLoadingSkeleton;
        $[49] = hideRetry;
        $[50] = icon;
        $[51] = metadataPosition;
        $[52] = props;
        $[53] = t14;
        $[54] = t15;
        $[55] = testId;
        $[56] = title;
        $[57] = url;
        $[58] = t16;
    } else t16 = $[58];
    return t16;
} : ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const { status: status = (0, $5TXU5.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $42omo.useState)(false);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const title = /*#__PURE__*/ $42omo.createElement((0, $gHW9t.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $42omo.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $gMc0m.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $86a4ce57d2ec07f2$export$2e2bcd8739ae039 = $86a4ce57d2ec07f2$var$TitleBlock;
module.exports["default"] = $86a4ce57d2ec07f2$export$2e2bcd8739ae039;

});

parcelRegister("eqpYq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");





var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");














var $e6pbP = parcelRequire("e6pbP");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");













const $bd7359d17942e8a2$var$listStyles = null;
const $bd7359d17942e8a2$var$UList = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_19bvv47k _bozgv47k"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            ...props,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ...props,
        className: (0, $gMc0m.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $bd7359d17942e8a2$export$2e2bcd8739ae039 = $bd7359d17942e8a2$var$UList;


const $9338d7fc86a81ff5$var$baseStyle = null;
const $9338d7fc86a81ff5$var$textStyleNew = null;
const $9338d7fc86a81ff5$var$textStyleOld = null; /**
                            * A component to render a response from AI in markdown text.
                            * @internal
                            * @param {AISummaryProps} AISummaryProps
                            */ 
const $9338d7fc86a81ff5$var$AISummary = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { content: t1, className: className, testId: t2, minHeight: t3 } = t0;
    const content = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "ai-summary" : t2;
    const minHeight = t3 === undefined ? 0 : t3;
    if (!content && minHeight === 0) return null;
    const is3pExperimentEnabled = (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") && (0, $dZ8uq.expValEqualsNoExposure)("platform_sl_3p_auth_rovo_action", "isEnabled", true);
    let t4;
    if ($[0] !== className) {
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            is3pExperimentEnabled ? "_syazi7uo" : "_syazazsu",
            className
        ]);
        $[0] = className;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            forceWrapper: true,
            overrides: {
                ul: (0, $bd7359d17942e8a2$export$2e2bcd8739ae039)
            },
            disableParsingRawHTML: true
        };
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== minHeight) {
        t6 = {
            minHeight: minHeight
        };
        $[3] = minHeight;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== content || $[6] !== t4 || $[7] !== t6 || $[8] !== testId) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $e6pbP.default), {
            "data-testid": testId,
            className: t4,
            children: content,
            options: t5,
            style: t6
        });
        $[5] = content;
        $[6] = t4;
        $[7] = t6;
        $[8] = testId;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
} : ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    const is3pExperimentEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_action', 'isEnabled', true);
    return /*#__PURE__*/ $42omo.createElement((0, $e6pbP.default), {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            is3pExperimentEnabled ? "_syazi7uo" : "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $bd7359d17942e8a2$export$2e2bcd8739ae039)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $9338d7fc86a81ff5$export$2e2bcd8739ae039 = $9338d7fc86a81ff5$var$AISummary;















var $8tSmd = parcelRequire("8tSmd");


var $2Nwuj = parcelRequire("2Nwuj");












const $ba3699740c57099b$var$styles = {
    aiFooterWrapper: "_ca0q1b66"
};
const $ba3699740c57099b$var$AIFooter = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)",
            size: "small"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            xcss: $ba3699740c57099b$var$styles.aiFooterWrapper
        }, t0, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            size: "small"
        }, /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: (0, $5TXU5.CONTENT_URL_ROVO),
            appearance: "subtle",
            target: "_blank"
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_disclaimer))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $ba3699740c57099b$var$styles.aiFooterWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small"
    }, /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
        href: (0, $5TXU5.CONTENT_URL_ROVO),
        appearance: "subtle",
        target: "_blank"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_disclaimer))));
var $ba3699740c57099b$export$2e2bcd8739ae039 = $ba3699740c57099b$var$AIFooter;



var $6bBFP = parcelRequire("6bBFP");


var $2R1C4 = parcelRequire("2R1C4");











var $kKODE = parcelRequire("kKODE");

const $f7f9db9fca31c767$var$AIEventSummaryViewed = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { fromCache: t1 } = t0;
    const fromCache = t1 === undefined ? null : t1;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[0] !== fireEvent || $[1] !== fromCache) {
        t2 = ()=>{
            fireEvent("ui.summary.viewed", {
                fromCache: fromCache
            });
            if (fromCache) fireEvent("track.aiInteraction.initiated", {
                aiFeatureName: "Smart Links Summary",
                proactiveAIGenerated: 1,
                userGeneratedAI: 0
            });
        };
        t3 = [
            fireEvent,
            fromCache
        ];
        $[0] = fireEvent;
        $[1] = fromCache;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $42omo.useEffect)(t2, t3);
    return null;
} : ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f7f9db9fca31c767$export$2e2bcd8739ae039 = $f7f9db9fca31c767$var$AIEventSummaryViewed;














const $2a4b4233e8981c08$var$animation = null;
const $2a4b4233e8981c08$var$animation1 = null;
const $2a4b4233e8981c08$var$animation2 = null;
const $2a4b4233e8981c08$var$dot1 = null;
const $2a4b4233e8981c08$var$dot2 = null;
const $2a4b4233e8981c08$var$dot3 = null;
const $2a4b4233e8981c08$var$animatedOpacity = null;
const $2a4b4233e8981c08$export$c0e6915bcce7d1d0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { isAnimated: t1 } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const t2 = isAnimated && "";
    const t3 = isAnimated && "_y44v1gpk";
    const t4 = isAnimated && $2a4b4233e8981c08$var$animatedOpacity;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $gMc0m.default)([
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement("path", {
            className: t5,
            d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
            fill: "#1868DB"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isAnimated && "";
    const t8 = isAnimated && "_y44v18gg";
    const t9 = isAnimated && $2a4b4233e8981c08$var$animatedOpacity;
    let t10;
    if ($[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t10 = (0, $gMc0m.default)([
            t7,
            t8,
            t9
        ]);
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10) {
        t11 = /*#__PURE__*/ $42omo.createElement("path", {
            className: t10,
            d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
            fill: "#BF63F3"
        });
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const t12 = isAnimated && "";
    const t13 = isAnimated && "_y44voqx9";
    const t14 = isAnimated && $2a4b4233e8981c08$var$animatedOpacity;
    let t15;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
        t15 = (0, $gMc0m.default)([
            t12,
            t13,
            t14
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] !== t15) {
        t16 = /*#__PURE__*/ $42omo.createElement("path", {
            className: t15,
            d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
            fill: "#FCA700"
        });
        $[16] = t15;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== t11 || $[19] !== t16 || $[20] !== t6) {
        t17 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t6, t11, t16);
        $[18] = t11;
        $[19] = t16;
        $[20] = t6;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v1gpk",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44v18gg",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $42omo.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            isAnimated && "",
            isAnimated && "_y44voqx9",
            isAnimated && $2a4b4233e8981c08$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};


const $6916bf0a97d23595$var$styles = null;
const $6916bf0a97d23595$var$newStyles = {
    iconWrapper: "_19bv1b66 _u5f3utpp _1e0c1txw _4cvr1h6o",
    placeholderWrapper: "_1e0c1txw _4cvr1h6o",
    summaryWrapper: "_ca0q1b66 _1e0c1txw",
    ellipsesContainer: "_19bv1b66"
};
const $6916bf0a97d23595$var$AISummaryBlockResolvedView = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, placeholder);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
const $6916bf0a97d23595$export$3570243fee4941c9 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default), (0, $9338d7fc86a81ff5$export$2e2bcd8739ae039));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const isSummarisedOnMountRef = (0, $42omo.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (status === 'error') return null;
     // Show summary when there is content to display
    if (content && content !== '') return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        xcss: $6916bf0a97d23595$var$newStyles.summaryWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: "xxsmall"
    })), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $f7f9db9fca31c767$export$2e2bcd8739ae039), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: true,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $42omo.createElement((0, $9338d7fc86a81ff5$export$2e2bcd8739ae039), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    }), status === 'done' && /*#__PURE__*/ $42omo.createElement((0, $ba3699740c57099b$export$2e2bcd8739ae039), null))));
     // Show loading state on initial request where content hasn't returned yet.
    if (status === 'loading') return /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        minHeight: minHeight,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        testId: `${testId}-placeholder`,
        xcss: $6916bf0a97d23595$var$newStyles.placeholderWrapper
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6916bf0a97d23595$var$newStyles.iconWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $lAFHW.RovoIcon), {
        shouldUseHexLogo: true,
        size: 'xxsmall'
    })), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).rovo_summary_loading)), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6916bf0a97d23595$var$newStyles.ellipsesContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $2a4b4233e8981c08$export$c0e6915bcce7d1d0), {
        isAnimated: true
    }))));
     // Otherwise, show placeholder if provided
    if (placeholder) return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, placeholder);
    return null;
};
var $6916bf0a97d23595$export$2e2bcd8739ae039 = $6916bf0a97d23595$var$AISummaryBlockResolvedView;


/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3d73a30329f2f2d2$var$AISummaryBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    let isAny3pRovoActionsExperimentOn;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ isAny3pRovoActionsExperimentOn: isAny3pRovoActionsExperimentOn, testId: t1, ...props } = t0);
        $[0] = t0;
        $[1] = isAny3pRovoActionsExperimentOn;
        $[2] = props;
        $[3] = t1;
    } else {
        isAny3pRovoActionsExperimentOn = $[1];
        props = $[2];
        t1 = $[3];
    }
    const testId = t1 === undefined ? "smart-ai-summary-block" : t1;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    if (isAny3pRovoActionsExperimentOn) {
        const t2 = props.size ?? cardContext?.ui?.size;
        let t3;
        if ($[4] !== actionData.url || $[5] !== props || $[6] !== t2 || $[7] !== testId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$3570243fee4941c9), {
                ...props,
                size: t2,
                testId: testId,
                url: actionData.url
            });
            $[4] = actionData.url;
            $[5] = props;
            $[6] = t2;
            $[7] = testId;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    const t2 = props.size ?? cardContext?.ui?.size;
    let t3;
    if ($[9] !== actionData.url || $[10] !== props || $[11] !== t2 || $[12] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$2e2bcd8739ae039), {
            ...props,
            size: t2,
            testId: testId,
            url: actionData.url
        });
        $[9] = actionData.url;
        $[10] = props;
        $[11] = t2;
        $[12] = testId;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ isAny3pRovoActionsExperimentOn: isAny3pRovoActionsExperimentOn, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    if (isAny3pRovoActionsExperimentOn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$3570243fee4941c9), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6916bf0a97d23595$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $3d73a30329f2f2d2$export$2e2bcd8739ae039 = $3d73a30329f2f2d2$var$AISummaryBlock;
module.exports["default"] = $3d73a30329f2f2d2$export$2e2bcd8739ae039;

});

parcelRegister("MlN47", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

















var $2ZgNz = parcelRequire("2ZgNz");


var $2R1C4 = parcelRequire("2R1C4");





var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $gNXND = parcelRequire("gNXND");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");


var $afp1H = parcelRequire("afp1H");


var $6KV13 = parcelRequire("6KV13");











var $eXmBZ = parcelRequire("eXmBZ");

const $b60461a0f2dc3b3a$export$2957fc44b3d2481 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const t0 = props.color || "currentColor";
    let t1;
    if ($[0] !== props || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            color: t0,
            ...props
        });
        $[0] = props;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        color: props.color || 'currentColor',
        ...props
    });


const $b7fbd07145f71993$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b60461a0f2dc3b3a$export$2957fc44b3d2481), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


const $92f251934aee2626$var$AIFooterBlockResolvedView = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    const t0 = `${testId}-resolved-view`;
    const t1 = `${testId}-provider`;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), {
            appearance: "subtle",
            testId: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== actionData || $[3] !== testId) {
        t3 = actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7fbd07145f71993$export$175228cc2c92b3b6), {
            ...actionData,
            testId: `${testId}-ai-metadata`
        }) : null;
        $[2] = actionData;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== props || $[6] !== t0 || $[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
            ...props,
            testId: t0
        }, t2, t3);
        $[5] = props;
        $[6] = t0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7fbd07145f71993$export$175228cc2c92b3b6), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $92f251934aee2626$export$2e2bcd8739ae039 = $92f251934aee2626$var$AIFooterBlockResolvedView;


/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $38aa18aa215cb0bb$var$AIFooterBlock = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ testId: t1, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
    } else {
        props = $[1];
        t1 = $[2];
    }
    const testId = t1 === undefined ? "smart-ai-footer-block" : t1;
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const t2 = props.size ?? cardContext?.ui?.size;
    let t3;
    if ($[3] !== props || $[4] !== t2 || $[5] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92f251934aee2626$export$2e2bcd8739ae039), {
            ...props,
            size: t2,
            testId: testId
        });
        $[3] = props;
        $[4] = t2;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92f251934aee2626$export$2e2bcd8739ae039), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $38aa18aa215cb0bb$export$2e2bcd8739ae039 = $38aa18aa215cb0bb$var$AIFooterBlock;
module.exports["default"] = $38aa18aa215cb0bb$export$2e2bcd8739ae039;

});

parcelRegister("7Twup", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jlQ9A = parcelRequire("jlQ9A");


var $2ZgNz = parcelRequire("2ZgNz");


var $2R1C4 = parcelRequire("2R1C4");

const $a23285dcc916d065$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $5TXU5.ActionName).RovoChatAction
];
const $a23285dcc916d065$var$ignoreContainerMarginStyles = null;
const $a23285dcc916d065$var$elevatedFooterStyles = null;
const $a23285dcc916d065$var$providerStyles = null;
const $a23285dcc916d065$var$actionsStyles = null; /**
                             * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
                             * @internal
                             * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
                             * @see Block
                             */ 
const $a23285dcc916d065$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    const cardContext = (0, $fUfR2.useFlexibleCardContext)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const size = props.size ?? cardContext?.ui?.size;
    const actions = (0, $42omo.useMemo)(()=>{
        if (!context?.actions) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$a23285dcc916d065$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name_0)=>{
            const Action = name_0 in $jlQ9A ? $jlQ9A[name_0] : undefined;
            return Action ? /*#__PURE__*/ $42omo.createElement(Action, {
                key: name_0,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick?.(name_0),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context?.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $gMc0m.default)([
            "_18zrpxbi _1rjcutpp _vchhusvi _1bsb129b _18u01ivi _2hwxc10g _otyr1ya9 _4t3ioahv",
            "_zulpu2gc _x3doj0fz _bfhkhfxm _mrkb1mok _1o0z1mok"
        ])
    }, !hideProvider && /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _1bah1y6m _vchhusvi _16jlkb7n"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2ZgNz.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $gMc0m.default)([
            "_zulpidpf _1e0c1txw _18u01wug _4cvr1h6o _vchhusvi _7386ze3t _1xdd12b0 _17zize3t _19p4ze3t _6zimze3t _f9lhze3t _rvy9ze3t _ue4dze3t _zgrbze3t _10cuze3t _6syfze3t _3hv7ze3t"
        ])
    }, actions) : null);
};
var $a23285dcc916d065$export$2e2bcd8739ae039 = $a23285dcc916d065$var$ResolvedHoverCardFooterBlock;
module.exports["default"] = $a23285dcc916d065$export$2e2bcd8739ae039;

});

parcelRegister("f0wtW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $jlQ9A = parcelRequire("jlQ9A");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $a3fRD = parcelRequire("a3fRD");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6bBFP = parcelRequire("6bBFP");

const $dfe1275874cc34dc$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8wadc _syazazsu"
};
const $dfe1275874cc34dc$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $dfe1275874cc34dc$export$2d2b754ac238f9aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { message: message, testId: testId } = t0;
    if (!message) return null;
    const t1 = message.appearance === "error" ? "color.background.danger" : undefined;
    const t2 = `${testId}-footer`;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            width: "calc(100% - var(--container-padding-left) - var(--container-padding-right))"
        };
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== message.appearance || $[2] !== message.icon) {
        t4 = message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance);
        $[1] = message.appearance;
        $[2] = message.icon;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== message.title) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $dfe1275874cc34dc$var$styles.titleStyles
        }, message.title);
        $[4] = message.title;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
            isFadeIn: true,
            show: true,
            showTransition: true
        }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "start",
            grow: "fill",
            space: "space.075",
            xcss: $dfe1275874cc34dc$var$styles.errorContentStyles
        }, t4, t5));
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t1 || $[10] !== t2 || $[11] !== t6) {
        t7 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            backgroundColor: t1,
            testId: t2,
            style: t3,
            xcss: $dfe1275874cc34dc$var$styles.containerStyles
        }, t6);
        $[9] = t1;
        $[10] = t2;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $dfe1275874cc34dc$var$styles.containerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6bBFP.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $dfe1275874cc34dc$var$styles.errorContentStyles
    }, message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $dfe1275874cc34dc$var$styles.titleStyles
    }, message.title))));
};


const $018f38f6aa2eb81b$var$ignoreContainerPaddingStyles = null;
const $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $018f38f6aa2eb81b$var$sort = (a, b)=>{
    let idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $018f38f6aa2eb81b$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $018f38f6aa2eb81b$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action', isAny3pRovoActionsExperimentOn: isAny3pRovoActionsExperimentOn })=>{
    (0, $fBMbo.di)((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const isRovoChatActionAvailable = isAny3pRovoActionsExperimentOn && (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction] !== undefined : undefined;
    const [message, setMessage] = (0, $42omo.useState)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const onLoadingChange = (0, $42omo.useCallback)((isLoading_0)=>{
        setIsLoading(isLoading_0);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $018f38f6aa2eb81b$export$1af10e3728e3a644(ui?.size || (0, $5TXU5.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $42omo.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $42omo.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $42omo.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? isRovoChatActionAvailable ? [
            (0, $5TXU5.ActionName).RovoChatAction
        ] : Object.keys(context.actions).filter((name_0)=>name_0 !== (0, $5TXU5.ActionName).RovoChatAction) : Object.keys(context.actions);
        arr.sort($018f38f6aa2eb81b$var$sort);
        const renderAction = (name_1)=>{
            const Action = name_1 in $jlQ9A ? $jlQ9A[name_1] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $42omo.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name_1,
                onClick: ()=>onClick(name_1),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                style: padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name_2)=>renderAction(name_2));
    }, [
        context?.actions,
        isRovoChatActionAvailable,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    if (!actions) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $42omo.createElement((0, $dfe1275874cc34dc$export$2d2b754ac238f9aa), {
        message: message,
        testId: testId
    }));
};
var $018f38f6aa2eb81b$export$2e2bcd8739ae039 = $018f38f6aa2eb81b$var$ActionBlock;
module.exports["default"] = $018f38f6aa2eb81b$export$2e2bcd8739ae039;

});

parcelRegister("5Tie7", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kMrL6 = parcelRequire("kMrL6");


var $1KuCI = parcelRequire("1KuCI");

const $eeea3d3a1c12cf78$export$1ca0544321134ad6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { isSelected: isSelected, url: url, placeholder: placeholder } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== placeholder || $[2] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
            key: "lazy-render-key",
            testId: "lazy-render-placeholder",
            "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
            isSelected: isSelected,
            link: url,
            className: (0, $kMrL6.loadingPlaceholderClassName),
            placeholder: placeholder
        });
        $[0] = isSelected;
        $[1] = placeholder;
        $[2] = url;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kMrL6.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};
module.exports["LoadingCardLink"] = $eeea3d3a1c12cf78$export$1ca0544321134ad6;

});

parcelRegister("kMrL6", function(module, exports) {

const $7c40b507ccc1d29f$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $7c40b507ccc1d29f$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $7c40b507ccc1d29f$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $7c40b507ccc1d29f$export$7b62853ead5e547c = 'block-card-resolved-view';
const $7c40b507ccc1d29f$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $7c40b507ccc1d29f$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $7c40b507ccc1d29f$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $7c40b507ccc1d29f$export$d17e5383afeb158c = 'block-card-content';
const $7c40b507ccc1d29f$export$8c59795ed52e92b3 = 'block-card-content-header';
const $7c40b507ccc1d29f$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $7c40b507ccc1d29f$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $7c40b507ccc1d29f$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $7c40b507ccc1d29f$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
module.exports["loadingPlaceholderClassName"] = $7c40b507ccc1d29f$export$4b2b7d155f69aed4;

});

parcelRegister("1KuCI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ioVck = parcelRequire("ioVck");

class $33c97c3cf1ea6f6c$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}
module.exports["CardLinkView"] = $33c97c3cf1ea6f6c$export$ce508304ed2dd145;

});

parcelRegister("ioVck", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4gM1A = parcelRequire("4gM1A");








var $gMc0m = parcelRequire("gMc0m");




const $f88a24196e637c23$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(18);
    let isHovered;
    let isSelected;
    let props;
    let truncateInline;
    let viewType;
    let withoutBackground;
    if ($[0] !== t0) {
        const { truncateInline: t1, withoutBackground: t2, isHovered: t3, isInteractive: _isInteractive, isSelected: t4, viewType: t5, ...t6 } = t0;
        truncateInline = t1;
        withoutBackground = t2;
        isHovered = t3;
        isSelected = t4;
        viewType = t5;
        props = t6;
        $[0] = t0;
        $[1] = isHovered;
        $[2] = isSelected;
        $[3] = props;
        $[4] = truncateInline;
        $[5] = viewType;
        $[6] = withoutBackground;
    } else {
        isHovered = $[1];
        isSelected = $[2];
        props = $[3];
        truncateInline = $[4];
        viewType = $[5];
        withoutBackground = $[6];
    }
    const t1 = truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf";
    const t2 = truncateInline && viewType === "unauthorised" && "_syaz15cr";
    const t3 = withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1";
    const t4 = isHovered && "_1h6d1w55";
    const t5 = isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1";
    const t6 = isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv";
    let t7;
    if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            t1,
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== props || $[15] !== ref || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: ref,
            ...props,
            className: t7
        }, props.children);
        $[14] = props;
        $[15] = ref;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $f88a24196e637c23$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(23);
    let href;
    let isHovered;
    let isInteractive;
    let isSelected;
    let props;
    let truncateInline;
    let viewType;
    let withoutBackground;
    if ($[0] !== t0) {
        ({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props } = t0);
        $[0] = t0;
        $[1] = href;
        $[2] = isHovered;
        $[3] = isInteractive;
        $[4] = isSelected;
        $[5] = props;
        $[6] = truncateInline;
        $[7] = viewType;
        $[8] = withoutBackground;
    } else {
        href = $[1];
        isHovered = $[2];
        isInteractive = $[3];
        isSelected = $[4];
        props = $[5];
        truncateInline = $[6];
        viewType = $[7];
        withoutBackground = $[8];
    }
    const t1 = truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf";
    const t2 = truncateInline && viewType === "unauthorised" && "_syaz15cr";
    const t3 = withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1";
    const t4 = isHovered && "_1h6d1w55";
    const t5 = isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1";
    const t6 = isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv";
    const t7 = isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3";
    const t8 = viewType === "errored" && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1";
    let t9;
    if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
        t9 = (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            t1,
            t2,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8
        ]);
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== href || $[19] !== props || $[20] !== ref || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: href,
            ref: ref,
            ...props,
            className: t9
        }, props.children);
        $[18] = href;
        $[19] = props;
        $[20] = ref;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
} : ({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $gMc0m.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $f88a24196e637c23$var$baseWrapperStyles = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $f88a24196e637c23$var$interactiveStyles = null;
const $f88a24196e637c23$var$hoveredStyles = null;
const $f88a24196e637c23$var$hoveredWithBackgroundStyles = null;
const $f88a24196e637c23$var$errorViewTypeStyles = null;
const $f88a24196e637c23$var$withoutBackgroundStyles = null;
const $f88a24196e637c23$var$withBackgroundStyles = null;
const $f88a24196e637c23$var$truncateStyles = null;
const $f88a24196e637c23$var$unauthorisedTruncateStyles = null;
const $f88a24196e637c23$var$notSelectedStyle = null;
const $f88a24196e637c23$var$selectedStyles = null;


const $0a9218124e4addff$export$b89a827e9254211a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(24);
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    let t0;
    if ($[0] !== onClick) {
        t0 = (event)=>{
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        $[0] = onClick;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== onClick) {
        t1 = (event_0)=>{
            if (event_0.key !== " " && event_0.key !== "Enter") return;
            if (onClick) {
                event_0.preventDefault();
                event_0.stopPropagation();
                onClick(event_0);
            }
        };
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    const handleKeyPress = t1;
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    const Wrapper = isAnchor ? (0, $f88a24196e637c23$export$6e4bde711df5c2ab) : (0, $f88a24196e637c23$export$8b5c95e985c4ec9a);
    const t2 = isInteractive && !link ? 0 : undefined;
    const t3 = isInteractive && !link ? "button" : undefined;
    let t4;
    if ($[4] !== Wrapper || $[5] !== children || $[6] !== className || $[7] !== handleClick || $[8] !== handleKeyPress || $[9] !== handleMouseDown || $[10] !== isHovered || $[11] !== isInteractive || $[12] !== isSelected || $[13] !== link || $[14] !== onAuxClick || $[15] !== onContextMenu || $[16] !== ref || $[17] !== t2 || $[18] !== t3 || $[19] !== testId || $[20] !== truncateInline || $[21] !== viewType || $[22] !== withoutBackground) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
            href: link,
            withoutBackground: withoutBackground,
            isSelected: isSelected,
            isInteractive: isInteractive,
            tabIndex: t2,
            role: t3,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            onKeyPress: handleKeyPress,
            "data-testid": testId,
            className: className,
            ref: ref,
            isHovered: isHovered,
            truncateInline: truncateInline,
            viewType: viewType
        }, children);
        $[4] = Wrapper;
        $[5] = children;
        $[6] = className;
        $[7] = handleClick;
        $[8] = handleKeyPress;
        $[9] = handleMouseDown;
        $[10] = isHovered;
        $[11] = isInteractive;
        $[12] = isSelected;
        $[13] = link;
        $[14] = onAuxClick;
        $[15] = onContextMenu;
        $[16] = ref;
        $[17] = t2;
        $[18] = t3;
        $[19] = testId;
        $[20] = truncateInline;
        $[21] = viewType;
        $[22] = withoutBackground;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : (props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $42omo.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $42omo.useCallback)((event_0)=>{
        if (event_0.key !== ' ' && event_0.key !== 'Enter') return;
        if (onClick) {
            event_0.preventDefault();
            event_0.stopPropagation();
            onClick(event_0);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $f88a24196e637c23$export$6e4bde711df5c2ab) : (0, $f88a24196e637c23$export$8b5c95e985c4ec9a);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && !link ? 0 : undefined,
        role: isInteractive && !link ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});
module.exports["Frame"] = $0a9218124e4addff$export$b89a827e9254211a;

});

parcelRegister("lb0pH", function(module, exports) {

let $f6aaf22e80d945a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f6aaf22e80d945a7$var$load("gyh6H"),
    $f6aaf22e80d945a7$var$load("1F7LX"),
    $f6aaf22e80d945a7$var$load("jZLnv"),
    $f6aaf22e80d945a7$var$load("6edij"),
    $f6aaf22e80d945a7$var$load("gknbb"),
    $f6aaf22e80d945a7$var$load("6iz6l"),
    $f6aaf22e80d945a7$var$load("4SCW2"),
    $f6aaf22e80d945a7$var$load("36QeB"),
    $f6aaf22e80d945a7$var$load("9q75n"),
    $f6aaf22e80d945a7$var$load("iYHbd"),
    $f6aaf22e80d945a7$var$load("cHb2G"),
    $f6aaf22e80d945a7$var$load("8hQ27"),
    $f6aaf22e80d945a7$var$load("keNIN"),
    $f6aaf22e80d945a7$var$load("hnGEQ"),
    $f6aaf22e80d945a7$var$load("3GuOt"),
    $f6aaf22e80d945a7$var$load("jbM5v"),
    $f6aaf22e80d945a7$var$load("dek7I"),
    $f6aaf22e80d945a7$var$load("dYtBN"),
    $f6aaf22e80d945a7$var$load("kNV5Y"),
    $f6aaf22e80d945a7$var$load("6SWFK"),
    $f6aaf22e80d945a7$var$load("9aQIt"),
    $f6aaf22e80d945a7$var$load("5zapo"),
    $f6aaf22e80d945a7$var$load("3MYQs"),
    $f6aaf22e80d945a7$var$load("XZauT"),
    $f6aaf22e80d945a7$var$load("4S1SF"),
    $f6aaf22e80d945a7$var$load("jiFtb"),
    $f6aaf22e80d945a7$var$load("lm9Lt"),
    $f6aaf22e80d945a7$var$load("9atVd"),
    $f6aaf22e80d945a7$var$load("9wPDc"),
    $f6aaf22e80d945a7$var$load("1MWOL"),
    $f6aaf22e80d945a7$var$load("6fQco"),
    $f6aaf22e80d945a7$var$load("aOY32"),
    $f6aaf22e80d945a7$var$load("7jSfd"),
    $f6aaf22e80d945a7$var$load("4HZlX"),
    $f6aaf22e80d945a7$var$load("kDqHr"),
    $f6aaf22e80d945a7$var$load("6wr18"),
    $f6aaf22e80d945a7$var$load("gT8XU"),
    $f6aaf22e80d945a7$var$load("lE8tR"),
    $f6aaf22e80d945a7$var$load("alA4m"),
    $f6aaf22e80d945a7$var$load("ffEVr"),
    $f6aaf22e80d945a7$var$load("7EorR"),
    $f6aaf22e80d945a7$var$load("18TX3"),
    $f6aaf22e80d945a7$var$load("eNanj"),
    $f6aaf22e80d945a7$var$load("kuFG2"),
    $f6aaf22e80d945a7$var$load("hhss7"),
    $f6aaf22e80d945a7$var$load("Wowvf"),
    $f6aaf22e80d945a7$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("2TEGg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dh538 = parcelRequire("dh538");


var $O1c6O = parcelRequire("O1c6O");

var $fDXXi = parcelRequire("fDXXi");


var $j5l6c = parcelRequire("j5l6c");


var $gWF6I = parcelRequire("gWF6I");


var $6er8q = parcelRequire("6er8q");


var $e8zaz = parcelRequire("e8zaz");


var $oZBat = parcelRequire("oZBat");





var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $lGgRw = parcelRequire("lGgRw");


var $9hlns = parcelRequire("9hlns");


var $48FEk = parcelRequire("48FEk");








var $fFa3V = parcelRequire("fFa3V");




/**
 * Hook for managing delayed hover actions with timeout management.
 */ function $c8f11ac7b8cef868$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $42omo.useRef)(null);
    const callbackRef = (0, $42omo.useRef)(callback);
    (0, $42omo.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $42omo.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}


/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $cd8e023101467c6c$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $cd8e023101467c6c$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $cd8e023101467c6c$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    for (const trigger of parentPopupElement.querySelectorAll('[aria-controls]')){
        const controlsId = trigger.getAttribute('aria-controls');
        if (controlsId && portal.querySelector(`#${controlsId}`)) return portal;
    }
    return null;
}


const $036bc09e0dcbcac4$var$HOVER_OPEN_DELAY = 800;
const $036bc09e0dcbcac4$var$HOVER_CLOSE_DELAY = 200;
function $036bc09e0dcbcac4$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $036bc09e0dcbcac4$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $036bc09e0dcbcac4$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $42omo.useRef)(null);
    const triggerListeners = (0, $42omo.useRef)([]);
    const contentNodeRef = (0, $42omo.useRef)(null);
    const contentListeners = (0, $42omo.useRef)(new Map());
    const isOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $c8f11ac7b8cef868$export$beb151954e0eb9fa)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $c8f11ac7b8cef868$export$beb151954e0eb9fa)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $42omo.useRef)(openDelay);
    const closeDelayRef = (0, $42omo.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $42omo.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $42omo.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $42omo.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $42omo.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $cd8e023101467c6c$export$63ce2e5e32c4f6a0)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $cd8e023101467c6c$export$386001e6036bddcf)(relatedTarget)) return;
            const childPortal = (0, $cd8e023101467c6c$export$a5fb0bbf4bb0e26a)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $42omo.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}








const $c268b218f7087397$var$PRELOAD_MAX_AGE = 300000;
const $c268b218f7087397$var$TIME_TO_INTENT = 200;
function $c268b218f7087397$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $c268b218f7087397$var$PRELOAD_MAX_AGE);
            }, $c268b218f7087397$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}








function $6e8d752af9ce8018$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $42omo.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}


const $08773b11ef01d4f2$var$emptyEntryPointParams = {};
const $08773b11ef01d4f2$var$emptyEntryPointProps = {};
const $08773b11ef01d4f2$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
};
function $08773b11ef01d4f2$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const updateRef = (0, $42omo.useRef)(null);
    const openedByRef = (0, $42omo.useRef)(null);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $08773b11ef01d4f2$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        if (isOpen) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($08773b11ef01d4f2$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $08773b11ef01d4f2$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $c268b218f7087397$export$e0cecaf2b8cc8d36)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $6e8d752af9ce8018$export$186b93979375b734)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $036bc09e0dcbcac4$export$b8df9ab832b125ac)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $42omo.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $42omo.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hoverContentRef,
            role: "none"
        }, content);
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}



var $8en9F = parcelRequire("8en9F");


var $ikcEb = parcelRequire("ikcEb");


var $cptht = parcelRequire("cptht");


var $4dNEc = parcelRequire("4dNEc");


var $2205s = parcelRequire("2205s");

/* UserProfileCardTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

const $83ab1c124ccca6dc$var$styles = {
    trigger: "_kkk2n7od _1e0c1nu9"
};
const $83ab1c124ccca6dc$export$d5e867b0afea0b23 = ({ trigger: trigger, triggerProps: triggerProps, children: children })=>{
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = hoverOnlyTrigger;
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, ...nonDialogTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            ...nonDialogTriggerProps,
            testId: "user-profile-card-trigger-wrapper",
            xcss: $83ab1c124ccca6dc$var$styles.trigger
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ...triggerProps,
        testId: "user-profile-card-trigger-wrapper",
        xcss: $83ab1c124ccca6dc$var$styles.trigger
    }, children);
};


function $082089d6a39bcf3b$export$74fa5d03ff375804(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($082089d6a39bcf3b$var$UserProfileCardWithTriggerInner, props));
}
/** Inner implementation of {@link UserProfileCardWithTrigger}. */ function $082089d6a39bcf3b$var$UserProfileCardWithTriggerInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, children: children, testId: testId, townsquareApp: townsquareApp, onProfileClick: onProfileClick, agent: agent, actions: actions }) {
    const PopupTriggerWithHover = (0, $dh538.fg)('people-teams_migrate-popup-adaptor-package') ? (0, $j5l6c.PopupTriggerWithHover) : (0, $08773b11ef01d4f2$export$afca832e0d04586a);
    const resolvedTriggerMode = trigger ?? 'click';
    const entryPointErrorFallback = (0, $42omo.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const getTestId = (0, $42omo.useMemo)(()=>(0, $cptht.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    // `triggerMethod` is the actual open method ('click' | 'hover') reported by the popup
    // adapter. It stays `undefined` until the first open so we never report a trigger-mode
    // value (e.g. 'preload-on-hover') as if it were an open method. This is hoisted onto
    // `TeamsAppAnalyticsContext.attributes` below so every analytics event fired beneath
    // the popup picks it up automatically without each event having to attach it manually.
    const [triggerMethod, setTriggerMethod] = (0, $42omo.useState)(undefined);
    const contextValue = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            townsquareApp: townsquareApp,
            onProfileClick: onProfileClick,
            getTestId: getTestId
        }), [
        cloudId,
        townsquareApp,
        onProfileClick,
        getTestId
    ]);
    const analyticsContextData = (0, $42omo.useMemo)(()=>({
            source: 'userProfileCard',
            attributes: {
                cloudId: cloudId,
                userId: userId,
                viewerId: viewerId,
                // Only attach `method` once an actual open has occurred so SLO dashboards never
                // see a synthetic method on pre-open events (e.g. preload).
                ...triggerMethod !== undefined ? {
                    method: triggerMethod
                } : {}
            }
        }), [
        cloudId,
        viewerId,
        userId,
        triggerMethod
    ]);
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikcEb.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $O1c6O.TeamsAppAnalyticsContext), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8en9F.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($082089d6a39bcf3b$var$UserProfileCardPopupWithAnalytics, {
        PopupTriggerWithHover: PopupTriggerWithHover,
        entryPointParams: {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        },
        entryPointProps: {
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            testId: testId,
            agent: agent,
            actions: actions
        },
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        triggerMode: resolvedTriggerMode,
        errorFallback: entryPointErrorFallback,
        onTriggerMethodChange: setTriggerMethod,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $83ab1c124ccca6dc$export$d5e867b0afea0b23), {
                trigger: resolvedTriggerMode,
                triggerProps: triggerProps
            }, children)
    })))));
}
function $082089d6a39bcf3b$var$UserProfileCardPopupWithAnalytics({ PopupTriggerWithHover: PopupTriggerWithHover, entryPointParams: entryPointParams, entryPointProps: entryPointProps, placement: placement, shouldRenderToParent: shouldRenderToParent, triggerMode: triggerMode, errorFallback: errorFallback, onTriggerMethodChange: onTriggerMethodChange, trigger: trigger }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { markInteractionStart: markInteractionStart } = (0, $8en9F.useCardOpenTimer)();
    const fireTriggeredRequest = (0, $e8zaz.useFireTriggeredRequest)();
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        // t=0 for all downstream `duration` measurements.
        markInteractionStart();
        onTriggerMethodChange(method);
        // `method` is attached inline because the context update from
        // `onTriggerMethodChange` has not propagated yet at this exact moment.
        fireEvent('ui.profilecard.triggered', {
            firedAt: (0, $6er8q.firedAt)(),
            method: method
        });
        fireTriggeredRequest();
    }, [
        fireEvent,
        fireTriggeredRequest,
        markInteractionStart,
        onTriggerMethodChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopupTriggerWithHover, {
        entryPoint: (0, $oZBat.entryPoint),
        placement: placement,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), {
            testId: entryPointProps.testId ?? ''
        }),
        errorFallback: errorFallback,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        shouldRenderToParent: shouldRenderToParent,
        shouldUseCaptureOnOutsideClick: true,
        triggerMode: triggerMode,
        onOpen: handleOpen,
        trigger: trigger
    });
}
module.exports["UserProfileCardWithTrigger"] = $082089d6a39bcf3b$export$74fa5d03ff375804;

});

parcelRegister("fRJCL", function(module, exports) {
const $fc9bc55d1493f9f0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $fc9bc55d1493f9f0$var$performanceAvailable = $fc9bc55d1493f9f0$var$isPerformanceAvailable();
const $fc9bc55d1493f9f0$var$initialPageTime = Date.now();
const $fc9bc55d1493f9f0$export$e9faea7c41053334 = ()=>{
    if ($fc9bc55d1493f9f0$var$performanceAvailable) return performance.now();
    return Date.now() - $fc9bc55d1493f9f0$var$initialPageTime;
};
module.exports["getPageTime"] = $fc9bc55d1493f9f0$export$e9faea7c41053334;

});

parcelRegister("oZBat", function(module, exports) {

var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $li1Tx = parcelRequire("li1Tx");


var $3Gey6 = parcelRequire("3Gey6");

const $482a141e4af62e04$var$fetchPolicy = 'store-or-network';

const $482a141e4af62e04$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("4G9a0")), {
        moduleId: "0e8b22f8",
        moduleName: "UserProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'user-profile-card-entrypoint'
    }),
    getPreloadProps: ({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId })=>{
        const variables = (0, $li1Tx.buildQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        return {
            queries: {
                queryRef: {
                    parameters: $3Gey6.default,
                    variables: variables,
                    options: {
                        fetchPolicy: $482a141e4af62e04$var$fetchPolicy
                    }
                }
            }
        };
    }
});
module.exports["entryPoint"] = $482a141e4af62e04$export$6333901e831d7af0;

});

parcelRegister("li1Tx", function(module, exports) {
/**
 * @generated SignedSource<<5c3abe0d7fc1d72c780bb9468140ef6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b4c1c775549c8b5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userIdString"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewerId"
            }
        ],
        "kind": "Fragment",
        "name": "UserProfileCardRelay_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "email"
                            },
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "department"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "location"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "organization"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appType"
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "activity",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "actors.0",
                                                "variableName": "userAri"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "actors"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 3
                            }
                        ],
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "workedOn",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ActivityItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ActivityNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "ActivityObject",
                                                "kind": "LinkedField",
                                                "name": "object",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluencePageLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluencePage"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceBlogPostLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceBlogPost"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceWhiteboardLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceWhiteboard"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "webUrl"
                                                                    }
                                                                ],
                                                                "type": "JiraIssue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    }
                                                                ],
                                                                "type": "ExternalDocument"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "href"
                                                                    }
                                                                ],
                                                                "type": "BitbucketPullRequest"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "alias": "loomUrl",
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    }
                                                                ],
                                                                "type": "LoomVideo"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "KnowledgeDiscoveryQueryApi",
                "kind": "LinkedField",
                "name": "knowledgeDiscovery",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "accountId",
                                "variableName": "userIdString"
                            },
                            {
                                "kind": "Variable",
                                "name": "orgId",
                                "variableName": "orgId"
                            },
                            {
                                "kind": "Variable",
                                "name": "requestingUserId",
                                "variableName": "viewerId"
                            },
                            {
                                "kind": "Variable",
                                "name": "tenantId",
                                "variableName": "cloudId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "singleUser",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "KnowledgeDiscoveryUserProfile",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "KnowledgeDiscoveryUserManager",
                                                "kind": "LinkedField",
                                                "name": "manager",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    v2 /*: any*/ ,
                                                    v1 /*: any*/ ,
                                                    v0 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyIntegrations",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "externalId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "integrationId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "product"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "KnowledgeDiscoverySingleUser"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$5b4c1c775549c8b5$var$node.hash = "0c1c29212a450e30cc5095a7c759b086";
var $5b4c1c775549c8b5$export$2e2bcd8739ae039 = $5b4c1c775549c8b5$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");








var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $3nj6t = parcelRequire("3nj6t");


var $igNBm = parcelRequire("igNBm");


var $iNxjP = parcelRequire("iNxjP");


var $48FEk = parcelRequire("48FEk");

function $adfe7afae3eb554e$var$AgentCardRelay({ accountId: accountId, cloudId: cloudId, hideStarButton: hideStarButton, hideConversationStarters: hideConversationStarters, onChatClick: onChatClick, onConversationStartersClick: onConversationStartersClick, onViewProfile: onViewProfile, onDuplicate: onDuplicate, onCopyLink: onCopyLink, onEdit: onEdit, onDeleteAgent: onDeleteAgent, renderCTA: renderCTA, renderMoreActions: renderMoreActions }) {
    const environment = (0, $irOoi.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const entryPointReference = (0, $42omo.useMemo)(()=>(0, $irOoi.loadEntryPoint)({
            getEnvironment: ()=>environment
        }, (0, $igNBm.agentProfileCardEntryPoint), {
            identityAccountId: accountId,
            cloudId: cloudId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        accountId,
        cloudId
    ]);
    const handleConversationStarterClick = (0, $42omo.useMemo)(()=>(prompt)=>onConversationStartersClick?.({
                message: prompt,
                type: 'static'
            }), [
        onConversationStartersClick
    ]);
    const handleDelete = (0, $42omo.useMemo)(()=>onDeleteAgent ? (agentId)=>{
            onDeleteAgent(agentId);
        } : undefined, [
        onDeleteAgent
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'mounted',
            actionSubject: 'agentCardRelay',
            eventType: 'operational',
            attributes: {
                source: 'agentCard'
            }
        }).fire();
        return ()=>{
            entryPointReference.dispose?.();
        };
    }, [
        entryPointReference,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNxjP.AgentProfileCardSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
        id: "agent-profile-card",
        entryPointReference: entryPointReference,
        runtimeProps: {
            cloudId: cloudId,
            identityAccountId: accountId,
            hideStarButton: hideStarButton,
            hideConversationStarters: hideConversationStarters,
            onChatClick: onChatClick,
            onConversationStarterClick: handleConversationStarterClick,
            onViewProfile: onViewProfile,
            onDuplicate: onDuplicate,
            onCopyLink: onCopyLink,
            onEdit: onEdit,
            onDelete: handleDelete,
            renderCTA: renderCTA,
            renderMoreActions: renderMoreActions
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNxjP.AgentProfileCardSkeleton), null)
    }));
}
function $adfe7afae3eb554e$export$4bb3d93416a668a2(props) {
    if ((0, $dh538.fg)('rovo_agent_profile_card_relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($adfe7afae3eb554e$var$AgentCardRelay, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3nj6t.AgentProfileCardResourced), props);
}



var $4dNEc = parcelRequire("4dNEc");


var $kGcl2 = parcelRequire("kGcl2");

/* UserProfileCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lAJUP = parcelRequire("lAJUP");


var $esRft = parcelRequire("esRft");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $O1c6O = parcelRequire("O1c6O");

var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $e8zaz = parcelRequire("e8zaz");


var $ay6Zz = parcelRequire("ay6Zz");


var $39XmP = parcelRequire("39XmP");




const $6bf30137358d95af$export$2b163c291f77b3f9 = (bridge, url, app)=>{
    const sourceApp = app ?? 'teams';
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: sourceApp
    });
    const isCrossAppMauEnabled = (0, $dh538.fg)('townsquare_teams_cross_app_mau');
    return app !== undefined && app !== 'teams' && isCrossAppMauEnabled ? buildUrlWithAnalyticsParams(url) : url;
};


const $2330b985c14490d3$var$shouldOpenInSameTab = (townsquareApp)=>townsquareApp === 'teams' || townsquareApp === 'teams-isolated';
const $2330b985c14490d3$export$a3989301a7f69ed7 = (userId, cloudId, townsquareApp)=>{
    const { href: rawHref, target: target, onNavigate: onNavigate } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        shouldOpenInSameTab: $2330b985c14490d3$var$shouldOpenInSameTab(townsquareApp)
    });
    // When no townsquareApp is provided, fall back to `'teams'` for the bridge string so
    // the analytics tag is always a real app name, never the literal `"undefined-customLink"`.
    const bridgeApp = townsquareApp ?? 'teams';
    const wrappedHref = (0, $6bf30137358d95af$export$2b163c291f77b3f9)(`${bridgeApp}-customLink`, rawHref, townsquareApp);
    const href = townsquareApp ? wrappedHref : rawHref;
    const isCrossAppMauGateEnabled = Boolean(townsquareApp) && href !== rawHref;
    return {
        href: href,
        target: target,
        onNavigate: onNavigate,
        isCrossAppMauGateEnabled: isCrossAppMauGateEnabled
    };
};



var $8en9F = parcelRequire("8en9F");


var $ikcEb = parcelRequire("ikcEb");

/** Appends `/work` to a profile URL, preserving any querystring. */ function $79f60994b4f870f3$export$f339ec3b489d28e5(href) {
    if (!href) return href;
    const [pathPart, queryPart] = href.split('?');
    const normalisedPath = pathPart.endsWith('/') ? `${pathPart}work` : `${pathPart}/work`;
    return queryPart === undefined ? normalisedPath : `${normalisedPath}?${queryPart}`;
}



var $cptht = parcelRequire("cptht");
















function $3bc9bd20d6342f7c$export$2ebec9f03312245c({ testId: testId, errorType: errorType }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $6er8q.firedAt)(),
            errorType: errorType,
            hasRetry: false
        });
    }, [
        fireEvent,
        errorType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
        testId: testId
    });
}



var $2205s = parcelRequire("2205s");





var $aXWIB = parcelRequire("aXWIB");


var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");














var $4asqm = parcelRequire("4asqm");




const $b85f75bd737ae266$export$c7eac394c4a88aeb = (townsquareApp)=>{
    // `fireCustomCrossAppAnalytic` needs raw `createAnalyticsEvent`, so this hook
    // intentionally owns the `@atlaskit/analytics-next` dependency.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)(()=>{
        if (!townsquareApp) return;
        (0, $4asqm.fireCustomCrossAppAnalytic)({
            tags: [
                'townsquare',
                'navigationExperiences'
            ],
            analyticsEventFireName: 'atlas',
            destinationApp: 'teams',
            bridge: `${townsquareApp}-customLink`,
            source: `townsquare-${townsquareApp}`,
            actionSubjectId: 'viewProfileLink',
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        townsquareApp,
        createAnalyticsEvent
    ]);
};












function $0caf0847675e2133$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
        fill: "#ECB22E"
    })));
}
function $0caf0847675e2133$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
        fill: "white"
    }));
}


const $dfc29d480e8ab830$export$ebea5317ff1808bf = {
    slack: (0, $0caf0847675e2133$export$b33fb54b08bb6422),
    teams: (0, $0caf0847675e2133$export$1bcbc9c337da86da)
};
function $dfc29d480e8ab830$export$5a867b7c6687d757(integration) {
    return $dfc29d480e8ab830$export$ebea5317ff1808bf[integration];
}


const $06891aee358a4255$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'slack';
    const isMsTeams = integrationId === 'teams';
    if (isSlack) {
        const openDmUrl = $06891aee358a4255$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $06891aee358a4255$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'teams',
            openDmUrl: openDmUrl
        };
    }
};
const $06891aee358a4255$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $06891aee358a4255$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};


const $1541e528197b85f3$var$normalizeProductKey = (product)=>product.trim().toLowerCase();
/**
 * Keeps the first row for each `product` (case-insensitive). Order matches the input array.
 */ function $1541e528197b85f3$var$uniqueRowsByFirstOccurrence(integrations = []) {
    const seen = new Set();
    const out = [];
    for (const row of integrations){
        const key = $1541e528197b85f3$var$normalizeProductKey(row.product);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(row);
    }
    return out;
}
const $1541e528197b85f3$export$cf50127c50537c52 = [
    'slack',
    'teams'
];
function $1541e528197b85f3$export$523ecfa1815bea06(integrations, email, integrationIdOrder = $1541e528197b85f3$export$cf50127c50537c52) {
    const rows = $1541e528197b85f3$var$uniqueRowsByFirstOccurrence(integrations ? [
        ...integrations
    ] : []);
    for (const id of integrationIdOrder){
        const row = rows.find((r)=>r.integrationId === id);
        if (!row) continue;
        const entry = {
            email: email,
            externalId: row.externalId,
            integrationId: row.integrationId,
            product: row.product
        };
        const dm = (0, $06891aee358a4255$export$596e547f4ce626bc)(row.integrationId, {
            email: entry.email,
            externalId: entry.externalId
        });
        if (dm) return {
            entry: entry,
            dm: dm
        };
    }
    return undefined;
}









var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $56M4r = parcelRequire("56M4r");


var $cGtPE = parcelRequire("cGtPE");


var $2SlZp = parcelRequire("2SlZp");


var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");





var $g5lKx = parcelRequire("g5lKx");










const $6e668c4e51010df5$var$messages = (0, $aXWIB.defineMessages)({
    actionMenuLabel: {
        id: "user-profile-card.ActionMenu.actionMenuLabel",
        defaultMessage: "More actions for {name}"
    }
});
function $6e668c4e51010df5$export$ed57a210b9d13bb6({ items: items, name: name }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isOpen, setOpen] = (0, $42omo.useState)(false);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const { getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    // Stable callbacks so the inner `Popup` and `IconButton` don't see prop churn each render.
    const handleClose = (0, $42omo.useCallback)(()=>setOpen(false), []);
    const handleTriggerClick = (0, $42omo.useCallback)(()=>setOpen((open)=>!open), []);
    const fireActionClick = (0, $42omo.useCallback)((itemId, hasHref, hasOnClick, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: hasHref,
            hasOnClick: hasOnClick,
            index: index,
            actionId: itemId
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    if (items.length === 0) return null;
    const renderItem = (item, index)=>{
        if (item.kind === 'link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            key: item.id,
            href: item.href,
            target: item.target,
            rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, true, Boolean(item.onClick), index);
                item.onClick?.(event);
                setOpen(false);
            }
        }, item.label);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            key: item.id,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, false, true, index);
                item.onClick(event);
                setOpen(false);
            }
        }, item.label);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "right-start",
        // The host card sits at `layers.modal()` (510) — use `layers.tooltip()` (700) so the
        // action-menu popup stacks above it. `tooltip()` is the conventional next-layer-up in
        // ADS and is forward-compatible with the upcoming top-layer popup mode.
        zIndex: (0, $g5lKx.layers).tooltip(),
        testId: getTestId('action-menu'),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
                spacing: "cozy"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, items.map(renderItem))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: formatMessage($6e668c4e51010df5$var$messages.actionMenuLabel, {
                    name: name
                }),
                onClick: handleTriggerClick,
                isSelected: isOpen,
                testId: getTestId('action-menu-trigger')
            })
    });
}









var $dedJV = parcelRequire("dedJV");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");

const $6413a854ff78a350$var$messages = (0, $aXWIB.defineMessages)({
    giveKudosLabel: {
        id: "user-profile-card.useKudosMenuItem.giveKudosLabel",
        defaultMessage: "Give kudos"
    }
});
/**
 * Stable analytics source attributed to kudos drawer events fired from this card.
 */ const $6413a854ff78a350$var$ANALYTICS_SOURCE = 'user-profile-card';
function $6413a854ff78a350$export$e739febab83b2399({ accountId: accountId, cloudId: cloudId, viewerId: viewerId }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const onOpen = (0, $42omo.useCallback)(()=>setIsOpen(true), []);
    const recipient = (0, $42omo.useMemo)(()=>({
            type: (0, $9EUfN.KudosType).INDIVIDUAL,
            recipientId: accountId
        }), [
        accountId
    ]);
    const label = formatMessage($6413a854ff78a350$var$messages.giveKudosLabel);
    const menuItem = (0, $42omo.useMemo)(()=>({
            kind: 'button',
            id: 'give-kudos',
            label: label,
            onClick: onOpen
        }), [
        label,
        onOpen
    ]);
    const teamCentralBaseUrl = (0, $dedJV.getATLContextUrl)('home');
    const suppressed = !teamCentralBaseUrl || !!viewerId && viewerId === accountId;
    if (suppressed) return {
        menuItem: null,
        launcher: null
    };
    const launcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iK7QL.GiveKudosLauncherLazy), {
        isOpen: isOpen,
        onClose: onClose,
        recipient: recipient,
        analyticsSource: $6413a854ff78a350$var$ANALYTICS_SOURCE,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId
    }));
    return {
        menuItem: menuItem,
        launcher: launcher
    };
}


const $dd80962e40f8ea2d$var$messages = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "user-profile-card.action-bar.view-profile",
        defaultMessage: "View profile"
    },
    sendMessageLabel: {
        id: "user-profile-card.action-bar.send-message-label",
        defaultMessage: "Message"
    }
});
function $dd80962e40f8ea2d$export$223875819fd7cf93({ profileData: profileData, cloudId: cloudId, actions: actions, viewerId: viewerId }) {
    const intl = (0, $aXWIB.useIntl)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const { townsquareApp: townsquareApp, onProfileClick: onProfileClick, getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const { accountId: accountId, thirdPartyIntegrations: thirdPartyIntegrations, email: email } = profileData;
    const { href: href, target: target, onNavigate: onNavigate, isCrossAppMauGateEnabled: isCrossAppMauGateEnabled } = (0, $2330b985c14490d3$export$a3989301a7f69ed7)(accountId, cloudId, townsquareApp);
    const fireCrossAppProfileAnalytic = (0, $b85f75bd737ae266$export$c7eac394c4a88aeb)(townsquareApp);
    const externalMessage = (0, $42omo.useMemo)(()=>(0, $1541e528197b85f3$export$523ecfa1815bea06)(thirdPartyIntegrations, email), [
        email,
        thirdPartyIntegrations
    ]);
    const handleThirdPartyMessageClick = (0, $42omo.useCallback)(()=>{
        // Reuse the existing `@atlaskit/profilecard` clicked.action event so the SLO dashboards
        // see a single click-event surface for both profile-card packages. `index` and `hasOnClick`
        // are required by that schema but are not meaningful for user-profile-card actions, so we
        // always send `index: 0` and `hasOnClick: true`.
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(externalMessage?.dm.openDmUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'thirdPartyMessage'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        externalMessage
    ]);
    const handleViewProfileClick = (0, $42omo.useCallback)((event)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(href),
            hasOnClick: true,
            index: 0,
            actionId: 'viewProfile'
        });
        if (isCrossAppMauGateEnabled) fireCrossAppProfileAnalytic();
        onProfileClick?.(accountId);
        onNavigate?.(event);
    }, [
        fireEvent,
        getDurationSinceInteraction,
        href,
        onNavigate,
        onProfileClick,
        isCrossAppMauGateEnabled,
        fireCrossAppProfileAnalytic,
        accountId
    ]);
    const menuItems = (0, $42omo.useMemo)(()=>{
        const visible = (actions ?? []).filter((action)=>!action.shouldRender || action.shouldRender(profileData));
        return visible.map((action, index)=>{
            const id = action.id ?? `action-${index}`;
            if (action.link) return {
                kind: 'link',
                id: id,
                label: action.label,
                href: action.link,
                target: action.target,
                onClick: action.callback ? (event, ...args)=>{
                    const isBasicClick = !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
                    if (isBasicClick) {
                        event.preventDefault();
                        action.callback?.(event, ...args);
                    }
                } : undefined
            };
            return {
                kind: 'button',
                id: id,
                label: action.label,
                onClick: (event, ...args)=>action.callback?.(event, ...args)
            };
        });
    }, [
        actions,
        profileData
    ]);
    const { menuItem: kudosMenuItem, launcher: kudosLauncher } = (0, $6413a854ff78a350$export$e739febab83b2399)({
        accountId: accountId,
        cloudId: cloudId,
        viewerId: viewerId
    });
    const allMenuItems = (0, $42omo.useMemo)(()=>kudosMenuItem ? [
            ...menuItems,
            kudosMenuItem
        ] : menuItems, [
        menuItems,
        kudosMenuItem
    ]);
    const hasActionMenu = allMenuItems.length > 0;
    // Without an accountId there is nothing to show. We allow rendering when there is no profile
    // link as long as the action menu has content - so consumers using the card without Teams
    // navigation can still surface custom actions / kudos.
    if (!accountId || !href && !hasActionMenu) return null;
    const inline = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, externalMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
        href: externalMessage.dm.openDmUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleThirdPartyMessageClick,
        icon: (0, $dfc29d480e8ab830$export$5a867b7c6687d757)(externalMessage.dm.integration),
        label: intl.formatMessage($dd80962e40f8ea2d$var$messages.sendMessageLabel),
        isTooltipDisabled: false
    }), accountId && href && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: href,
        appearance: "default",
        target: target,
        onClick: handleViewProfileClick,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: getTestId('view-profile-button')
    }, intl.formatMessage($dd80962e40f8ea2d$var$messages.viewProfile)), hasActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e668c4e51010df5$export$ed57a210b9d13bb6), {
        items: allMenuItems,
        name: profileData.name
    }));
    // When there's no kudos launcher to portal-mount, return the bare `<Inline>` element so that
    // callers which expected the legacy single-element return tree continue to see one node (and
    // no extra fragment wrapper). The fragment form is only used when we actually need to render
    // the launcher sibling.
    if (!kudosLauncher) return inline;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, inline, kudosLauncher);
}





















const $c052bc18bed19d18$var$messages = (0, $aXWIB.defineMessages)({
    managerHeading: {
        id: "user-profile-card.ManagerSection.managerHeading",
        defaultMessage: "Manager"
    }
});
function $c052bc18bed19d18$export$2992b481dad9fb03({ manager: manager }) {
    const intl = (0, $aXWIB.useIntl)();
    const { getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const { name: name, avatarUrl: avatarUrl, jobTitle: jobTitle } = manager;
    if (!name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075",
        testId: getTestId('manager')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        weight: "medium",
        size: "small",
        color: "color.text"
    }, intl.formatMessage($c052bc18bed19d18$var$messages.managerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        maxLines: 1
    }, name), jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, jobTitle))));
}
















var $cBiyA = parcelRequire("cBiyA");

const $a453294bcbadcae5$var$messages = (0, $aXWIB.defineMessages)({
    recentWorkHeading: {
        id: "user-profile-card.recent-work.heading",
        defaultMessage: "Recent work"
    }
});
function $a453294bcbadcae5$export$5981f4ad4928b105({ recentWorkData: recentWorkData, testId: testId, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick }) {
    const intl = (0, $aXWIB.useIntl)();
    if (recentWorkData.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        weight: "medium",
        size: "small",
        color: "color.text"
    }, intl.formatMessage($a453294bcbadcae5$var$messages.recentWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBiyA.LinkList), {
        urls: recentWorkData,
        size: "compact",
        maxSources: 3,
        showExpand: false,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick
    })));
}


const $4cba81a0340423db$var$styles = {
    root: "_1bsb1gwv _1ul95x59 _80om73ad _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhkhp5a"
}; /**
    * Presentational profile card displaying a user's core information and recent work.
    * Renders avatar, name, pronouns, job title, department, location, manager, and recent-work items.
    *
    * Shows a loading skeleton when `isLoading` is true or `profileData` is undefined.
    * Displays an error state when profile data is missing or `name` is not provided.
    *
    * Recent-work previews require a `SmartCardProvider` from `@atlaskit/link-provider`
    * in scope (already provided by every Atlassian product shell).
    */ 
function $4cba81a0340423db$export$7bf40cd2a197df2d({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading = false, testId: testId = 'user-profile-card', cloudId: cloudId, error: error, actions: actions, viewerId: viewerId }) {
    const outerContext = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const userId = profileData?.accountId ?? '';
    const localGetTestId = (0, $42omo.useMemo)(()=>(0, $cptht.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]); // Forward outer values so trigger-wrapped + standalone consumers see the same shape;
    // fall back to a local getTestId factory when there is no outer provider.
    const contextValue = (0, $42omo.useMemo)(()=>({
            ...outerContext,
            cloudId: cloudId,
            getTestId: outerContext.getTestId !== (0, $ikcEb.defaultGetTestId) ? outerContext.getTestId : localGetTestId
        }), [
        cloudId,
        localGetTestId,
        outerContext
    ]);
    const analyticsData = {
        source: 'userProfileCard',
        attributes: {
            cloudId: cloudId,
            userId: userId,
            hasManager: Boolean(profileData?.manager),
            hasRecentWork: Boolean(recentWorkData?.length),
            hasThirdPartyIntegrations: Boolean(profileData?.thirdPartyIntegrations?.length)
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $O1c6O.TeamsAppAnalyticsContext), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikcEb.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8en9F.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardErrorBoundary, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        isLoading: isLoading,
        testId: testId,
        cloudId: cloudId,
        error: error,
        actions: actions,
        viewerId: viewerId
    })))));
}
function $4cba81a0340423db$var$UserProfileCardErrorBoundary({ children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleError = (0, $42omo.useCallback)((_error)=>{
        // `default` (not `renderError`) - schema only allows `default | NotFound`.
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $6er8q.firedAt)(),
            errorType: 'default',
            hasRetry: false
        });
    }, [
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: handleError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        })
    }, children);
}
function $4cba81a0340423db$var$UserProfileCardContent({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading, testId: testId, cloudId: cloudId, error: error, actions: actions, viewerId: viewerId }) {
    const { getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const hasProfileData = Boolean(profileData && profileData.name);
    (0, $e8zaz.useFireRequestSucceeded)(!isLoading && hasProfileData);
    (0, $e8zaz.useFireRequestFailed)(!isLoading && !hasProfileData ? error ?? null : undefined);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), {
        testId: testId
    });
    if (!profileData || !profileData.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bc9bd20d6342f7c$export$2ebec9f03312245c), {
        testId: testId,
        errorType: "NotFound"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardRenderedContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        testId: testId,
        cloudId: cloudId,
        getTestId: getTestId,
        actions: actions,
        viewerId: viewerId
    });
} // Success-only render. Split out so `useFireContentRendered` mounts (and fires)
// only when the user actually sees the content - not on loading or error.
function $4cba81a0340423db$var$UserProfileCardRenderedContent({ profileData: profileData, recentWorkData: recentWorkData, testId: testId, cloudId: cloudId, getTestId: getTestId, actions: actions, viewerId: viewerId }) {
    (0, $e8zaz.useFireContentRendered)(profileData);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const { townsquareApp: townsquareApp } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const { href: profileHref } = (0, $2330b985c14490d3$export$a3989301a7f69ed7)(profileData.accountId, cloudId, townsquareApp);
    const viewAllUrl = (0, $79f60994b4f870f3$export$f339ec3b489d28e5)(profileHref);
    const handleRecentWorkViewAllClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(viewAllUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'recentWorkViewAll'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        viewAllUrl
    ]);
    const { name: name, pronouns: pronouns, avatarUrl: avatarUrl, jobTitle: jobTitle, department: department, location: location, localTime: localTime, manager: manager } = profileData;
    const subtitleParts = [
        jobTitle,
        department
    ].filter(Boolean);
    const subtitle = subtitleParts.join(` \u2022 `);
    const locationLine = localTime && location ? `${location} \u2013 ${localTime}` : location ?? undefined;
    const hasRecentWork = Boolean(recentWorkData?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4cba81a0340423db$var$styles.root,
        testId: testId,
        role: "region",
        "aria-label": name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150",
        testId: "profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "xlarge",
        testId: getTestId('avatar')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd80962e40f8ea2d$export$223875819fd7cf93), {
        profileData: profileData,
        cloudId: cloudId,
        actions: actions,
        viewerId: viewerId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "medium",
        testId: getTestId('name')
    }, name), pronouns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('pronouns')
    }, pronouns)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('subtitle')
    }, subtitle), locationLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 1,
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('location')
    }, locationLine))), manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c052bc18bed19d18$export$2992b481dad9fb03), {
        manager: manager
    }), hasRecentWork && recentWorkData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a453294bcbadcae5$export$5981f4ad4928b105), {
        recentWorkData: recentWorkData,
        testId: getTestId('recent-work'),
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: handleRecentWorkViewAllClick
    })));
}


/**
 * Renders a user profile card from a Relay fragment.
 *
 * The fragment is colocated: it contains the user's base profile (name, avatar,
 * email, extendedProfile) and the supplemental data (manager, third-party
 * integrations, recent work) in one spread, so everything fetches in a single
 * round-trip.
 *
 * Recent-work previews need a `SmartCardProvider` from `@atlaskit/link-provider`
 * in scope. Atlassian product shells provide this by default.
 *
 * @example
 * ```tsx
 * const data = useLazyLoadQuery<MyQuery>(
 *   graphql`
 *     query MyQuery($userId: ID!, $cloudId: String!, $orgId: String!, $viewerId: String!) {
 *       ...UserProfileCardRelay_query @arguments(
 *         userId: $userId, cloudId: $cloudId, orgId: $orgId, viewerId: $viewerId
 *       )
 *     }
 *   `,
 *   buildQueryVariables({ userId, cloudId, orgId, viewerId }),
 * );
 * return <UserProfileCardRelay queryFragment={data} cloudId={cloudId} />;
 * ```
 */ function $30359ad292ebe595$export$8d4b90914bf8e85e({ queryFragment: queryFragment, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent, actions: actions, viewerId: viewerId }) {
    const data = (0, $irOoi.useFragment)((0, $5b4c1c775549c8b5$export$2e2bcd8739ae039), queryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30359ad292ebe595$var$UserProfileCardRelayContent, {
        data: data,
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        agent: agent,
        actions: actions,
        viewerId: viewerId
    });
}
function $30359ad292ebe595$var$UserProfileCardRelayContent({ data: data, cloudId: cloudId, testId: testId, isLoading: isLoading, agent: agent, actions: actions, viewerId: viewerId }) {
    const user = data.user;
    const accountId = user?.accountId ?? '';
    const rawSingleUser = data.knowledgeDiscovery?.singleUser;
    const knowledgeSingleUser = rawSingleUser && 'user' in rawSingleUser ? rawSingleUser : null;
    const rawManager = knowledgeSingleUser?.user?.manager;
    const recentWorkData = (0, $42omo.useMemo)(()=>{
        const edges = data.activity?.workedOn?.edges ?? [];
        const urls = edges.flatMap((edge)=>{
            const objectData = edge?.node?.object?.data;
            if (!objectData) return [];
            switch(objectData.__typename){
                case 'ConfluencePage':
                case 'ConfluenceBlogPost':
                case 'ConfluenceWhiteboard':
                    return objectData.links?.base && objectData.links?.webUi ? [
                        `${objectData.links.base}${objectData.links.webUi}`
                    ] : [];
                case 'JiraIssue':
                    return objectData.webUrl ? [
                        objectData.webUrl
                    ] : [];
                case 'ExternalDocument':
                    return objectData.url ? [
                        objectData.url
                    ] : [];
                case 'BitbucketPullRequest':
                    return objectData.href ? [
                        objectData.href
                    ] : [];
                case 'LoomVideo':
                    return objectData.loomUrl ? [
                        objectData.loomUrl
                    ] : [];
                default:
                    return [];
            }
        });
        return urls.length ? urls : undefined;
    }, [
        data.activity?.workedOn?.edges
    ]);
    const appType = user && 'appType' in user ? user.appType : null;
    const isAgent = typeof appType === 'string' && appType.toLowerCase() === 'agent';
    const profileData = (0, $42omo.useMemo)(()=>{
        if (!user || isAgent) return null;
        const knowledge = knowledgeSingleUser?.user;
        const manager = rawManager?.id ? {
            id: rawManager.id,
            name: rawManager.name,
            avatarUrl: rawManager.picture,
            jobTitle: rawManager.jobTitle
        } : null;
        const thirdPartyIntegrations = knowledge?.thirdPartyIntegrations?.filter((integration)=>Boolean(integration?.externalId && integration?.integrationId && integration?.product)).map((integration)=>({
                externalId: integration.externalId,
                integrationId: integration.integrationId,
                product: integration.product
            }));
        return {
            accountId: user.accountId,
            name: user.name ?? '',
            avatarUrl: user.picture,
            email: user.email,
            jobTitle: user.extendedProfile?.jobTitle,
            department: user.extendedProfile?.department,
            location: user.extendedProfile?.location,
            organization: user.extendedProfile?.organization,
            manager: manager,
            thirdPartyIntegrations: thirdPartyIntegrations?.length ? thirdPartyIntegrations : null
        };
    }, [
        user,
        isAgent,
        knowledgeSingleUser,
        rawManager
    ]);
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
        testId: testId
    });
    if (isAgent) {
        if (!agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $adfe7afae3eb554e$export$4bb3d93416a668a2), {
            ...agent,
            accountId: accountId,
            cloudId: cloudId
        }));
    }
    if (!profileData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4cba81a0340423db$export$7bf40cd2a197df2d), {
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        profileData: profileData,
        recentWorkData: recentWorkData,
        actions: actions,
        viewerId: viewerId
    }));
}
function $30359ad292ebe595$export$9a3cee82e7cc08ff({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId }) {
    return {
        userId: userId,
        userIdString: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        userAri: `ari:cloud:identity::user/${userId}`
    };
}
module.exports["UserProfileCardRelay"] = $30359ad292ebe595$export$8d4b90914bf8e85e;
module.exports["buildQueryVariables"] = $30359ad292ebe595$export$9a3cee82e7cc08ff;

});

parcelRegister("igNBm", function(module, exports) {

var $l6rYU = parcelRequire("l6rYU");


var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $gWpWO = parcelRequire("gWpWO");

function $7167b4a229648a7c$var$resolveQueryVariables(params) {
    if ('identityAccountId' in params) return {
        agentAri: '',
        identityAccountId: params.identityAccountId,
        cloudId: params.cloudId,
        fetchByIdentity: true
    };
    const agentAri = 'agentAri' in params ? params.agentAri : (0, $l6rYU.RovoAgentAri).create({
        activationId: params.activationId,
        agentId: params.agentId
    }).toString();
    return {
        agentAri: agentAri,
        identityAccountId: '',
        cloudId: '',
        fetchByIdentity: false
    };
}

const $7167b4a229648a7c$export$cf39f5e5e131a6dd = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("7YD42")), {
        moduleId: "dc6e5a58",
        moduleName: "AgentProfileCardContainer",
        priority: "interaction",
        moduleId: 'conversation-assistant-agent_agent-profile-card'
    }),
    getPreloadProps: (params)=>{
        const queryVariables = $7167b4a229648a7c$var$resolveQueryVariables(params);
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $gWpWO.default),
                    variables: queryVariables,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $7167b4a229648a7c$export$cf39f5e5e131a6dd;

});

parcelRegister("l6rYU", function(module, exports) {
// src/rovo/agent/types.ts
var $128cd896b475733b$export$474f4563a5282a33 = "rovo", $128cd896b475733b$export$541c04ced4758f83 = "agent";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/rovo/agent/manifest.ts
var $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $128cd896b475733b$export$474f4563a5282a33),
    resourceType: (0, $128cd896b475733b$export$541c04ced4758f83),
    resourceIdSlug: "activation/{activationId}/{agentId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        agentId: /[a-zA-Z0-9\-]+/
    }
};
// src/rovo/agent/index.ts
var $f5cfdd076f0f6834$export$eaa394a67f27c50 = class _RovoAgentAri extends (0, $3NXcb.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get agentId() {
        return this._agentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts.qualifier,
            platformQualifier: $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts.resourceOwner,
            resourceType: $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.agentId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                agentId: opts.agentId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f5cfdd076f0f6834$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            agentId: this.agentId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._agentId = opts.resourceIdSegmentValues.agentId;
    }
};
module.exports["RovoAgentAri"] = $f5cfdd076f0f6834$export$eaa394a67f27c50;

});

parcelRegister("gWpWO", function(module, exports) {
/**
 * @generated SignedSource<<44c292346f22c43228b71daa22e1bc4d>>
 * @relayHash 89c3db6f08f38ab8e7c0f8ff0efa27d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da
const $f8a873f9b6404900$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "AgentProfileCard_agentRef"
                            }
                        ],
                        "type": "AgentStudioAssistant"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "AgentProfileCard_agentRef"
                }
            ],
            "type": "AgentStudioAssistant"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountStatus"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "profileUrl"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "AgentStudioAgentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canDelete"
                        }
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da",
            "metadata": {},
            "name": "AgentProfileCardContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f8a873f9b6404900$var$node.hash = "7f56b7d6645b9220c953a6792948a3ba";
var $f8a873f9b6404900$export$2e2bcd8739ae039 = $f8a873f9b6404900$var$node;
module.exports["default"] = $f8a873f9b6404900$export$2e2bcd8739ae039;

});

parcelRegister("7YD42", function(module, exports) {

let $5cec7051ceaa9986$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5cec7051ceaa9986$var$load("f4xGT"),
    $5cec7051ceaa9986$var$load("6wr18"),
    $5cec7051ceaa9986$var$load("3ezts"),
    $5cec7051ceaa9986$var$load("jbxHq"),
    $5cec7051ceaa9986$var$load("ffEVr"),
    $5cec7051ceaa9986$var$load("lVz7d"),
    $5cec7051ceaa9986$var$load("7EorR"),
    $5cec7051ceaa9986$var$load("aSL4q"),
    $5cec7051ceaa9986$var$load("hhss7"),
    $5cec7051ceaa9986$var$load("k2XsF")
]).then(()=>parcelRequire('jON2k'));

});

parcelRegister("iNxjP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");

const $8a855b028dcbeb43$var$styles = {
    card: "_2rko1mok _1reo15vq _18m915vq _1bsbnklw _bfhk1bhr",
    body: "_ca0qxy5q _19bvpxbi _u5f3pxbi _n3tdpxbi"
};
const $8a855b028dcbeb43$export$406245d651cacfa7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "96px",
            borderRadius: 0
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $8a855b028dcbeb43$var$styles.card
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $8a855b028dcbeb43$var$styles.body,
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "160px",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "120px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "48px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "32px"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $8a855b028dcbeb43$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "96px",
        borderRadius: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $8a855b028dcbeb43$var$styles.body,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "160px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "120px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "32px"
    })));
};
module.exports["AgentProfileCardSkeleton"] = $8a855b028dcbeb43$export$406245d651cacfa7;

});

parcelRegister("4dNEc", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kGcl2 = parcelRequire("kGcl2");

const $ffa90fd44525fb29$var$messages = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "user-profile-card.error.title",
        defaultMessage: "Something went wrong and we couldn't load this profile."
    },
    errorDescription: {
        id: "user-profile-card.error.description",
        defaultMessage: "Try again in a few moments."
    }
});
const $ffa90fd44525fb29$var$styles = {
    body: "_ca0q1ejb _n3td1ejb _19bv1ejb _u5f31ejb _y3gn1h6o"
}; /**
    * Error fallback when the entry point fails to render or profile data is missing.
    */ 
function $ffa90fd44525fb29$export$f7f7efdefcc02999({ testId: testId }) {
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        xcss: $ffa90fd44525fb29$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.subtlest"
    }, intl.formatMessage($ffa90fd44525fb29$var$messages.errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($ffa90fd44525fb29$var$messages.errorDescription)))));
}
module.exports["CardError"] = $ffa90fd44525fb29$export$f7f7efdefcc02999;

});

parcelRegister("2205s", function(module, exports) {
/* CardLoading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $e8zaz = parcelRequire("e8zaz");


var $kGcl2 = parcelRequire("kGcl2");

const $4749f8e69ede5bc2$var$styles = {
    inner: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    text: "_19pk12x7",
    fill: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    linkRow: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _1i531l7x _uwhke4h9 _15a5nqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    linkRowFirst: "_13li1qi0 _qrwq1qi0",
    linkRowLast: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0"
};
function $4749f8e69ede5bc2$var$HeaderSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "96px",
        height: "96px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "96px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150",
        xcss: $4749f8e69ede5bc2$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "45%",
        height: "20px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "80%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "50%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
}
function $4749f8e69ede5bc2$var$ManagerSectionSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "60px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "24px",
        height: "24px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050",
        xcss: $4749f8e69ede5bc2$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "45%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "65%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }))));
}
function $4749f8e69ede5bc2$var$LinkRowSkeleton({ first: first, last: last, titleWidth: titleWidth, subtitleWidth: subtitleWidth = '30%' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($4749f8e69ede5bc2$var$styles.linkRow, first && $4749f8e69ede5bc2$var$styles.linkRowFirst, last && $4749f8e69ede5bc2$var$styles.linkRowLast)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $4749f8e69ede5bc2$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "36px",
        height: "36px",
        borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $4749f8e69ede5bc2$var$styles.fill,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: titleWidth,
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: subtitleWidth,
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "32px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
}
function $4749f8e69ede5bc2$var$RecentWorkSectionSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "90px",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$LinkRowSkeleton, {
        first: true,
        titleWidth: "70%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$LinkRowSkeleton, {
        titleWidth: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$LinkRowSkeleton, {
        last: true,
        titleWidth: "65%"
    })));
} /**
   * Loading state shown while the profile card entry chunk resolves. Mirrors the
   * populated card layout:
   *
   * - Header: 96px avatar + action buttons (icon + "View profile") above the
   *   name + pronouns, subtitle (up to 2 lines), and location.
   * - Manager: heading + 24px avatar with name and job title lines.
   * - Recent work: heading + 3 bordered link rows that mirror the compact
   *   `LinkList` rendering used in `RecentWorkSection`.
   *
   * Keeping the skeleton shape close to the populated layout minimises the
   * perceived layout jump when data resolves. Fires `rendered.spinner` on mount
   * so the event only emits when the spinner is actually on screen.
   */ 
function $4749f8e69ede5bc2$export$5d25853fd6bdf402({ testId: testId }) {
    (0, $e8zaz.useFireRenderedSpinner)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        xcss: $4749f8e69ede5bc2$var$styles.inner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$HeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$ManagerSectionSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$RecentWorkSectionSkeleton, null))));
}
module.exports["CardLoading"] = $4749f8e69ede5bc2$export$5d25853fd6bdf402;

});

parcelRegister("cBiyA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7bZ3i = parcelRequire("7bZ3i");











var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kpYGL = parcelRequire("kpYGL");


var $hpUsb = parcelRequire("hpUsb");

var $5TXU5 = parcelRequire("5TXU5");

var $1lLfV = parcelRequire("1lLfV");

var $5znEc = parcelRequire("5znEc");

const $6b624b5882fc4b79$export$533f831a441a4b64 = 4;


const $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6 = (onLinkClick, url, idx)=>{
    if (!onLinkClick) return {
        onClick: undefined,
        onAuxClick: undefined,
        onContextMenu: undefined
    };
    return {
        onClick: ()=>onLinkClick(url, idx),
        onAuxClick: (e)=>{
            if (e.button === 1) onLinkClick(url, idx, {
                isAuxClick: true
            });
        },
        onContextMenu: (_e)=>onLinkClick(url, idx, {
                isContextMenu: true
            })
    };
};












var $2Nwuj = parcelRequire("2Nwuj");







const $742a27c74678daf7$export$fdef7686f3aefbe0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { urls: urls, onLinkClick: onLinkClick, testIdPrefix: testIdPrefix } = t0;
    let t1;
    if ($[0] !== onLinkClick || $[1] !== testIdPrefix || $[2] !== urls) {
        let t2;
        if ($[4] !== onLinkClick || $[5] !== testIdPrefix) {
            t2 = (url, idx)=>{
                const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    key: `${url}-${idx}-errored-fallback`,
                    testId: `${testIdPrefix}-errored-fallback-item-${idx}`,
                    onAuxClick: onAuxClick,
                    onContextMenu: onContextMenu
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: url,
                    onClick: onClick,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url));
            };
            $[4] = onLinkClick;
            $[5] = testIdPrefix;
            $[6] = t2;
        } else t2 = $[6];
        t1 = urls.map(t2);
        $[0] = onLinkClick;
        $[1] = testIdPrefix;
        $[2] = urls;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ urls: urls, onLinkClick: onLinkClick, testIdPrefix: testIdPrefix })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, urls.map((url, idx)=>{
        const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: `${url}-${idx}-errored-fallback`,
            testId: `${testIdPrefix}-errored-fallback-item-${idx}`,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: url,
            onClick: onClick,
            target: "_blank",
            rel: "noopener noreferrer"
        }, url));
    }));
};











const $af964aae8a362311$export$9441241ba5515b77 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Set();
        $[0] = t0;
    } else t0 = $[0];
    const [erroredIndices, setErroredIndices] = (0, $42omo.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (idx)=>setErroredIndices((prev)=>new Set(prev).add(idx));
        $[1] = t1;
    } else t1 = $[1];
    const markErrored = t1;
    let t2;
    if ($[2] !== erroredIndices) {
        t2 = {
            erroredIndices: erroredIndices,
            markErrored: markErrored
        };
        $[2] = erroredIndices;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const [erroredIndices, setErroredIndices] = (0, $42omo.useState)(new Set());
    const markErrored = (idx)=>setErroredIndices((prev)=>new Set(prev).add(idx));
    return {
        erroredIndices: erroredIndices,
        markErrored: markErrored
    };
};


const $be34308c5e894274$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _irr31dpa",
    rootCompact: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    linkWrapperUnresolved: "_1tke8vuz",
    linkWrapperUnresolvedCompact: "_1tke1ylp",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _4t3i1ylp"
};
const $be34308c5e894274$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1o9zidpf _18u0u2gc"
};
const $be34308c5e894274$var$messages = (0, $aXWIB.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_compact_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_compact_collapse",
        defaultMessage: "Show less"
    },
    link_list_view_all: {
        id: "smart_knowledge_card.link_list_compact_view_all",
        defaultMessage: "View all"
    }
});
const $be34308c5e894274$var$LinkListCompactComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick, size: t1 } = t0;
    const size = t1 === undefined ? "default" : t1;
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setResolved(true);
        $[0] = t2;
    } else t2 = $[0];
    const handleResolve = t2;
    let t3;
    if ($[1] !== onError) {
        t3 = ()=>{
            handleResolve();
            onError();
        };
        $[1] = onError;
        $[2] = t3;
    } else t3 = $[2];
    const handleError = t3;
    let t4;
    if ($[3] !== idx || $[4] !== onLinkClick || $[5] !== url) {
        t4 = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        $[3] = idx;
        $[4] = onLinkClick;
        $[5] = url;
        $[6] = t4;
    } else t4 = $[6];
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = t4;
    const isCompact = size === "compact";
    const t5 = isCompact && $be34308c5e894274$var$styles.rootCompact;
    const t6 = borderTopRounded && $be34308c5e894274$var$styles.borderTopRounded;
    const t7 = borderBottomRounded && $be34308c5e894274$var$styles.borderBottomRounded;
    const t8 = !resolved && $be34308c5e894274$var$styles.linkWrapperUnresolved;
    const t9 = !resolved && isCompact && $be34308c5e894274$var$styles.linkWrapperUnresolvedCompact;
    let t10;
    if ($[7] !== t5 || $[8] !== t6 || $[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
        t10 = (0, $1Whri.cx)($be34308c5e894274$var$styles.root, t5, $be34308c5e894274$var$styles.borderTop, t6, t7, t8, t9);
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    const t11 = `link-list-compact-item-${idx}${borderTopRounded ? "-top-rounded" : ""}${borderBottomRounded ? "-bottom-rounded" : ""}`;
    const t12 = isCompact ? (0, $5TXU5.SmartLinkSize).Small : (0, $5TXU5.SmartLinkSize).Medium;
    let t13;
    if ($[13] !== t12) {
        t13 = {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: t12,
            removeBlockRestriction: true
        };
        $[13] = t12;
        $[14] = t13;
    } else t13 = $[14];
    let t14;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
            maxLines: 1,
            showActionOnHover: true,
            subtitle: [
                {
                    name: (0, $5TXU5.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $5TXU5.ElementName).ModifiedOn
                }
            ],
            position: (0, $5TXU5.SmartLinkPosition).Center
        }));
        $[15] = t14;
    } else t14 = $[15];
    let t15;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleWrapper
        }, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $be34308c5e894274$var$unboundedStyles.metadataStateSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).State
                }
            ]
        })));
        $[16] = t15;
    } else t15 = $[16];
    let t16;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t15, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            xcss: $be34308c5e894274$var$unboundedStyles.unboundedMetadataWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $be34308c5e894274$var$unboundedStyles.metadataPrioritySlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).Priority
                }
            ]
        }))));
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== handleError || $[19] !== onClick || $[20] !== t13 || $[21] !== url) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
            appearance: "block",
            url: url,
            onClick: onClick,
            ui: t13,
            onError: handleError,
            onResolve: handleResolve
        }, t16);
        $[18] = handleError;
        $[19] = onClick;
        $[20] = t13;
        $[21] = url;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== resolved) {
        t18 = !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.unresolvedSkeletonOverlay, $be34308c5e894274$var$styles.loadingContainer),
            testId: "unresolved-loading-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "16px",
            height: "16px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $be34308c5e894274$var$styles.loadingSkeletonRows,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "40%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "70%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }))));
        $[23] = resolved;
        $[24] = t18;
    } else t18 = $[24];
    let t19;
    if ($[25] !== onAuxClick || $[26] !== onContextMenu || $[27] !== t10 || $[28] !== t11 || $[29] !== t17 || $[30] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t10,
            testId: t11,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, t17, t18);
        $[25] = onAuxClick;
        $[26] = onContextMenu;
        $[27] = t10;
        $[28] = t11;
        $[29] = t17;
        $[30] = t18;
        $[31] = t19;
    } else t19 = $[31];
    return t19;
} : ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick, size: size = 'default' })=>{
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    const handleResolve = ()=>setResolved(true);
    const handleError = ()=>{
        handleResolve();
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
    const isCompact = size === 'compact';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.root, isCompact && $be34308c5e894274$var$styles.rootCompact, $be34308c5e894274$var$styles.borderTop, borderTopRounded && $be34308c5e894274$var$styles.borderTopRounded, borderBottomRounded && $be34308c5e894274$var$styles.borderBottomRounded, !resolved && $be34308c5e894274$var$styles.linkWrapperUnresolved, !resolved && isCompact && $be34308c5e894274$var$styles.linkWrapperUnresolvedCompact),
        testId: `link-list-compact-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: isCompact ? (0, $5TXU5.SmartLinkSize).Small : (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $5TXU5.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ElementName).ModifiedOn
            }
        ],
        position: (0, $5TXU5.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).Priority
            }
        ]
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.unresolvedSkeletonOverlay, $be34308c5e894274$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $be34308c5e894274$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $be34308c5e894274$export$1fbb558f111cbbf9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(34);
    const { urls: urls, onLinkClick: onLinkClick, size: size, maxSources: t1, expandedMaxSources: expandedMaxSources, showExpand: t2, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    const maxSources = t1 === undefined ? (0, $6b624b5882fc4b79$export$533f831a441a4b64) : t1;
    const showExpand = t2 === undefined ? true : t2;
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $af964aae8a362311$export$9441241ba5515b77)();
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $6b624b5882fc4b79$export$533f831a441a4b64);
    let T0;
    let showExpandToggle;
    let showViewAll;
    let t3;
    let t4;
    let t5;
    if ($[0] !== erroredIndices || $[1] !== expandedMaxSources || $[2] !== isExpanded || $[3] !== markErrored || $[4] !== onLinkClick || $[5] !== safeMaxSources || $[6] !== showExpand || $[7] !== size || $[8] !== urls || $[9] !== viewAllUrl) {
        t5 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let t6;
            if ($[16] !== erroredIndices) {
                t6 = (i_0)=>!erroredIndices.has(i_0);
                $[16] = erroredIndices;
                $[17] = t6;
            } else t6 = $[17];
            const visibleIndices = urls.map($be34308c5e894274$var$_temp).filter(t6);
            const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined;
            const hasMore = showExpand && visibleIndices.length > safeMaxSources;
            const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
            const firstVisibleIdx = renderedIndices[0] ?? -1;
            const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
            const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
            if (allUrlsErrored) {
                let t7;
                if ($[18] !== onLinkClick || $[19] !== urls) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742a27c74678daf7$export$fdef7686f3aefbe0), {
                        urls: urls,
                        onLinkClick: onLinkClick,
                        testIdPrefix: "link-list-compact"
                    });
                    $[18] = onLinkClick;
                    $[19] = urls;
                    $[20] = t7;
                } else t7 = $[20];
                t5 = t7;
                break bb0;
            }
            showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
            showExpandToggle = hasMore && !showViewAll;
            const hasFooter = showExpandToggle || showViewAll;
            T0 = (0, $eyWa4.default);
            t3 = "space.0";
            t4 = renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be34308c5e894274$var$LinkListCompactComponent, {
                    key: `${urls[originalIdx]}-${originalIdx}`,
                    url: urls[originalIdx],
                    idx: originalIdx,
                    borderTopRounded: originalIdx === firstVisibleIdx,
                    borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
                    onError: ()=>markErrored(originalIdx),
                    onLinkClick: onLinkClick,
                    size: size
                }));
        }
        $[0] = erroredIndices;
        $[1] = expandedMaxSources;
        $[2] = isExpanded;
        $[3] = markErrored;
        $[4] = onLinkClick;
        $[5] = safeMaxSources;
        $[6] = showExpand;
        $[7] = size;
        $[8] = urls;
        $[9] = viewAllUrl;
        $[10] = T0;
        $[11] = showExpandToggle;
        $[12] = showViewAll;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else {
        T0 = $[10];
        showExpandToggle = $[11];
        showViewAll = $[12];
        t3 = $[13];
        t4 = $[14];
        t5 = $[15];
    }
    if (t5 !== Symbol.for("react.early_return_sentinel")) return t5;
    let t6;
    if ($[21] !== isExpanded || $[22] !== showExpandToggle) {
        t6 = showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.expandWrapper, $be34308c5e894274$var$styles.borderBottomRounded),
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: ()=>setIsExpanded(!isExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_expand))));
        $[21] = isExpanded;
        $[22] = showExpandToggle;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== onViewAllLinkClick || $[25] !== showViewAll || $[26] !== viewAllUrl) {
        t7 = showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.expandWrapper, $be34308c5e894274$var$styles.borderBottomRounded),
            alignBlock: "center",
            testId: "link-list-compact-view-all"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "subtle",
            href: viewAllUrl,
            onClick: onViewAllLinkClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_view_all))));
        $[24] = onViewAllLinkClick;
        $[25] = showViewAll;
        $[26] = viewAllUrl;
        $[27] = t7;
    } else t7 = $[27];
    let t8;
    if ($[28] !== T0 || $[29] !== t3 || $[30] !== t4 || $[31] !== t6 || $[32] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            space: t3
        }, t4, t6, t7);
        $[28] = T0;
        $[29] = t3;
        $[30] = t4;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
    } else t8 = $[33];
    return t8;
} : ({ urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources = (0, $6b624b5882fc4b79$export$533f831a441a4b64), expandedMaxSources: expandedMaxSources, showExpand: showExpand = true, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $af964aae8a362311$export$9441241ba5515b77)(); // Clamp `maxSources` to a sensible positive integer. The prop is typed as
    // `number`, so a caller can pass `0` (renders nothing until "Show more"
    // click) or a negative number (`slice(0, -1)` would silently drop the
    // last item). Falling back to `DEFAULT_MAX_SOURCES` keeps the API
    // forgiving without changing the documented happy-path behaviour.
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $6b624b5882fc4b79$export$533f831a441a4b64); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i_0)=>!erroredIndices.has(i_0));
    const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined; // Only show the expand/collapse button when showExpand is true and there are
    // more items than safeMaxSources. When showExpand is false all items up to
    // safeMaxSources are shown immediately with no toggle.
    const hasMore = showExpand && visibleIndices.length > safeMaxSources;
    const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1; // In the edge case that every url has errored, rather than rendering nothing
    // (which looks broken given the surrounding context), fall back to rendering
    // each URL as a plain ADS link so the user still sees the links
    const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
    if (allUrlsErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742a27c74678daf7$export$fdef7686f3aefbe0), {
        urls: urls,
        onLinkClick: onLinkClick,
        testIdPrefix: "link-list-compact"
    });
    const showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
    const showExpandToggle = hasMore && !showViewAll;
    const hasFooter = showExpandToggle || showViewAll;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be34308c5e894274$var$LinkListCompactComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick,
            size: size
        })), showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.expandWrapper, $be34308c5e894274$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_expand)))), showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.expandWrapper, $be34308c5e894274$var$styles.borderBottomRounded),
        alignBlock: "center",
        testId: "link-list-compact-view-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: viewAllUrl,
        onClick: onViewAllLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_view_all)))));
};
function $be34308c5e894274$var$_temp(_, i) {
    return i;
}















































const $c55bd8c5797796c1$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _irr31dpa",
    linkWrapperUnresolved: "_1tke1ex1",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _4t3i1ylp"
};
const $c55bd8c5797796c1$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr _1bac1mp2 _13bou2gc",
    hideTitleStyles: "_u4a7glyw _502wglyw",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataModifiedOnSlot: "_1bsb1w81 _1o9zidpf _18u0utpp",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1bsbzwfg _1o9zidpf _18u0u2gc",
    metadataAuthorSlot: "_1bsb1wqb _1o9zidpf _18u0pxbi",
    previewSlot: "_1bsb1tcg _1o9zidpf"
};
const $c55bd8c5797796c1$var$messages = (0, $aXWIB.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_full_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_full_collapse",
        defaultMessage: "Show less"
    },
    link_list_view_all: {
        id: "smart_knowledge_card.link_list_full_view_all",
        defaultMessage: "View all"
    }
});
const $c55bd8c5797796c1$var$LinkListFullComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick } = t0;
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setResolved(true);
        $[0] = t1;
    } else t1 = $[0];
    const handleResolve = t1;
    let t2;
    if ($[1] !== onError) {
        t2 = ()=>{
            handleResolve();
            onError();
        };
        $[1] = onError;
        $[2] = t2;
    } else t2 = $[2];
    const handleError = t2;
    let t3;
    if ($[3] !== idx || $[4] !== onLinkClick || $[5] !== url) {
        t3 = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
        $[3] = idx;
        $[4] = onLinkClick;
        $[5] = url;
        $[6] = t3;
    } else t3 = $[6];
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = t3;
    const t4 = borderTopRounded && $c55bd8c5797796c1$var$styles.borderTopRounded;
    const t5 = borderBottomRounded && $c55bd8c5797796c1$var$styles.borderBottomRounded;
    const t6 = !resolved && $c55bd8c5797796c1$var$styles.linkWrapperUnresolved;
    let t7;
    if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
        t7 = (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.root, $c55bd8c5797796c1$var$styles.borderTop, t4, t5, t6);
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = `link-list-full-item-${idx}${borderTopRounded ? "-top-rounded" : ""}${borderBottomRounded ? "-bottom-rounded" : ""}`;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        };
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
            maxLines: 1,
            showActionOnHover: true,
            subtitle: [
                {
                    name: (0, $5TXU5.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $5TXU5.ElementName).CreatedBy
                }
            ],
            position: (0, $5TXU5.SmartLinkPosition).Center
        }));
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleWrapper
        }, t10, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataStateSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).State
                }
            ]
        })));
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataAuthorSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).AuthorGroup
                }
            ]
        }));
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataModifiedOnSlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).ModifiedOn
                }
            ]
        }));
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataPrioritySlot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
            maxLines: 1,
            primary: [
                {
                    name: (0, $5TXU5.ElementName).Priority
                }
            ]
        }));
        $[16] = t14;
    } else t14 = $[16];
    let t15;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $1Whri.cx)($c55bd8c5797796c1$var$unboundedStyles.hideTitleStyles, $c55bd8c5797796c1$var$unboundedStyles.previewSlot);
        $[17] = t15;
    } else t15 = $[17];
    let t16;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            spread: "space-between",
            alignBlock: "center"
        }, t11, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedMetadataWrapper
        }, t12, t13, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t15
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
            maxLines: 1,
            actions: [
                {
                    name: (0, $5TXU5.ActionName).PreviewAction,
                    hideContent: true
                }
            ],
            showActionOnHover: true,
            position: (0, $5TXU5.SmartLinkPosition).Center
        }))));
        $[18] = t16;
    } else t16 = $[18];
    let t17;
    if ($[19] !== handleError || $[20] !== onClick || $[21] !== url) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
            appearance: "block",
            url: url,
            onClick: onClick,
            ui: t9,
            onError: handleError,
            onResolve: handleResolve
        }, t16);
        $[19] = handleError;
        $[20] = onClick;
        $[21] = url;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== resolved) {
        t18 = !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.unresolvedSkeletonOverlay, $c55bd8c5797796c1$var$styles.loadingContainer),
            testId: "unresolved-loading-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "16px",
            height: "16px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $c55bd8c5797796c1$var$styles.loadingSkeletonRows,
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "40%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "70%",
            height: "12px",
            borderRadius: "var(--ds-radius-small, 4px)"
        }))));
        $[23] = resolved;
        $[24] = t18;
    } else t18 = $[24];
    let t19;
    if ($[25] !== onAuxClick || $[26] !== onContextMenu || $[27] !== t17 || $[28] !== t18 || $[29] !== t7 || $[30] !== t8) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t7,
            testId: t8,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        }, t17, t18);
        $[25] = onAuxClick;
        $[26] = onContextMenu;
        $[27] = t17;
        $[28] = t18;
        $[29] = t7;
        $[30] = t8;
        $[31] = t19;
    } else t19 = $[31];
    return t19;
} : ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick })=>{
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    const handleResolve = ()=>setResolved(true);
    const handleError = ()=>{
        handleResolve();
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6)(onLinkClick, url, idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.root, $c55bd8c5797796c1$var$styles.borderTop, borderTopRounded && $c55bd8c5797796c1$var$styles.borderTopRounded, borderBottomRounded && $c55bd8c5797796c1$var$styles.borderBottomRounded, !resolved && $c55bd8c5797796c1$var$styles.linkWrapperUnresolved),
        testId: `link-list-full-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $5TXU5.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ElementName).CreatedBy
            }
        ],
        position: (0, $5TXU5.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataAuthorSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).AuthorGroup
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataModifiedOnSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).ModifiedOn
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).Priority
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$unboundedStyles.hideTitleStyles, $c55bd8c5797796c1$var$unboundedStyles.previewSlot)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        actions: [
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                hideContent: true
            }
        ],
        showActionOnHover: true,
        position: (0, $5TXU5.SmartLinkPosition).Center
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.unresolvedSkeletonOverlay, $c55bd8c5797796c1$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $c55bd8c5797796c1$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $c55bd8c5797796c1$export$984f8adc5ac31b30 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { urls: urls, onLinkClick: onLinkClick, maxSources: t1, expandedMaxSources: expandedMaxSources, showExpand: t2, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    const maxSources = t1 === undefined ? (0, $6b624b5882fc4b79$export$533f831a441a4b64) : t1;
    const showExpand = t2 === undefined ? true : t2;
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $af964aae8a362311$export$9441241ba5515b77)();
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $6b624b5882fc4b79$export$533f831a441a4b64);
    let T0;
    let showExpandToggle;
    let showViewAll;
    let t3;
    let t4;
    let t5;
    if ($[0] !== erroredIndices || $[1] !== expandedMaxSources || $[2] !== isExpanded || $[3] !== markErrored || $[4] !== onLinkClick || $[5] !== safeMaxSources || $[6] !== showExpand || $[7] !== urls || $[8] !== viewAllUrl) {
        t5 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let t6;
            if ($[15] !== erroredIndices) {
                t6 = (i_0)=>!erroredIndices.has(i_0);
                $[15] = erroredIndices;
                $[16] = t6;
            } else t6 = $[16];
            const visibleIndices = urls.map($c55bd8c5797796c1$var$_temp).filter(t6);
            const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined;
            const hasMore = showExpand && visibleIndices.length > safeMaxSources;
            const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
            const firstVisibleIdx = renderedIndices[0] ?? -1;
            const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
            const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
            if (allUrlsErrored) {
                let t7;
                if ($[17] !== onLinkClick || $[18] !== urls) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742a27c74678daf7$export$fdef7686f3aefbe0), {
                        urls: urls,
                        onLinkClick: onLinkClick,
                        testIdPrefix: "link-list-full"
                    });
                    $[17] = onLinkClick;
                    $[18] = urls;
                    $[19] = t7;
                } else t7 = $[19];
                t5 = t7;
                break bb0;
            }
            showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
            showExpandToggle = hasMore && !showViewAll;
            const hasFooter = showExpandToggle || showViewAll;
            T0 = (0, $eyWa4.default);
            t3 = "space.0";
            t4 = renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c55bd8c5797796c1$var$LinkListFullComponent, {
                    key: `${urls[originalIdx]}-${originalIdx}`,
                    url: urls[originalIdx],
                    idx: originalIdx,
                    borderTopRounded: originalIdx === firstVisibleIdx,
                    borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
                    onError: ()=>markErrored(originalIdx),
                    onLinkClick: onLinkClick
                }));
        }
        $[0] = erroredIndices;
        $[1] = expandedMaxSources;
        $[2] = isExpanded;
        $[3] = markErrored;
        $[4] = onLinkClick;
        $[5] = safeMaxSources;
        $[6] = showExpand;
        $[7] = urls;
        $[8] = viewAllUrl;
        $[9] = T0;
        $[10] = showExpandToggle;
        $[11] = showViewAll;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else {
        T0 = $[9];
        showExpandToggle = $[10];
        showViewAll = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
    }
    if (t5 !== Symbol.for("react.early_return_sentinel")) return t5;
    let t6;
    if ($[20] !== isExpanded || $[21] !== showExpandToggle) {
        t6 = showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.expandWrapper, $c55bd8c5797796c1$var$styles.borderBottomRounded),
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: ()=>setIsExpanded(!isExpanded)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_expand))));
        $[20] = isExpanded;
        $[21] = showExpandToggle;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== onViewAllLinkClick || $[24] !== showViewAll || $[25] !== viewAllUrl) {
        t7 = showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.expandWrapper, $c55bd8c5797796c1$var$styles.borderBottomRounded),
            alignBlock: "center",
            testId: "link-list-full-view-all"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "subtle",
            href: viewAllUrl,
            onClick: onViewAllLinkClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_view_all))));
        $[23] = onViewAllLinkClick;
        $[24] = showViewAll;
        $[25] = viewAllUrl;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== T0 || $[28] !== t3 || $[29] !== t4 || $[30] !== t6 || $[31] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            space: t3
        }, t4, t6, t7);
        $[27] = T0;
        $[28] = t3;
        $[29] = t4;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
    } else t8 = $[32];
    return t8;
} : ({ urls: urls, onLinkClick: onLinkClick, maxSources: maxSources = (0, $6b624b5882fc4b79$export$533f831a441a4b64), expandedMaxSources: expandedMaxSources, showExpand: showExpand = true, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $af964aae8a362311$export$9441241ba5515b77)(); // Clamp `maxSources` to a sensible positive integer — same defensive logic
    // as link-list-compact to keep the API forgiving.
    const safeMaxSources = maxSources >= 1 ? maxSources : (0, $6b624b5882fc4b79$export$533f831a441a4b64); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i_0)=>!erroredIndices.has(i_0));
    const expandedCap = expandedMaxSources !== undefined && expandedMaxSources > safeMaxSources ? expandedMaxSources : undefined; // Only show the expand/collapse button when showExpand is true and there are
    // more items than safeMaxSources. When showExpand is false all items up to
    // safeMaxSources are shown immediately with no toggle.
    const hasMore = showExpand && visibleIndices.length > safeMaxSources;
    const renderedIndices = isExpanded ? expandedCap !== undefined ? visibleIndices.slice(0, expandedCap) : visibleIndices : visibleIndices.slice(0, safeMaxSources);
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1; // In the edge case that every url has errored, rather than rendering nothing
    // (which looks broken given the surrounding context), fall back to rendering
    // each URL as a plain ADS link so the user still sees the links
    const allUrlsErrored = urls.length > 0 && erroredIndices.size === urls.length;
    if (allUrlsErrored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742a27c74678daf7$export$fdef7686f3aefbe0), {
        urls: urls,
        onLinkClick: onLinkClick,
        testIdPrefix: "link-list-full"
    });
    const showViewAll = !!viewAllUrl && (!hasMore || isExpanded);
    const showExpandToggle = hasMore && !showViewAll;
    const hasFooter = showExpandToggle || showViewAll;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c55bd8c5797796c1$var$LinkListFullComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasFooter,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick
        })), showExpandToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.expandWrapper, $c55bd8c5797796c1$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_expand)))), showViewAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.expandWrapper, $c55bd8c5797796c1$var$styles.borderBottomRounded),
        alignBlock: "center",
        testId: "link-list-full-view-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: viewAllUrl,
        onClick: onViewAllLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_view_all)))));
};
function $c55bd8c5797796c1$var$_temp(_, i) {
    return i;
}


const $de24bf906e414d3f$var$containerRoot = null;
const $de24bf906e414d3f$var$showCompact = null;
const $de24bf906e414d3f$var$showFull = null;
const $de24bf906e414d3f$export$533f831a441a4b64 = 4;
const $de24bf906e414d3f$export$bec64ed398b2de33 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources, expandedMaxSources: expandedMaxSources, showExpand: showExpand, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_1bsb1osq _7cca15wb _1f381bi7"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1e0c1ule _1h0uglyw"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandedMaxSources || $[3] !== maxSources || $[4] !== onLinkClick || $[5] !== onViewAllLinkClick || $[6] !== showExpand || $[7] !== size || $[8] !== urls || $[9] !== viewAllUrl) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $be34308c5e894274$export$1fbb558f111cbbf9), {
            urls: urls,
            onLinkClick: onLinkClick,
            size: size,
            maxSources: maxSources,
            expandedMaxSources: expandedMaxSources,
            showExpand: showExpand,
            viewAllUrl: viewAllUrl,
            onViewAllLinkClick: onViewAllLinkClick
        }));
        $[2] = expandedMaxSources;
        $[3] = maxSources;
        $[4] = onLinkClick;
        $[5] = onViewAllLinkClick;
        $[6] = showExpand;
        $[7] = size;
        $[8] = urls;
        $[9] = viewAllUrl;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw _1h0u1ule"
        ]);
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== expandedMaxSources || $[13] !== maxSources || $[14] !== onLinkClick || $[15] !== onViewAllLinkClick || $[16] !== showExpand || $[17] !== urls || $[18] !== viewAllUrl) {
        t5 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t4
        }, /*#__PURE__*/ $42omo.createElement((0, $c55bd8c5797796c1$export$984f8adc5ac31b30), {
            urls: urls,
            onLinkClick: onLinkClick,
            maxSources: maxSources,
            expandedMaxSources: expandedMaxSources,
            showExpand: showExpand,
            viewAllUrl: viewAllUrl,
            onViewAllLinkClick: onViewAllLinkClick
        }));
        $[12] = expandedMaxSources;
        $[13] = maxSources;
        $[14] = onLinkClick;
        $[15] = onViewAllLinkClick;
        $[16] = showExpand;
        $[17] = urls;
        $[18] = viewAllUrl;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $42omo.createElement((0, $7bZ3i.SmartCardProvider), null, t3, t5));
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : ({ urls: urls, onLinkClick: onLinkClick, size: size, maxSources: maxSources, expandedMaxSources: expandedMaxSources, showExpand: showExpand, viewAllUrl: viewAllUrl, onViewAllLinkClick: onViewAllLinkClick })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1osq _7cca15wb _1f381bi7"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7bZ3i.SmartCardProvider), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1h0uglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $be34308c5e894274$export$1fbb558f111cbbf9), {
        urls: urls,
        onLinkClick: onLinkClick,
        size: size,
        maxSources: maxSources,
        expandedMaxSources: expandedMaxSources,
        showExpand: showExpand,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick
    })), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0cglyw _1h0u1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $c55bd8c5797796c1$export$984f8adc5ac31b30), {
        urls: urls,
        onLinkClick: onLinkClick,
        maxSources: maxSources,
        expandedMaxSources: expandedMaxSources,
        showExpand: showExpand,
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: onViewAllLinkClick
    }))));
};
module.exports["LinkList"] = $de24bf906e414d3f$export$bec64ed398b2de33;

});

parcelRegister("3Gey6", function(module, exports) {
/**
 * @generated SignedSource<<48519cfdb73c5a14f3e10456dec9cf9a>>
 * @relayHash 740055ccba4a1ecb547d7380889c2075
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58d9313ba3b66f5b68d98a01eb9d82f9a67f4adc07167b1ee25758331e869b3c
const $88c913f65753a156$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIdString"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewerId"
    }, v6 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v10 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = [
        v11 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "userAri",
                            "variableName": "userAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIdString",
                            "variableName": "userIdString"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewerId",
                            "variableName": "viewerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserProfileCardRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "department"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "organization"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "items": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "actors.0",
                                                    "variableName": "userAri"
                                                }
                                            ],
                                            "kind": "ListValue",
                                            "name": "actors"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 3
                                }
                            ],
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ActivityItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityObject",
                                                    "kind": "LinkedField",
                                                    "name": "object",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluencePageLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceBlogPostLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceWhiteboardLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "webUrl"
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "href"
                                                                        }
                                                                    ],
                                                                    "type": "BitbucketPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "loomUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "LoomVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "MercuryPortfolio"
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "userIdString"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "requestingUserId",
                                    "variableName": "viewerId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "tenantId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "singleUser",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryUserProfile",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryUserManager",
                                                    "kind": "LinkedField",
                                                    "name": "manager",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                    "kind": "LinkedField",
                                                    "name": "thirdPartyIntegrations",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "externalId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "integrationId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "product"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeDiscoverySingleUser"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "58d9313ba3b66f5b68d98a01eb9d82f9a67f4adc07167b1ee25758331e869b3c",
            "metadata": {},
            "name": "UserProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$88c913f65753a156$var$node.hash = "85cac0d771f87f5698cf3c18dcde5c03";
var $88c913f65753a156$export$2e2bcd8739ae039 = $88c913f65753a156$var$node;
module.exports["default"] = $88c913f65753a156$export$2e2bcd8739ae039;

});

parcelRegister("4G9a0", function(module, exports) {

let $368230b741037419$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $368230b741037419$var$load("i8mSI").then(()=>parcelRequire('ahqGM'));

});

parcelRegister("6cbph", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $05796b2533bfe14f$var$AssignedToElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).assigned_to, context.assignedTo) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).AssignedTo
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedTo
    }) : null;
};
var $05796b2533bfe14f$export$2e2bcd8739ae039 = $05796b2533bfe14f$var$AssignedToElement;
module.exports["default"] = $05796b2533bfe14f$export$2e2bcd8739ae039;

});

parcelRegister("4wLtQ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $e65535d36ac745c6$var$AssignedToGroupElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9mMJ0.toAvatarGroupProps)(context.assignedToGroup, true) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).AssignedToGroup
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedToGroup
    }) : null;
};
var $e65535d36ac745c6$export$2e2bcd8739ae039 = $e65535d36ac745c6$var$AssignedToGroupElement;
module.exports["default"] = $e65535d36ac745c6$export$2e2bcd8739ae039;

});

parcelRegister("iNImz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $68f91cb1c2b70cc7$var$AttachmentCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.attachmentCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Attachment,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).AttachmentCount
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AttachmentCount
    }) : null;
};
var $68f91cb1c2b70cc7$export$2e2bcd8739ae039 = $68f91cb1c2b70cc7$var$AttachmentCountElement;
module.exports["default"] = $68f91cb1c2b70cc7$export$2e2bcd8739ae039;

});

parcelRegister("LrBxG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $5665fdfe0a3a6612$var$AuthorGroupElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9mMJ0.toAvatarGroupProps)(context.authorGroup, false) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).AuthorGroup
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AuthorGroup
    }) : null;
};
var $5665fdfe0a3a6612$export$2e2bcd8739ae039 = $5665fdfe0a3a6612$var$AuthorGroupElement;
module.exports["default"] = $5665fdfe0a3a6612$export$2e2bcd8739ae039;

});

parcelRegister("bWsCB", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9683283e28315c04$var$ChecklistProgressElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.checklistProgress?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).CheckItem,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).ChecklistProgress
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ChecklistProgress
    }) : null;
};
var $9683283e28315c04$export$2e2bcd8739ae039 = $9683283e28315c04$var$ChecklistProgressElement;
module.exports["default"] = $9683283e28315c04$export$2e2bcd8739ae039;

});

parcelRegister("azCqP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9mMJ0 = parcelRequire("9mMJ0");

const $853fada055614992$var$CollaboratorGroupElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9mMJ0.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).CollaboratorGroup
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CollaboratorGroup
    }) : null;
};
var $853fada055614992$export$2e2bcd8739ae039 = $853fada055614992$var$CollaboratorGroupElement;
module.exports["default"] = $853fada055614992$export$2e2bcd8739ae039;

});

parcelRegister("e8W8a", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $047203c23d0cd021$var$CreatedOnElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $6wR2f.toDateTimeProps)("created", context.createdOn) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).CreatedOn
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedOn
    }) : null;
};
var $047203c23d0cd021$export$2e2bcd8739ae039 = $047203c23d0cd021$var$CreatedOnElement;
module.exports["default"] = $047203c23d0cd021$export$2e2bcd8739ae039;

});

parcelRegister("3nul2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $916e74797092cad1$var$CreatedByElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).created_by, context.createdBy) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).CreatedBy
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedBy
    }) : null;
};
var $916e74797092cad1$export$2e2bcd8739ae039 = $916e74797092cad1$var$CreatedByElement;
module.exports["default"] = $916e74797092cad1$export$2e2bcd8739ae039;

});

parcelRegister("jKoRo", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $d5c24538631868a6$var$DueOnElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $7f92O.toDateLozengeProps)(context.dueOn) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).DueOn,
            isDateTag: true
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $7f92O.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $d5c24538631868a6$export$2e2bcd8739ae039 = $d5c24538631868a6$var$DueOnElement;
module.exports["default"] = $d5c24538631868a6$export$2e2bcd8739ae039;

});

parcelRegister("bmx11", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $c95f1e4b0b62823d$var$LatestCommitElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.latestCommit?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Commit,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).LatestCommit
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LatestCommit
    }) : null;
};
var $c95f1e4b0b62823d$export$2e2bcd8739ae039 = $c95f1e4b0b62823d$var$LatestCommitElement;
module.exports["default"] = $c95f1e4b0b62823d$export$2e2bcd8739ae039;

});

parcelRegister("8iOdP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $8bb8e = parcelRequire("8bb8e");

const $7078b0bbce341226$var$LocationElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.location ?? null;
    let t0;
    if ($[0] !== data || $[1] !== props) {
        t0 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
            theme: (0, $5TXU5.SmartLinkInternalTheme).Grey,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).Location
        }) : null;
        $[0] = data;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bb8e.default), {
        theme: (0, $5TXU5.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Location
    }) : null;
};
var $7078b0bbce341226$export$2e2bcd8739ae039 = $7078b0bbce341226$var$LocationElement;
module.exports["default"] = $7078b0bbce341226$export$2e2bcd8739ae039;

});

parcelRegister("jW9GW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $7578031676e72aae$var$ModifiedByElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).modified_by, context.modifiedBy) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).ModifiedBy
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ModifiedBy
    }) : null;
};
var $7578031676e72aae$export$2e2bcd8739ae039 = $7578031676e72aae$var$ModifiedByElement;
module.exports["default"] = $7578031676e72aae$export$2e2bcd8739ae039;

});

parcelRegister("ikM9T", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");











var $gMc0m = parcelRequire("gMc0m");





var $b6b6P = parcelRequire("b6b6P");

const $531c533c77a52797$var$styles = null;
const $531c533c77a52797$var$MediaElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { name: name, className: className, testId: t1, type: type, url: url, onLoad: onLoad, onError: onError } = t0;
    const testId = t1 === undefined ? "smart-element-media" : t1;
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    let t2;
    if ($[0] !== className) {
        t2 = (0, $gMc0m.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]);
        $[0] = className;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = ui?.hideLoadingSkeleton;
    const t4 = `${testId}-image`;
    let t5;
    if ($[2] !== onError || $[3] !== onLoad || $[4] !== t3 || $[5] !== t4 || $[6] !== url) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
            hideLoadingSkeleton: t3,
            testId: t4,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        });
        $[2] = onError;
        $[3] = onLoad;
        $[4] = t3;
        $[5] = t4;
        $[6] = url;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== name || $[9] !== t2 || $[10] !== t5 || $[11] !== testId || $[12] !== type) {
        t6 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-smart-element": name,
            "data-smart-element-media": type,
            "data-testid": testId,
            className: t2
        }, t5);
        $[8] = name;
        $[9] = t2;
        $[10] = t5;
        $[11] = testId;
        $[12] = type;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $b6b6P.default), {
        hideLoadingSkeleton: ui?.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $531c533c77a52797$export$2e2bcd8739ae039 = $531c533c77a52797$var$MediaElement;


const $a98281f2c459b443$var$PreviewElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(11);
    let t0;
    if ($[0] !== props) {
        t0 = props ?? {};
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let overrideUrl;
    let rest;
    if ($[2] !== t0) {
        ({ overrideUrl: overrideUrl, ...rest } = t0);
        $[2] = t0;
        $[3] = overrideUrl;
        $[4] = rest;
    } else {
        overrideUrl = $[3];
        rest = $[4];
    }
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t1;
    if ($[5] !== context?.preview || $[6] !== overrideUrl) {
        t1 = overrideUrl ? {
            url: overrideUrl,
            type: (0, $5TXU5.MediaType).Image
        } : context?.preview;
        $[5] = context?.preview;
        $[6] = overrideUrl;
        $[7] = t1;
    } else t1 = $[7];
    const data = t1;
    if (!data) return null;
    let t2;
    if ($[8] !== data || $[9] !== rest) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531c533c77a52797$export$2e2bcd8739ae039), {
            ...rest,
            ...data
        });
        $[8] = data;
        $[9] = rest;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5TXU5.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $531c533c77a52797$export$2e2bcd8739ae039), {
        ...rest,
        ...data
    });
};
var $a98281f2c459b443$export$2e2bcd8739ae039 = $a98281f2c459b443$var$PreviewElement;
module.exports["default"] = $a98281f2c459b443$export$2e2bcd8739ae039;

});

parcelRegister("8YJtM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $ecf289c1a2ef6a7c$var$PriorityElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    let t0;
    if ($[0] !== data || $[1] !== props) {
        t0 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).Priority
        }) : null;
        $[0] = data;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Priority
    }) : null;
};
var $ecf289c1a2ef6a7c$export$2e2bcd8739ae039 = $ecf289c1a2ef6a7c$var$PriorityElement;
module.exports["default"] = $ecf289c1a2ef6a7c$export$2e2bcd8739ae039;

});

parcelRegister("6Ed8U", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $3c7f8fc790c1b094$var$ProgrammingLanguageElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.programmingLanguage) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).ProgrammingLanguage,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).ProgrammingLanguage
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ProgrammingLanguage
    }) : null;
};
var $3c7f8fc790c1b094$export$2e2bcd8739ae039 = $3c7f8fc790c1b094$var$ProgrammingLanguageElement;
module.exports["default"] = $3c7f8fc790c1b094$export$2e2bcd8739ae039;

});

parcelRegister("2ZgNz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $33250de89c37863a$var$ProviderElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    let t0;
    if ($[0] !== data || $[1] !== props) {
        t0 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).Provider
        }) : null;
        $[0] = data;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Provider
    }) : null;
};
var $33250de89c37863a$export$2e2bcd8739ae039 = $33250de89c37863a$var$ProviderElement;
module.exports["default"] = $33250de89c37863a$export$2e2bcd8739ae039;

});

parcelRegister("2GDee", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b374eebbbeae9d3$var$ReadTimeElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).read_time, context.readTime) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).ReadTime
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ReadTime
    }) : null;
};
var $2b374eebbbeae9d3$export$2e2bcd8739ae039 = $2b374eebbbeae9d3$var$ReadTimeElement;
module.exports["default"] = $2b374eebbbeae9d3$export$2e2bcd8739ae039;

});

parcelRegister("h2WFd", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $6wR2f = parcelRequire("6wR2f");

const $b4843e0ca575cd89$var$SentOnElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $6wR2f.toDateTimeProps)("sent", context.sentOn) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).SentOn
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SentOn
    }) : null;
};
var $b4843e0ca575cd89$export$2e2bcd8739ae039 = $b4843e0ca575cd89$var$SentOnElement;
module.exports["default"] = $b4843e0ca575cd89$export$2e2bcd8739ae039;

});

parcelRegister("49WiA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $4a2a6a0afaba68de$var$snippetBaseStyle = null;
const $4a2a6a0afaba68de$var$SnippetElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(6);
    const { content: overrideContent, maxLines: t0, className: className, ...restOfProps } = props ?? {};
    const maxLines = t0 === undefined ? $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES : t0;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const T0 = (0, $aIzVM.default);
    const t1 = overrideContent ?? context?.snippet;
    const t2 = (0, $gMc0m.default)([
        "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
        className
    ]);
    let t3;
    if ($[0] !== T0 || $[1] !== maxLines || $[2] !== restOfProps || $[3] !== t1 || $[4] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement(T0, {
            content: t1,
            maxLines: maxLines,
            className: t2,
            ...restOfProps
        });
        $[0] = T0;
        $[1] = maxLines;
        $[2] = restOfProps;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : (props)=>{
    const { content: overrideContent, maxLines: maxLines = $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    return /*#__PURE__*/ $42omo.createElement((0, $aIzVM.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $4a2a6a0afaba68de$export$2e2bcd8739ae039 = $4a2a6a0afaba68de$var$SnippetElement;
module.exports["default"] = $4a2a6a0afaba68de$export$2e2bcd8739ae039;

});

parcelRegister("aGsNO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $2b9dc14522cad497$var$SourceBranchElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toTextProps)(context.sourceBranch) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).SourceBranch
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SourceBranch
    }) : null;
};
var $2b9dc14522cad497$export$2e2bcd8739ae039 = $2b9dc14522cad497$var$SourceBranchElement;
module.exports["default"] = $2b9dc14522cad497$export$2e2bcd8739ae039;

});

parcelRegister("emfmd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $7f92O = parcelRequire("7f92O");

const $ba597065b544e1bf$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $ba597065b544e1bf$var$StateElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.state ?? null;
    const metricProps = (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($ba597065b544e1bf$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f92O.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $5TXU5.ElementName).State
    });
};
var $ba597065b544e1bf$export$2e2bcd8739ae039 = $ba597065b544e1bf$var$StateElement;
module.exports["default"] = $ba597065b544e1bf$export$2e2bcd8739ae039;

});

parcelRegister("a0Yyn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $9a2e44abfd20874f$var$SubscriberCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.subscriberCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Subscriber,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).SubscriberCount
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubscriberCount
    }) : null;
};
var $9a2e44abfd20874f$export$2e2bcd8739ae039 = $9a2e44abfd20874f$var$SubscriberCountElement;
module.exports["default"] = $9a2e44abfd20874f$export$2e2bcd8739ae039;

});

parcelRegister("b8mrt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $a84eddedac7cbcb2$var$SubTasksProgressElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.subTasksProgress?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).SubTasksProgress,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).SubTasksProgress
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubTasksProgress
    }) : null;
};
var $a84eddedac7cbcb2$export$2e2bcd8739ae039 = $a84eddedac7cbcb2$var$SubTasksProgressElement;
module.exports["default"] = $a84eddedac7cbcb2$export$2e2bcd8739ae039;

});

parcelRegister("jpKes", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");











var $gMc0m = parcelRequire("gMc0m");


var $c4sKh = parcelRequire("c4sKh");

const $26451f799052e0a3$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $26451f799052e0a3$var$BaseAtlaskitElementBadge = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { value: value, name: name, className: className, testId: t1 } = t0;
    const testId = t1 === undefined ? "smart-element-atlaskit-badge" : t1;
    if (!value) return null;
    let t2;
    if ($[0] !== className) {
        t2 = (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]);
        $[0] = className;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== value) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), null, value);
        $[2] = value;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== name || $[5] !== t2 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-smart-element": name,
            "data-smart-element-atlaskit-badge": true,
            "data-testid": testId,
            className: t2
        }, t3);
        $[4] = name;
        $[5] = t2;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), null, value));
};
var $26451f799052e0a3$export$2e2bcd8739ae039 = $26451f799052e0a3$var$BaseAtlaskitElementBadge;
const $26451f799052e0a3$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};


const $92f590de7cb9f9cd$var$StoryPointsElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $26451f799052e0a3$export$731812b93bd90554)(context.storyPoints) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26451f799052e0a3$export$2e2bcd8739ae039), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).StoryPoints
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $26451f799052e0a3$export$731812b93bd90554)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26451f799052e0a3$export$2e2bcd8739ae039), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).StoryPoints
    }) : null;
};
var $92f590de7cb9f9cd$export$2e2bcd8739ae039 = $92f590de7cb9f9cd$var$StoryPointsElement;
module.exports["default"] = $92f590de7cb9f9cd$export$2e2bcd8739ae039;

});

parcelRegister("hIbqn", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $9a81c9be82c9d19d$var$TargetBranchElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $aIzVM.toTextProps)(context.targetBranch) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).TargetBranch
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TargetBranch
    }) : null;
};
var $9a81c9be82c9d19d$export$2e2bcd8739ae039 = $9a81c9be82c9d19d$var$TargetBranchElement;
module.exports["default"] = $9a81c9be82c9d19d$export$2e2bcd8739ae039;

});

parcelRegister("b16ZX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $5b6166ad5dd66d6f$var$TeamMemberCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    let t0;
    if ($[0] !== context?.teamMemberCount) {
        const count = context?.teamMemberCount && context?.teamMemberCount > $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT ? `${$5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
        t0 = count ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).team_members_count, count) : null;
        $[0] = context?.teamMemberCount;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).TeamMemberCount
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT ? `${$5b6166ad5dd66d6f$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TeamMemberCount
    }) : null;
};
var $5b6166ad5dd66d6f$export$2e2bcd8739ae039 = $5b6166ad5dd66d6f$var$TeamMemberCountElement;
module.exports["default"] = $5b6166ad5dd66d6f$export$2e2bcd8739ae039;

});

parcelRegister("bG0uM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $abfd64423c5a2d62$var$UserAttributesElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== props) {
        t0 = (userAttributes)=>{
            if (!userAttributes) return null;
            const attributeKeys = [
                "pronouns",
                "role",
                "department",
                "location"
            ];
            const attributes = [];
            attributeKeys.forEach((key)=>{
                if (userAttributes[key]) {
                    const data = (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).user_attributes, userAttributes[key]);
                    if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
                        key: key,
                        ...data,
                        testId: `smart-element-text-${key}`,
                        ...props,
                        name: (0, $5TXU5.ElementName).UserAttributes
                    }));
                }
            });
            return attributes.length > 0 ? attributes : null;
        };
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const renderUserAttributes = t0;
    let t1;
    if ($[2] !== context || $[3] !== renderUserAttributes) {
        t1 = context ? renderUserAttributes(context.userAttributes) : null;
        $[2] = context;
        $[3] = renderUserAttributes;
        $[4] = t1;
    } else t1 = $[4];
    const elements = t1;
    let t2;
    if ($[5] !== elements) {
        t2 = elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements) : null;
        $[5] = elements;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5TXU5.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements) : null;
};
var $abfd64423c5a2d62$export$2e2bcd8739ae039 = $abfd64423c5a2d62$var$UserAttributesElement;
module.exports["default"] = $abfd64423c5a2d62$export$2e2bcd8739ae039;

});

parcelRegister("8OVDp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $34076fdcb2e684ce$var$HostNameElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    let t0;
    if ($[0] !== hostName || $[1] !== props) {
        t0 = hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
            content: hostName,
            ...props,
            name: (0, $5TXU5.ElementName).HostName
        }) : null;
        $[0] = hostName;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const hostName = context?.data?.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        content: hostName,
        ...props,
        name: (0, $5TXU5.ElementName).HostName
    }) : null;
};
var $34076fdcb2e684ce$export$2e2bcd8739ae039 = $34076fdcb2e684ce$var$HostNameElement;
module.exports["default"] = $34076fdcb2e684ce$export$2e2bcd8739ae039;

});

parcelRegister("zH0mb", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $5c7b8fd91da848f0$var$ViewCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.viewCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).View,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).ViewCount
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).View,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ViewCount
    }) : null;
};
var $5c7b8fd91da848f0$export$2e2bcd8739ae039 = $5c7b8fd91da848f0$var$ViewCountElement;
module.exports["default"] = $5c7b8fd91da848f0$export$2e2bcd8739ae039;

});

parcelRegister("6LJqp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $1a9391f1b33e2cfa$var$VoteCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t0;
    if ($[0] !== context) {
        t0 = context ? (0, $9AUBM.toBadgeProps)(context.voteCount?.toString()) : null;
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const data = t0;
    let t1;
    if ($[2] !== data || $[3] !== props) {
        t1 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Vote,
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).VoteCount
        }) : null;
        $[2] = data;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).VoteCount
    }) : null;
};
var $1a9391f1b33e2cfa$export$2e2bcd8739ae039 = $1a9391f1b33e2cfa$var$VoteCountElement;
module.exports["default"] = $1a9391f1b33e2cfa$export$2e2bcd8739ae039;

});

parcelRegister("e4NSt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9AUBM = parcelRequire("9AUBM");

const $97e7d5657b08cc85$var$AppliedToComponentsCountElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(6);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    let t0;
    if ($[0] !== context.appliedToComponentsCount || $[1] !== formatMessage) {
        t0 = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
            numberOfComponents: context.appliedToComponentsCount
        });
        $[0] = context.appliedToComponentsCount;
        $[1] = formatMessage;
        $[2] = t0;
    } else t0 = $[2];
    const label = t0;
    let t1;
    if ($[3] !== label || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
            icon: (0, $5TXU5.IconType).Component,
            label: label,
            ...props
        });
        $[3] = label;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Component,
        label: label,
        ...props
    });
};
var $97e7d5657b08cc85$export$2e2bcd8739ae039 = $97e7d5657b08cc85$var$AppliedToComponentsCountElement;
module.exports["default"] = $97e7d5657b08cc85$export$2e2bcd8739ae039;

});

parcelRegister("4SEPT", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $aIzVM = parcelRequire("aIzVM");

const $1dfde747276dc37b$var$baseStyle = null;
const $1dfde747276dc37b$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(x);
const $1dfde747276dc37b$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $1dfde747276dc37b$var$maxLinesCss = null; /**
                           * Public API — exported externally. Do not add props without external support intent.
                           */ 
const $1dfde747276dc37b$var$CustomElementByAccessType = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { className: className, testId: t1, ...props } = t0;
    const testId = t1 === undefined ? "custom-by-access-type-element" : t1;
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]?.values;
    if ($1dfde747276dc37b$var$isMessageDescriptor(contentForAccessType)) {
        let t2;
        if ($[0] !== contentForAccessType || $[1] !== values) {
            t2 = {
                descriptor: contentForAccessType,
                values: values
            };
            $[0] = contentForAccessType;
            $[1] = values;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== className || $[4] !== props || $[5] !== t2 || $[6] !== testId) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
                ...props,
                message: t2,
                className: className,
                testId: testId,
                hideFormat: true
            });
            $[3] = className;
            $[4] = props;
            $[5] = t2;
            $[6] = testId;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t2;
    if ($[8] !== props.color) {
        t2 = {
            color: props.color
        };
        $[8] = props.color;
        $[9] = t2;
    } else t2 = $[9];
    const t3 = props.fontSize !== undefined && $1dfde747276dc37b$var$fontOverrideStyleMap[props.fontSize];
    let t4;
    if ($[10] !== className || $[11] !== t3) {
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            t3,
            "_1yyjkb7n _102k1j6v",
            className
        ]);
        $[10] = className;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== contentForAccessType || $[14] !== t2 || $[15] !== t4 || $[16] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: t2,
            "data-separator": true,
            "data-smart-element-text": true,
            "data-testid": testId,
            className: t4
        }, contentForAccessType);
        $[13] = contentForAccessType;
        $[14] = t2;
        $[15] = t4;
        $[16] = testId;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]?.values;
    if ($1dfde747276dc37b$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $1dfde747276dc37b$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ])
    }, contentForAccessType);
};
var $1dfde747276dc37b$export$2e2bcd8739ae039 = $1dfde747276dc37b$var$CustomElementByAccessType;
module.exports["default"] = $1dfde747276dc37b$export$2e2bcd8739ae039;

});

parcelRegister("lOpcG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fUfR2 = parcelRequire("fUfR2");

/**
 * Public API — exported externally. Do not add props without external support intent.
 */ const $0ea0c23a597f730f$var$CustomByStatusElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let className;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ className: className, testId: t1, ...props } = t0);
        $[0] = t0;
        $[1] = className;
        $[2] = props;
        $[3] = t1;
    } else {
        className = $[1];
        props = $[2];
        t1 = $[3];
    }
    const testId = t1 === undefined ? "custom-by-status-element" : t1;
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    let t2;
    if ($[4] !== className || $[5] !== component || $[6] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-separator": true,
            "data-smart-element": "custom-element",
            "data-smart-element-text": true,
            "data-testid": testId,
            className: className
        }, component);
        $[4] = className;
        $[5] = component;
        $[6] = testId;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, component);
};
var $0ea0c23a597f730f$export$2e2bcd8739ae039 = $0ea0c23a597f730f$var$CustomByStatusElement;
module.exports["default"] = $0ea0c23a597f730f$export$2e2bcd8739ae039;

});

parcelRegister("6FZ6a", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");








var $gMc0m = parcelRequire("gMc0m");





var $1bHXt = parcelRequire("1bHXt");


var $9YwaJ = parcelRequire("9YwaJ");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");





var $fUfR2 = parcelRequire("fUfR2");


var $l17Fn = parcelRequire("l17Fn");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $0c0e9865fe28e398$var$IconOnlyLarge = null;
const $0c0e9865fe28e398$var$SizeSmall = null;
const $0c0e9865fe28e398$var$styles = {
    textSmall: "_13bowadc _1q9t1wq8 _1rlg1g80 _bdn61h6o"
};
const $0c0e9865fe28e398$var$SizeSmallIconOnly = null;
const $0c0e9865fe28e398$var$SizeSmallNotIconOnly = null;
const $0c0e9865fe28e398$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $0c0e9865fe28e398$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $0c0e9865fe28e398$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $0c0e9865fe28e398$var$ActionButtonRefresh = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(69);
    const { appearance: t1, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const iconOnly = !content;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { product: product } = (0, $l17Fn.default)();
    const isRovoSupported = !!context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction] && !!product && product === "CONFLUENCE";
    const onButtonClick = $0c0e9865fe28e398$var$_temp;
    let t2;
    bb0: {
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? "default" : "compact";
        const icon = iconBefore || iconAfter;
        let t3;
        if ($[0] !== icon) {
            t3 = icon ? ()=>icon : undefined;
            $[0] = icon;
            $[1] = t3;
        } else t3 = $[1];
        const iconFn = t3;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) {
                const t4 = $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance];
                let t5;
                if ($[2] !== onClick) {
                    t5 = onButtonClick(onClick);
                    $[2] = onClick;
                    $[3] = t5;
                } else t5 = $[3];
                let t6;
                if ($[4] !== href || $[5] !== iconFn || $[6] !== isDisabled || $[7] !== spacing || $[8] !== t4 || $[9] !== t5 || $[10] !== testId || $[11] !== tooltipMessage) {
                    t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
                        appearance: t4,
                        icon: iconFn,
                        href: href,
                        isDisabled: isDisabled,
                        isTooltipDisabled: false,
                        label: tooltipMessage,
                        onClick: t5,
                        spacing: spacing,
                        testId: testId,
                        tooltip: $0c0e9865fe28e398$var$tooltipOptions
                    });
                    $[4] = href;
                    $[5] = iconFn;
                    $[6] = isDisabled;
                    $[7] = spacing;
                    $[8] = t4;
                    $[9] = t5;
                    $[10] = testId;
                    $[11] = tooltipMessage;
                    $[12] = t6;
                } else t6 = $[12];
                t2 = t6;
                break bb0;
            }
            const t4 = $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance];
            let t5;
            if ($[13] !== onClick) {
                t5 = onButtonClick(onClick);
                $[13] = onClick;
                $[14] = t5;
            } else t5 = $[14];
            let t6;
            if ($[15] !== iconFn || $[16] !== isDisabled || $[17] !== isLoading || $[18] !== spacing || $[19] !== t4 || $[20] !== t5 || $[21] !== testId || $[22] !== tooltipMessage) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    appearance: t4,
                    icon: iconFn,
                    isDisabled: isDisabled,
                    isLoading: isLoading,
                    isTooltipDisabled: false,
                    label: tooltipMessage,
                    onClick: t5,
                    spacing: spacing,
                    testId: testId,
                    tooltip: $0c0e9865fe28e398$var$tooltipOptions
                });
                $[15] = iconFn;
                $[16] = isDisabled;
                $[17] = isLoading;
                $[18] = spacing;
                $[19] = t4;
                $[20] = t5;
                $[21] = testId;
                $[22] = tooltipMessage;
                $[23] = t6;
            } else t6 = $[23];
            t2 = t6;
            break bb0;
        }
        let t4;
        if ($[24] !== iconBefore) {
            t4 = iconBefore ? ()=>iconBefore : undefined;
            $[24] = iconBefore;
            $[25] = t4;
        } else t4 = $[25];
        const iconBeforeFn = t4;
        let t5;
        if ($[26] !== iconAfter) {
            t5 = iconAfter ? ()=>iconAfter : undefined;
            $[26] = iconAfter;
            $[27] = t5;
        } else t5 = $[27];
        const iconAfterFn = t5;
        if (isLinkButton) {
            const t6 = `${testId}-tooltip`;
            const t7 = $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance];
            let t8;
            if ($[28] !== onClick) {
                t8 = onButtonClick(onClick);
                $[28] = onClick;
                $[29] = t8;
            } else t8 = $[29];
            let t9;
            if ($[30] !== ariaLabel || $[31] !== content || $[32] !== href || $[33] !== iconAfterFn || $[34] !== iconBeforeFn || $[35] !== isDisabled || $[36] !== spacing || $[37] !== t7 || $[38] !== t8 || $[39] !== testId) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                    appearance: t7,
                    "aria-label": ariaLabel,
                    iconAfter: iconAfterFn,
                    iconBefore: iconBeforeFn,
                    isDisabled: isDisabled,
                    href: href,
                    onClick: t8,
                    spacing: spacing,
                    testId: testId
                }, content);
                $[30] = ariaLabel;
                $[31] = content;
                $[32] = href;
                $[33] = iconAfterFn;
                $[34] = iconBeforeFn;
                $[35] = isDisabled;
                $[36] = spacing;
                $[37] = t7;
                $[38] = t8;
                $[39] = testId;
                $[40] = t9;
            } else t9 = $[40];
            let t10;
            if ($[41] !== t6 || $[42] !== t9 || $[43] !== tooltipMessage) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: tooltipMessage,
                    hideTooltipOnClick: true,
                    testId: t6
                }, t9);
                $[41] = t6;
                $[42] = t9;
                $[43] = tooltipMessage;
                $[44] = t10;
            } else t10 = $[44];
            t2 = t10;
            break bb0;
        }
        const t6 = `${testId}-tooltip`;
        const t7 = $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance];
        let t8;
        if ($[45] !== onClick) {
            t8 = onButtonClick(onClick);
            $[45] = onClick;
            $[46] = t8;
        } else t8 = $[46];
        let t9;
        if ($[47] !== ariaLabel || $[48] !== content || $[49] !== iconAfterFn || $[50] !== iconBeforeFn || $[51] !== isDisabled || $[52] !== isLoading || $[53] !== spacing || $[54] !== t7 || $[55] !== t8 || $[56] !== testId) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: t7,
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: t8,
                spacing: spacing,
                testId: testId
            }, content);
            $[47] = ariaLabel;
            $[48] = content;
            $[49] = iconAfterFn;
            $[50] = iconBeforeFn;
            $[51] = isDisabled;
            $[52] = isLoading;
            $[53] = spacing;
            $[54] = t7;
            $[55] = t8;
            $[56] = testId;
            $[57] = t9;
        } else t9 = $[57];
        let t10;
        if ($[58] !== t6 || $[59] !== t9 || $[60] !== tooltipMessage) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: tooltipMessage,
                hideTooltipOnClick: true,
                testId: t6
            }, t9);
            $[58] = t6;
            $[59] = t9;
            $[60] = tooltipMessage;
            $[61] = t10;
        } else t10 = $[61];
        t2 = t10;
    }
    const button = t2;
    const t3 = `${testId}-button-wrapper`;
    const t4 = isRovoSupported && size === (0, $5TXU5.SmartLinkSize).Small && $0c0e9865fe28e398$var$styles.textSmall;
    let t5;
    if ($[62] !== t4) {
        t5 = (0, $1bHXt.cx)(t4);
        $[62] = t4;
        $[63] = t5;
    } else t5 = $[63];
    let t6;
    if ($[64] !== button || $[65] !== ref || $[66] !== t3 || $[67] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: t3,
            ref: ref,
            xcss: t5
        }, button);
        $[64] = button;
        $[65] = ref;
        $[66] = t3;
        $[67] = t5;
        $[68] = t6;
    } else t6 = $[68];
    return t6;
} : ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { product: product } = (0, $l17Fn.default)();
    const isRovoSupported = !!context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction] && !!product && product === 'CONFLUENCE';
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $42omo.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $1bHXt.cx)(isRovoSupported && size === (0, $5TXU5.SmartLinkSize).Small && $0c0e9865fe28e398$var$styles.textSmall)
    }, button);
});
const $0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss = (0, $1iDg7.withOverrideCss)($0c0e9865fe28e398$var$ActionButtonRefresh);
const $0c0e9865fe28e398$var$ActionButtonNew = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { appearance: t1, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const iconOnly = !content;
    const onButtonClick = $0c0e9865fe28e398$var$_temp2;
    const t2 = size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf";
    const t3 = size === (0, $5TXU5.SmartLinkSize).Small && "_11c8wadc _k48p1wq8";
    const t4 = size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o";
    const t5 = size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66";
    let t6;
    if ($[0] !== className || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = (0, $gMc0m.default)([
            t2,
            t3,
            t4,
            t5,
            className
        ]);
        $[0] = className;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = `${testId}-button-wrapper`;
    const t8 = `${testId}-tooltip`;
    let t9;
    if ($[6] !== onClick) {
        t9 = onButtonClick(onClick);
        $[6] = onClick;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = (0, $hJgLA.sizeToButtonSpacing)[size];
    let t11;
    if ($[8] !== appearance || $[9] !== ariaLabel || $[10] !== content || $[11] !== href || $[12] !== iconAfter || $[13] !== iconBefore || $[14] !== isDisabled || $[15] !== isLoading || $[16] !== t10 || $[17] !== t9 || $[18] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
            appearance: appearance,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: t9,
            spacing: t10,
            testId: testId,
            href: href,
            "aria-label": ariaLabel
        }, content);
        $[8] = appearance;
        $[9] = ariaLabel;
        $[10] = content;
        $[11] = href;
        $[12] = iconAfter;
        $[13] = iconBefore;
        $[14] = isDisabled;
        $[15] = isLoading;
        $[16] = t10;
        $[17] = t9;
        $[18] = testId;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== t11 || $[21] !== t8 || $[22] !== tooltipMessage) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: t8
        }, t11);
        $[20] = t11;
        $[21] = t8;
        $[22] = tooltipMessage;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12 || $[25] !== t6 || $[26] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t6,
            "data-testid": t7
        }, t12);
        $[24] = t12;
        $[25] = t6;
        $[26] = t7;
        $[27] = t13;
    } else t13 = $[27];
    return t13;
} : ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $42omo.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5TXU5.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $hJgLA.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $0c0e9865fe28e398$var$ActionButton = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonNew, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c0e9865fe28e398$var$ActionButtonNew, props);
};
var $0c0e9865fe28e398$export$2e2bcd8739ae039 = $0c0e9865fe28e398$var$ActionButton;
function $0c0e9865fe28e398$var$_temp(handler) {
    return (e)=>{
        e.preventDefault();
        handler();
    };
}
function $0c0e9865fe28e398$var$_temp2(handler) {
    return (e)=>{
        e.preventDefault();
        handler();
    };
}












var $dAYOx = parcelRequire("dAYOx");


var $ivUmx = parcelRequire("ivUmx");

const $4e516599d84c6e93$var$ActionDropdownItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = (0, $ivUmx.handleOnClick)(onClick);
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== content || $[3] !== iconAfter || $[4] !== iconBefore || $[5] !== isLoading || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            elemAfter: iconAfter,
            elemBefore: iconBefore,
            isDisabled: isLoading,
            onClick: t1,
            testId: testId
        }, content);
        $[2] = content;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = isLoading;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $ivUmx.handleOnClick)(onClick),
        testId: testId
    }, content);
var $4e516599d84c6e93$export$2e2bcd8739ae039 = $4e516599d84c6e93$var$ActionDropdownItem;














const $cc9e773a3279151b$var$stackItemIconStylesCompiled = null;
const $cc9e773a3279151b$var$ActionIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { testId: testId, icon: icon } = t0;
    const t1 = `${testId}-icon`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_1e0c116y"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== icon || $[2] !== t1) {
        t3 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": t1,
            className: t2
        }, icon);
        $[1] = icon;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $gMc0m.default)([
            "_1e0c116y"
        ])
    }, icon);
};
var $cc9e773a3279151b$export$2e2bcd8739ae039 = $cc9e773a3279151b$var$ActionIcon;
























var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");




var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9hlns = parcelRequire("9hlns");


var $dZ8uq = parcelRequire("dZ8uq");





const $cb337baea8f1bcdf$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo",
    spinner: "_1bsb1tcg _4t3i1tcg _1e0c116y _4cvr1h6o _1bah1h6o"
};
const $cb337baea8f1bcdf$var$ActionButton = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] !== size || $[1] !== spaceOption) {
        t1 = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
        $[0] = size;
        $[1] = spaceOption;
        $[2] = t1;
    } else t1 = $[2];
    const space = t1;
    let t2;
    if ($[3] !== isDisabled || $[4] !== isLoading || $[5] !== onClickCallback) {
        t2 = ()=>{
            if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
        };
        $[3] = isDisabled;
        $[4] = isLoading;
        $[5] = onClickCallback;
        $[6] = t2;
    } else t2 = $[6];
    const onClick = t2;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") && (0, $dZ8uq.expValEqualsNoExposure)("platform_sl_3p_auth_rovo_action", "isEnabled", true);
        $[7] = t3;
    } else t3 = $[7];
    const is3pExperimentEnabled = t3;
    let t4;
    if ($[8] !== iconOption || $[9] !== isLoading || $[10] !== testId) {
        t4 = iconOption && isLoading ? /*#__PURE__*/ $42omo.createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
            icon: is3pExperimentEnabled ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                xcss: $cb337baea8f1bcdf$var$styles.spinner
            }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                size: 16,
                testId: `${testId}-loading`
            })) : /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
                testId: `${testId}-loading`
            })
        }) : iconOption;
        $[8] = iconOption;
        $[9] = isLoading;
        $[10] = testId;
        $[11] = t4;
    } else t4 = $[11];
    const icon = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.button);
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== ariaLabel) {
        t6 = (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") ? {
            "aria-label": ariaLabel
        } : {};
        $[13] = ariaLabel;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.content);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== content) {
        t8 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: t7
        }, content);
        $[16] = content;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== icon || $[19] !== space || $[20] !== t8) {
        t9 = /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            grow: "fill",
            space: space
        }, icon, t8);
        $[18] = icon;
        $[19] = space;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== onClick || $[23] !== style || $[24] !== t6 || $[25] !== t9 || $[26] !== testId || $[27] !== tooltipProps) {
        t10 = /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            xcss: t5,
            ...tooltipProps,
            onClick: onClick,
            testId: testId,
            style: style,
            ...t6
        }, t9);
        $[22] = onClick;
        $[23] = style;
        $[24] = t6;
        $[25] = t9;
        $[26] = testId;
        $[27] = tooltipProps;
        $[28] = t10;
    } else t10 = $[28];
    return t10;
} : ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const is3pExperimentEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') && (0, $dZ8uq.expValEqualsNoExposure)('platform_sl_3p_auth_rovo_action', 'isEnabled', true);
    const icon = iconOption && isLoading ? /*#__PURE__*/ $42omo.createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: is3pExperimentEnabled ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $cb337baea8f1bcdf$var$styles.spinner
        }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        style: style,
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? {
            'aria-label': ariaLabel
        } : {}
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($cb337baea8f1bcdf$var$styles.content)
    }, content)));
};
var $cb337baea8f1bcdf$export$2e2bcd8739ae039 = $cb337baea8f1bcdf$var$ActionButton;


const $e828a55eaf50791b$var$ActionStackItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    let content;
    let hideTooltip;
    let hideTooltipOnMouseDown;
    let props;
    let tooltipMessage;
    let tooltipOnHide;
    if ($[0] !== t0) {
        ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props } = t0);
        $[0] = t0;
        $[1] = content;
        $[2] = hideTooltip;
        $[3] = hideTooltipOnMouseDown;
        $[4] = props;
        $[5] = tooltipMessage;
        $[6] = tooltipOnHide;
    } else {
        content = $[1];
        hideTooltip = $[2];
        hideTooltipOnMouseDown = $[3];
        props = $[4];
        tooltipMessage = $[5];
        tooltipOnHide = $[6];
    }
    let t1;
    if ($[7] !== content || $[8] !== hideTooltip || $[9] !== hideTooltipOnMouseDown || $[10] !== props || $[11] !== tooltipMessage || $[12] !== tooltipOnHide) {
        t1 = hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
            ...props,
            content: content
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipMessage || content,
            onHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            }));
        $[7] = content;
        $[8] = hideTooltip;
        $[9] = hideTooltipOnMouseDown;
        $[10] = props;
        $[11] = tooltipMessage;
        $[12] = tooltipOnHide;
        $[13] = t1;
    } else t1 = $[13];
    return t1;
} : ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>{
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb337baea8f1bcdf$export$2e2bcd8739ae039), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $e828a55eaf50791b$export$2e2bcd8739ae039 = $e828a55eaf50791b$var$ActionStackItem;


/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1f726fde681f8fde$var$Action = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { as: as, appearance: t1, content: content, isLoading: t2, onClick: onClick, size: t3, testId: t4, icon: icon, iconPosition: t5, spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const isLoading = t2 === undefined ? false : t2;
    const size = t3 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t3;
    const testId = t4 === undefined ? "smart-action" : t4;
    const iconPosition = t5 === undefined ? "before" : t5;
    if (!onClick) return null;
    const isStackItem = as === "stack-item";
    const isDropdownItem = as === "dropdown-item" || asDropDownItem;
    let t6;
    if ($[0] !== icon || $[1] !== testId) {
        t6 = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
            icon: icon,
            testId: testId
        }) : undefined;
        $[0] = icon;
        $[1] = testId;
        $[2] = t6;
    } else t6 = $[2];
    const actionIcon = t6;
    const iconBefore = icon && iconPosition === "before" ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === "after" ? actionIcon : undefined;
    if (isStackItem) {
        const t7 = tooltipMessage || content;
        let t8;
        if ($[3] !== actionIcon || $[4] !== ariaLabel || $[5] !== content || $[6] !== hideTooltip || $[7] !== hideTooltipOnMouseDown || $[8] !== isDisabled || $[9] !== isLoading || $[10] !== onClick || $[11] !== size || $[12] !== spaceInline || $[13] !== style || $[14] !== t7 || $[15] !== testId || $[16] !== tooltipOnHide) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e828a55eaf50791b$export$2e2bcd8739ae039), {
                content: content,
                icon: actionIcon,
                space: spaceInline,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onClick,
                size: size,
                testId: testId,
                tooltipMessage: t7,
                style: style,
                tooltipOnHide: tooltipOnHide,
                hideTooltipOnMouseDown: hideTooltipOnMouseDown,
                hideTooltip: hideTooltip,
                ariaLabel: ariaLabel
            });
            $[3] = actionIcon;
            $[4] = ariaLabel;
            $[5] = content;
            $[6] = hideTooltip;
            $[7] = hideTooltipOnMouseDown;
            $[8] = isDisabled;
            $[9] = isLoading;
            $[10] = onClick;
            $[11] = size;
            $[12] = spaceInline;
            $[13] = style;
            $[14] = t7;
            $[15] = testId;
            $[16] = tooltipOnHide;
            $[17] = t8;
        } else t8 = $[17];
        return t8;
    }
    if (isDropdownItem) {
        let t7;
        if ($[18] !== content || $[19] !== iconAfter || $[20] !== iconBefore || $[21] !== isLoading || $[22] !== onClick || $[23] !== testId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e516599d84c6e93$export$2e2bcd8739ae039), {
                content: content,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isLoading: isLoading,
                onClick: onClick,
                testId: testId
            });
            $[18] = content;
            $[19] = iconAfter;
            $[20] = iconBefore;
            $[21] = isLoading;
            $[22] = onClick;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    const t7 = tooltipMessage || content;
    let t8;
    if ($[25] !== appearance || $[26] !== ariaLabel || $[27] !== className || $[28] !== content || $[29] !== href || $[30] !== iconAfter || $[31] !== iconBefore || $[32] !== isDisabled || $[33] !== isLoading || $[34] !== onClick || $[35] !== size || $[36] !== t7 || $[37] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c0e9865fe28e398$export$2e2bcd8739ae039), {
            appearance: appearance,
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            className: className,
            size: size,
            testId: testId,
            tooltipMessage: t7,
            isDisabled: isDisabled,
            href: href,
            ariaLabel: ariaLabel
        });
        $[25] = appearance;
        $[26] = ariaLabel;
        $[27] = className;
        $[28] = content;
        $[29] = href;
        $[30] = iconAfter;
        $[31] = iconBefore;
        $[32] = isDisabled;
        $[33] = isLoading;
        $[34] = onClick;
        $[35] = size;
        $[36] = t7;
        $[37] = testId;
        $[38] = t8;
    } else t8 = $[38];
    const button = t8;
    let t9;
    if ($[39] !== Wrapper || $[40] !== button) {
        t9 = Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, button) : button;
        $[39] = Wrapper;
        $[40] = button;
        $[41] = t9;
    } else t9 = $[41];
    return t9;
} : ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc9e773a3279151b$export$2e2bcd8739ae039), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e828a55eaf50791b$export$2e2bcd8739ae039), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e516599d84c6e93$export$2e2bcd8739ae039), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c0e9865fe28e398$export$2e2bcd8739ae039), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, button) : button;
};
var $1f726fde681f8fde$export$2e2bcd8739ae039 = $1f726fde681f8fde$var$Action;
module.exports["default"] = $1f726fde681f8fde$export$2e2bcd8739ae039;

});

parcelRegister("jLXEH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hmuev = parcelRequire("hmuev");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $f415990ae4e7261e$var$DeleteAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: t0,
            icon: t1,
            testId: "smart-action-delete-action",
            tooltipMessage: t2,
            ...props
        });
        $[3] = props;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).delete),
        ...props
    });
var $f415990ae4e7261e$export$2e2bcd8739ae039 = $f415990ae4e7261e$var$DeleteAction;
module.exports["default"] = $f415990ae4e7261e$export$2e2bcd8739ae039;

});

parcelRegister("dVBHR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Zr9M = parcelRequire("1Zr9M");


var $afp1H = parcelRequire("afp1H");


var $6FZ6a = parcelRequire("6FZ6a");

const $a74c68e5cf0852d5$var$EditAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        });
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: t0,
            icon: t1,
            testId: "smart-action-edit-action",
            tooltipMessage: t2,
            ...props
        });
        $[3] = props;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).edit),
        ...props
    });
var $a74c68e5cf0852d5$export$2e2bcd8739ae039 = $a74c68e5cf0852d5$var$EditAction;
module.exports["default"] = $a74c68e5cf0852d5$export$2e2bcd8739ae039;

});

parcelRegister("cLh5D", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9aGns = parcelRequire("9aGns");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $6FZ6a = parcelRequire("6FZ6a");

const $47aa84bed0904f6b$var$DownloadAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    let onClickCallback;
    let props;
    if ($[0] !== t0) {
        ({ onClick: onClickCallback, ...props } = t0);
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = props;
    } else {
        onClickCallback = $[1];
        props = $[2];
    }
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[3] = t1;
    } else t1 = $[3];
    const invoke = (0, $9oOnT.default)(t1);
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    let t2;
    if ($[4] !== data || $[5] !== invoke || $[6] !== onClickCallback) {
        t2 = ()=>{
            if (data?.invokeAction) {
                invoke(data.invokeAction);
                onClickCallback?.();
            }
        };
        $[4] = data;
        $[5] = invoke;
        $[6] = onClickCallback;
        $[7] = t2;
    } else t2 = $[7];
    const onClick = t2;
    const isStackItem = props.as === "stack-item";
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    let t3;
    if ($[8] !== data || $[9] !== label || $[10] !== onClick || $[11] !== props || $[12] !== tooltipMessage) {
        t3 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Download"
            }),
            onClick: onClick,
            testId: "smart-action-download-action",
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
            ...data,
            ...props
        }) : null;
        $[8] = data;
        $[9] = label;
        $[10] = onClick;
        $[11] = props;
        $[12] = tooltipMessage;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $47aa84bed0904f6b$export$2e2bcd8739ae039 = $47aa84bed0904f6b$var$DownloadAction;
module.exports["default"] = $47aa84bed0904f6b$export$2e2bcd8739ae039;

});

parcelRegister("9l03X", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $hJgLA = parcelRequire("hJgLA");





var $kKODE = parcelRequire("kKODE");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");

const $8421257f1cf5034c$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $8421257f1cf5034c$export$2e2bcd8739ae039 = $8421257f1cf5034c$var$createInvokeRequest;



var $6FZ6a = parcelRequire("6FZ6a");

const $a36d75dc0f2bdcbc$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const invoke = (0, $g98dH.default)();
    const reload = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $8421257f1cf5034c$export$2e2bcd8739ae039)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload({
                    url: action.reload.url,
                    isReloading: true,
                    id: action.reload.id
                });
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8i8ID.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $a36d75dc0f2bdcbc$export$2e2bcd8739ae039 = $a36d75dc0f2bdcbc$var$ServerAction;








const $3c347798ab285251$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_errorGalaxia : (0, $afp1H.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_errorGalaxia : (0, $afp1H.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $afp1H.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $afp1H.messages).unfollow_goal_error;
    return (0, $afp1H.messages).generic_error_message;
};




const $fd35d1180b7d8d14$var$importIconMapper = {
    goal: ()=>(parcelRequire("bRnvt")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9RQQm")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $fd35d1180b7d8d14$var$getIcon = (stackIconType)=>{
    const importFn = $fd35d1180b7d8d14$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hJgLA.importIcon)(importFn);
};
const $fd35d1180b7d8d14$var$FollowAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(28);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const intl = (0, $aXWIB.useIntl)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    let data;
    let isProject;
    let value;
    if ($[0] !== actionData) {
        ({ value: value, isProject: isProject, ...data } = actionData);
        $[0] = actionData;
        $[1] = data;
        $[2] = isProject;
        $[3] = value;
    } else {
        data = $[1];
        isProject = $[2];
        value = $[3];
    }
    const isStackItem = props.as === "stack-item";
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $c6GJD.default).getExperimentValue("project-terminology-refresh", "isEnabled", false) ? (0, $afp1H.messages).follow_project_descriptionGalaxia : (0, $afp1H.messages).follow_project_description : (0, $c6GJD.default).getExperimentValue("project-terminology-refresh", "isEnabled", false) ? (0, $afp1H.messages).unfollow_project_descriptionGalaxia : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? "projects" : "goal";
    let t0;
    if ($[4] !== stackIconType) {
        t0 = $fd35d1180b7d8d14$var$getIcon(stackIconType);
        $[4] = stackIconType;
        $[5] = t0;
    } else t0 = $[5];
    const ImportedIcon = t0;
    const t1 = `smart-action-follow-action-${stackIconType}-icon`;
    let t2;
    if ($[6] !== ImportedIcon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
            label: "Follow",
            testId: t1
        });
        $[6] = ImportedIcon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    const followIcon = t2;
    let t3;
    if ($[9] !== isProject || $[10] !== props || $[11] !== value) {
        t3 = ()=>{
            const { onError: onErrorCallback } = props;
            const errorMessage = (0, $3c347798ab285251$export$49248678d3914625)(isProject, value);
            onErrorCallback?.({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), errorMessage),
                appearance: "error"
            });
        };
        $[9] = isProject;
        $[10] = props;
        $[11] = value;
        $[12] = t3;
    } else t3 = $[12];
    const handleError = t3;
    let t4;
    if ($[13] !== label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label);
        $[13] = label;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== intl || $[16] !== label) {
        t5 = (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") ? {
            ariaLabel: intl.formatMessage(label)
        } : {};
        $[15] = intl;
        $[16] = label;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== tooltipMessage) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage);
        $[18] = tooltipMessage;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== data || $[21] !== followIcon || $[22] !== handleError || $[23] !== props || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a36d75dc0f2bdcbc$export$2e2bcd8739ae039), {
            content: t4,
            ...t5,
            icon: followIcon,
            testId: "smart-action-follow-action",
            tooltipMessage: t6,
            ...data,
            ...props,
            onError: handleError
        });
        $[20] = data;
        $[21] = followIcon;
        $[22] = handleError;
        $[23] = props;
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const intl = (0, $aXWIB.useIntl)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).follow_project_descriptionGalaxia : (0, $afp1H.messages).follow_project_description : (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $afp1H.messages).unfollow_project_descriptionGalaxia : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $fd35d1180b7d8d14$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $3c347798ab285251$export$49248678d3914625)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a36d75dc0f2bdcbc$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label),
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? {
            ariaLabel: intl.formatMessage(label)
        } : {},
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $fd35d1180b7d8d14$export$2e2bcd8739ae039 = $fd35d1180b7d8d14$var$FollowAction;
module.exports["default"] = $fd35d1180b7d8d14$export$2e2bcd8739ae039;

});

parcelRegister("2vLbR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lOzEN = parcelRequire("lOzEN");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $l17Fn = parcelRequire("l17Fn");


var $6FZ6a = parcelRequire("6FZ6a");

const $b8c6ed50ac412c77$var$PreviewAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let onClickCallback;
    let props;
    if ($[0] !== t0) {
        ({ onClick: onClickCallback, ...props } = t0);
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = props;
    } else {
        onClickCallback = $[1];
        props = $[2];
    }
    const intl = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[3] = t1;
    } else t1 = $[3];
    const invoke = (0, $9oOnT.default)(t1);
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const { product: product } = (0, $l17Fn.default)();
    let t2;
    if ($[4] !== data || $[5] !== invoke || $[6] !== onClickCallback) {
        t2 = ()=>{
            if (data?.invokeAction) {
                invoke(data.invokeAction);
                onClickCallback?.();
            }
        };
        $[4] = data;
        $[5] = invoke;
        $[6] = onClickCallback;
        $[7] = t2;
    } else t2 = $[7];
    const onClick = t2;
    const isStackItem = props.as === "stack-item";
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    let t3;
    if ($[8] !== hasPreviewPanel || $[9] !== product || $[10] !== props.iconSize) {
        t3 = ()=>{
            if ((0, $1oCLl.expValEquals)("platform_hover_card_preview_panel", "cohort", "test") && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                ...(0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") || !!product && product === "CONFLUENCE" ? {
                    size: props.iconSize
                } : {}
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                ...(0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") || !!product && product === "CONFLUENCE" ? {
                    size: props.iconSize
                } : {}
            });
        };
        $[8] = hasPreviewPanel;
        $[9] = product;
        $[10] = props.iconSize;
        $[11] = t3;
    } else t3 = $[11];
    const actionIcon = t3;
    let t4;
    bb0: {
        if ((0, $1oCLl.expValEquals)("platform_hover_card_preview_panel", "cohort", "test") && hasPreviewPanel) {
            t4 = (0, $afp1H.messages).preview_panel;
            break bb0;
        }
        if ((0, $1oCLl.expValEquals)("platform_hover_card_preview_panel", "cohort", "test")) {
            t4 = (0, $afp1H.messages).preview_modal;
            break bb0;
        }
        t4 = (0, $afp1H.messages).preview_improved;
    }
    const actionLabel = t4;
    let t5;
    if ($[12] !== actionLabel || $[13] !== intl) {
        t5 = intl.formatMessage(actionLabel);
        $[12] = actionLabel;
        $[13] = intl;
        $[14] = t5;
    } else t5 = $[14];
    const actionMessage = t5;
    let t6;
    if ($[15] !== actionIcon || $[16] !== actionMessage || $[17] !== data || $[18] !== onClick || $[19] !== props || $[20] !== tooltipMessage) {
        t6 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            ariaLabel: actionMessage,
            content: actionMessage,
            icon: actionIcon(),
            onClick: onClick,
            testId: "smart-action-preview-action",
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
            hideTooltipOnMouseDown: true,
            ...data,
            ...props
        }) : null;
        $[15] = actionIcon;
        $[16] = actionMessage;
        $[17] = data;
        $[18] = onClick;
        $[19] = props;
        $[20] = tooltipMessage;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const { product: product } = (0, $l17Fn.default)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    const actionIcon = (0, $42omo.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || !!product && product === 'CONFLUENCE' ? {
                size: props.iconSize
            } : {}
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || !!product && product === 'CONFLUENCE' ? {
                size: props.iconSize
            } : {}
        });
    }, [
        hasPreviewPanel,
        props.iconSize,
        product
    ]);
    const actionLabel = (0, $42omo.useMemo)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return (0, $afp1H.messages).preview_panel;
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return (0, $afp1H.messages).preview_modal;
        return (0, $afp1H.messages).preview_improved;
    }, [
        hasPreviewPanel
    ]);
    const actionMessage = intl.formatMessage(actionLabel);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ariaLabel: actionMessage,
        content: actionMessage,
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $b8c6ed50ac412c77$export$2e2bcd8739ae039 = $b8c6ed50ac412c77$var$PreviewAction;
module.exports["default"] = $b8c6ed50ac412c77$export$2e2bcd8739ae039;

});

parcelRegister("apOlf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $l17Fn = parcelRequire("l17Fn");


var $6FZ6a = parcelRequire("6FZ6a");

const $a91d440270dbacf8$var$CopyLinkAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    let onClickCallback;
    let props;
    if ($[0] !== t0) {
        ({ onClick: onClickCallback, ...props } = t0);
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = props;
    } else {
        onClickCallback = $[1];
        props = $[2];
    }
    const intl = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[3] = t1;
    } else t1 = $[3];
    const invoke = (0, $9oOnT.default)(t1);
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const { product: product } = (0, $l17Fn.default)();
    let t2;
    if ($[4] !== data || $[5] !== invoke || $[6] !== onClickCallback) {
        t2 = ()=>{
            if (data?.invokeAction) {
                invoke({
                    ...data.invokeAction,
                    actionFn: async ()=>{
                        await data.invokeAction?.actionFn();
                        setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                    }
                });
                onClickCallback?.();
            }
        };
        $[4] = data;
        $[5] = invoke;
        $[6] = onClickCallback;
        $[7] = t2;
    } else t2 = $[7];
    const onClick = t2;
    let t3;
    if ($[8] !== data || $[9] !== intl || $[10] !== onClick || $[11] !== product || $[12] !== props || $[13] !== tooltipMessage) {
        t3 = data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            ariaLabel: intl.formatMessage((0, $afp1H.messages).copy_url_to_clipboard),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_url_to_clipboard),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                color: "currentColor",
                label: "",
                spacing: "spacious",
                ...(0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") || !!product && product === "CONFLUENCE" ? {
                    size: props.iconSize
                } : {}
            }),
            onClick: onClick,
            testId: "smart-action-copy-link-action",
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
            ...data,
            ...props
        }) : null;
        $[8] = data;
        $[9] = intl;
        $[10] = onClick;
        $[11] = product;
        $[12] = props;
        $[13] = tooltipMessage;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ onClick: onClickCallback, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const { product: product } = (0, $l17Fn.default)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        ariaLabel: intl.formatMessage((0, $afp1H.messages).copy_url_to_clipboard),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || !!product && product === 'CONFLUENCE' ? {
                size: props.iconSize
            } : {}
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $a91d440270dbacf8$export$2e2bcd8739ae039 = $a91d440270dbacf8$var$CopyLinkAction;
module.exports["default"] = $a91d440270dbacf8$export$2e2bcd8739ae039;

});

parcelRegister("fl0WE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");





var $fBMbo = parcelRequire("fBMbo");


var $dh538 = parcelRequire("dh538");


var $6KV13 = parcelRequire("6KV13");











var $aXWIB = parcelRequire("aXWIB");


var $gNXND = parcelRequire("gNXND");





var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $l17Fn = parcelRequire("l17Fn");


var $6FZ6a = parcelRequire("6FZ6a");








var $kbh18 = parcelRequire("kbh18");













const $9dd168d53d6086c0$var$AIEventErrorViewed = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { reason: reason } = t0;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== fireEvent || $[1] !== reason) {
        t1 = ()=>{
            fireEvent("ui.error.viewed.aiSummary", {
                reason: reason
            });
        };
        t2 = [
            fireEvent,
            reason
        ];
        $[0] = fireEvent;
        $[1] = reason;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $9dd168d53d6086c0$export$2e2bcd8739ae039 = $9dd168d53d6086c0$var$AIEventErrorViewed;












var $2Nwuj = parcelRequire("2Nwuj");




const $287ebec1fdd40e02$var$AILearnMoreAnchor = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: (0, $5TXU5.CONTENT_URL_ROVO),
            target: "_blank",
            rel: "noopener noreferrer",
            ...props
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: (0, $5TXU5.CONTENT_URL_ROVO),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $287ebec1fdd40e02$export$2e2bcd8739ae039 = $287ebec1fdd40e02$var$AILearnMoreAnchor;


const $b750d65dda1a4c8d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $kbh18.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9dd168d53d6086c0$export$2e2bcd8739ae039), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $287ebec1fdd40e02$export$2e2bcd8739ae039), {
                        href: url
                    }, chunks)
            }
        }))
    };
};


const $276cdae1a40ee2d2$export$75a19de44af58722 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function AISummariseAction(t0) {
    const $ = (0, $frIzR.c)(25);
    let onClickCallback;
    let onErrorCallback;
    let props;
    let status;
    let summariseUrl;
    let testId;
    if ($[0] !== t0) {
        ({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props } = t0);
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = onErrorCallback;
        $[3] = props;
        $[4] = status;
        $[5] = summariseUrl;
        $[6] = testId;
    } else {
        onClickCallback = $[1];
        onErrorCallback = $[2];
        props = $[3];
        status = $[4];
        summariseUrl = $[5];
        testId = $[6];
    }
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { product: product } = (0, $l17Fn.default)();
    let t1;
    if ($[7] !== onErrorCallback) {
        t1 = (state)=>{
            if (state?.status === "error") onErrorCallback?.((0, $b750d65dda1a4c8d$export$82f46aa4e6535a45)(state.error));
        };
        $[7] = onErrorCallback;
        $[8] = t1;
    } else t1 = $[8];
    const onCompleted = t1;
    let t2;
    if ($[9] !== fireEvent || $[10] !== onClickCallback || $[11] !== onCompleted || $[12] !== summariseUrl) {
        t2 = ()=>{
            fireEvent("ui.button.clicked.aiSummary", {});
            fireEvent("track.aiInteraction.initiated", {
                aiFeatureName: "Smart Links Summary",
                proactiveAIGenerated: 0,
                userGeneratedAI: 1
            });
            summariseUrl()?.then(onCompleted, onCompleted);
            onClickCallback?.();
        };
        $[9] = fireEvent;
        $[10] = onClickCallback;
        $[11] = onCompleted;
        $[12] = summariseUrl;
        $[13] = t2;
    } else t2 = $[13];
    const handleActionClick = t2;
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summary_action_rebrand);
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== product || $[16] !== props) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            ...(0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") || !!product && product === "CONFLUENCE" ? {
                size: props.iconSize
            } : {}
        });
        $[15] = product;
        $[16] = props;
        $[17] = t4;
    } else t4 = $[17];
    const t5 = `${testId}-summarise-action`;
    const t6 = status === "loading";
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summary_action_description_rebrand);
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== handleActionClick || $[20] !== props || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: t3,
            icon: t4,
            onClick: handleActionClick,
            testId: t5,
            isLoading: t6,
            tooltipMessage: t7,
            ...props
        });
        $[19] = handleActionClick;
        $[20] = props;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : function AISummariseAction({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { product: product } = (0, $l17Fn.default)();
    const onCompleted = (0, $42omo.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $b750d65dda1a4c8d$export$82f46aa4e6535a45)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summary_action_rebrand),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || !!product && product === 'CONFLUENCE' ? {
                size: props.iconSize
            } : {}
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).ai_summary_action_description_rebrand),
        ...props
    });
};















var $2MuFw = parcelRequire("2MuFw");










const $8b66580330514e65$export$cfa1d3eed9a61059 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CopySummaryAction(t0) {
    const $ = (0, $frIzR.c)(19);
    let content;
    let onClickCallback;
    let props;
    let testId;
    if ($[0] !== t0) {
        const { url: url, onClick: t1, testId: t2, content: t3, ...t4 } = t0;
        onClickCallback = t1;
        testId = t2;
        content = t3;
        props = t4;
        $[0] = t0;
        $[1] = content;
        $[2] = onClickCallback;
        $[3] = props;
        $[4] = testId;
    } else {
        content = $[1];
        onClickCallback = $[2];
        props = $[3];
        testId = $[4];
    }
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    let t1;
    if ($[5] !== content || $[6] !== fireEvent || $[7] !== onClickCallback) {
        t1 = async ()=>{
            fireEvent("ui.button.clicked.copySummary", {});
            await navigator.clipboard.writeText(content ?? "");
            setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
            onClickCallback?.();
        };
        $[5] = content;
        $[6] = fireEvent;
        $[7] = onClickCallback;
        $[8] = t1;
    } else t1 = $[8];
    const handleCopySummaryClick = t1;
    let t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        });
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    const t4 = `${testId}-copy-summary-action`;
    let t5;
    if ($[11] !== tooltipMessage) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage);
        $[11] = tooltipMessage;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description);
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== handleCopySummaryClick || $[15] !== props || $[16] !== t4 || $[17] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: t2,
            icon: t3,
            onClick: handleCopySummaryClick,
            testId: t4,
            tooltipMessage: t5,
            tooltipOnHide: t6,
            ...props
        });
        $[14] = handleCopySummaryClick;
        $[15] = props;
        $[16] = t4;
        $[17] = t5;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : function CopySummaryAction({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $42omo.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
};
const $8b66580330514e65$export$7e8c7a0de1a37bfe = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CopySummaryActionNew(t0) {
    const $ = (0, $frIzR.c)(21);
    let onClickCallback;
    let props;
    let t1;
    let testId;
    if ($[0] !== t0) {
        const { url: url, onClick: t2, summary: t3, testId: t4, ...t5 } = t0;
        onClickCallback = t2;
        t1 = t3;
        testId = t4;
        props = t5;
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = props;
        $[3] = t1;
        $[4] = testId;
    } else {
        onClickCallback = $[1];
        props = $[2];
        t1 = $[3];
        testId = $[4];
    }
    const summary = t1 === undefined ? "" : t1;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    let t2;
    if ($[5] !== fireEvent || $[6] !== onClickCallback || $[7] !== summary) {
        t2 = async ()=>{
            fireEvent("ui.button.clicked.copySummary", {});
            await navigator.clipboard.writeText(summary);
            setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
            onClickCallback?.();
        };
        $[5] = fireEvent;
        $[6] = onClickCallback;
        $[7] = summary;
        $[8] = t2;
    } else t2 = $[8];
    const handleCopySummaryClick = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action);
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== props.iconSize) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        });
        $[10] = props.iconSize;
        $[11] = t4;
    } else t4 = $[11];
    const t5 = `${testId}-copy-summary-action`;
    let t6;
    if ($[12] !== tooltipMessage) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage);
        $[12] = tooltipMessage;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description);
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== handleCopySummaryClick || $[16] !== props || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: t3,
            icon: t4,
            onClick: handleCopySummaryClick,
            testId: t5,
            tooltipMessage: t6,
            tooltipOnHide: t7,
            ...props
        });
        $[15] = handleCopySummaryClick;
        $[16] = props;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : function CopySummaryActionNew({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $42omo.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $42omo.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
};


const $b80129153fa85400$export$8eed96bc6d982595 = (props)=>{
    (0, $fBMbo.di)((0, $6KV13.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $6KV13.default)(url);
    (0, $42omo.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b66580330514e65$export$7e8c7a0de1a37bfe), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b66580330514e65$export$cfa1d3eed9a61059), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $276cdae1a40ee2d2$export$75a19de44af58722), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};


const $773427e96b58aed9$var$AISummaryAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    let t0;
    if ($[0] !== actionData || $[1] !== props) {
        t0 = actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b80129153fa85400$export$8eed96bc6d982595), {
            ...actionData,
            ...props
        }) : null;
        $[0] = actionData;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b80129153fa85400$export$8eed96bc6d982595), {
        ...actionData,
        ...props
    }) : null;
};
var $773427e96b58aed9$export$2e2bcd8739ae039 = $773427e96b58aed9$var$AISummaryAction;
module.exports["default"] = $773427e96b58aed9$export$2e2bcd8739ae039;

});

parcelRegister("loGLq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fxBfz = parcelRequire("fxBfz");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $l17Fn = parcelRequire("l17Fn");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");




const $916427ca86a2c806$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $afp1H.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $afp1H.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};



const $12d115b9ed847307$var$AutomationModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cQF6P")));
const $12d115b9ed847307$var$AutomationAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const { product: rovoProduct } = (0, $l17Fn.default)();
    let t0;
    if ($[0] !== fireEvent || $[1] !== modal || $[2] !== onClickCallback) {
        t0 = (automationActionData_0)=>{
            const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData_0;
            fireEvent("ui.button.clicked.automationAction", {});
            const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $916427ca86a2c806$export$93e707b363eaf5c8)(product, resourceType) || {};
            const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), modalTitle) : undefined;
            const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...modalDescription,
                values: {
                    name: objectName,
                    b: $12d115b9ed847307$var$_temp,
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
                }
            }) : undefined;
            modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12d115b9ed847307$var$AutomationModal, {
                baseAutomationUrl: baseAutomationUrl,
                objectAri: objectAri,
                siteAri: siteAri,
                canManageAutomation: canManageAutomation,
                analyticsSource: analyticsSource,
                modalTitle: automationModalTitle,
                modalDescription: automationModalDescription,
                onClose: ()=>modal.close()
            }));
            onClickCallback?.();
        };
        $[0] = fireEvent;
        $[1] = modal;
        $[2] = onClickCallback;
        $[3] = t0;
    } else t0 = $[3];
    const automationActionOnClick = t0;
    if (!automationActionData) return null;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_title);
        $[4] = t1;
    } else t1 = $[4];
    const automationActionTitle = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_tooltip);
        $[5] = t2;
    } else t2 = $[5];
    const automationActionTooltip = t2;
    let t3;
    if ($[6] !== formatMessage) {
        t3 = formatMessage((0, $afp1H.messages).automation_action_icon_label);
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    const automationActionIconLabel = t3;
    let t4;
    if ($[8] !== props.iconSize || $[9] !== rovoProduct) {
        t4 = (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") || !!rovoProduct && rovoProduct === "CONFLUENCE" ? {
            size: props.iconSize
        } : {};
        $[8] = props.iconSize;
        $[9] = rovoProduct;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== automationActionIconLabel || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            ...t4
        });
        $[11] = automationActionIconLabel;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== automationActionData || $[15] !== automationActionOnClick) {
        t6 = ()=>automationActionOnClick(automationActionData);
        $[14] = automationActionData;
        $[15] = automationActionOnClick;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== props || $[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: automationActionTitle,
            icon: t5,
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: t6
        }));
        $[17] = props;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const { product: rovoProduct } = (0, $l17Fn.default)();
    const automationActionOnClick = (0, $42omo.useCallback)((automationActionData_0)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData_0;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $916427ca86a2c806$export$93e707b363eaf5c8)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12d115b9ed847307$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $afp1H.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || !!rovoProduct && rovoProduct === 'CONFLUENCE' ? {
                size: props.iconSize
            } : {}
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $12d115b9ed847307$export$2e2bcd8739ae039 = $12d115b9ed847307$var$AutomationAction;
function $12d115b9ed847307$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, chunks);
}
module.exports["default"] = $12d115b9ed847307$export$2e2bcd8739ae039;

});

parcelRegister("1MuZd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");


var $9oOnT = parcelRequire("9oOnT");


var $kNkkl = parcelRequire("kNkkl");


var $4I8po = parcelRequire("4I8po");


var $6FZ6a = parcelRequire("6FZ6a");

const $cb943c3aeab7c86e$var$GOOGLE_PROMPTS = [
    (0, $4I8po.RovoChatPromptKey).RECOMMEND_OTHER_SOURCES,
    (0, $4I8po.RovoChatPromptKey).SHOW_OTHER_MENTIONS,
    (0, $4I8po.RovoChatPromptKey).SUGGEST_IMPROVEMENT
];
const $cb943c3aeab7c86e$var$DEFAULT_PROMPTS = $cb943c3aeab7c86e$var$GOOGLE_PROMPTS;
const $cb943c3aeab7c86e$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $kNkkl.default)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $42omo.useMemo)(()=>{
        if (prompts) return prompts;
        return $cb943c3aeab7c86e$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $9oOnT.default)({});
    const onClick = (0, $42omo.useCallback)((promptData, promptKey)=>{
        if (promptData && data?.invokeAction) {
            invoke({
                ...data?.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback?.();
        }
    }, [
        data?.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $42omo.useMemo)(()=>{
        return resolvedPrompts.map((promptKey_0, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData_0 } = (0, $4I8po.getPromptAction)({
                promptKey: promptKey_0,
                intl: intl,
                url: data?.url,
                product: data?.product,
                iconSize: props.iconSize,
                cardAppearance: props.cardAppearance
            }) || {};
            return promptData_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
                content: content,
                icon: icon,
                key: promptKey_0,
                onClick: ()=>onClick(promptData_0, promptKey_0),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && promptActions?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, promptActions) : null;
};
var $cb943c3aeab7c86e$export$2e2bcd8739ae039 = $cb943c3aeab7c86e$var$RovoChatAction;
module.exports["default"] = $cb943c3aeab7c86e$export$2e2bcd8739ae039;

});

parcelRegister("9Gqdx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $3eMTN = parcelRequire("3eMTN");


var $6FZ6a = parcelRequire("6FZ6a");











var $kevJM = parcelRequire("kevJM");

const $c0b0240da4db21c1$var$RelatedLinksActionIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { iconSize: iconSize } = t0;
    let t1;
    if ($[0] !== iconSize) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: iconSize
        });
        $[0] = iconSize;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        color: "currentColor",
        spacing: "spacious",
        label: '',
        size: iconSize
    });
var $c0b0240da4db21c1$export$2e2bcd8739ae039 = $c0b0240da4db21c1$var$RelatedLinksActionIcon;



const $c0c15e76cd694fe8$var$RelatedLinksModal = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aPH2w")));
const $c0c15e76cd694fe8$var$ViewRelatedLinksAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let onClickCallback;
    let props;
    if ($[0] !== t0) {
        ({ onClick: onClickCallback, ...props } = t0);
        $[0] = t0;
        $[1] = onClickCallback;
        $[2] = props;
    } else {
        onClickCallback = $[1];
        props = $[2];
    }
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    let t1;
    if ($[3] !== actionData?.ari || $[4] !== fireEvent || $[5] !== modal || $[6] !== onClickCallback) {
        t1 = ()=>{
            const ari = actionData?.ari;
            if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0c15e76cd694fe8$var$RelatedLinksModal, {
                ari: ari,
                showModal: true,
                onClose: ()=>modal.close()
            }));
            fireEvent("ui.button.clicked.relatedLinks", {});
            onClickCallback?.();
        };
        $[3] = actionData?.ari;
        $[4] = fireEvent;
        $[5] = modal;
        $[6] = onClickCallback;
        $[7] = t1;
    } else t1 = $[7];
    actionData?.ari;
    const onClick = t1;
    let t2;
    if ($[8] !== actionData || $[9] !== onClick || $[10] !== props) {
        t2 = actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links),
            ...(0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") ? {
                tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links)
            } : {},
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0b0240da4db21c1$export$2e2bcd8739ae039), (0, $dh538.fg)("platform_sl_3p_auth_rovo_action_kill_switch") ? {
                iconSize: props.iconSize
            } : {}),
            onClick: onClick,
            testId: "smart-action-view-related-links-action",
            ariaLabel: "View most recent pages or content types coming from or found on this link",
            ...props
        }) : null;
        $[8] = actionData;
        $[9] = onClick;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onClick = (0, $42omo.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c0c15e76cd694fe8$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links),
        ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? {
            tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).related_links_view_related_links)
        } : {},
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0b0240da4db21c1$export$2e2bcd8739ae039), (0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') ? {
            iconSize: props.iconSize
        } : {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c0c15e76cd694fe8$export$2e2bcd8739ae039 = $c0c15e76cd694fe8$var$ViewRelatedLinksAction;
module.exports["default"] = $c0c15e76cd694fe8$export$2e2bcd8739ae039;

});

parcelRegister("j5Rp4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $5TXU5 = parcelRequire("5TXU5");


var $fUfR2 = parcelRequire("fUfR2");

const $fd2ed04371a16208$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $fd2ed04371a16208$var$validErrorStatuses = [
    (0, $5TXU5.SmartLinkStatus).Forbidden,
    (0, $5TXU5.SmartLinkStatus).Unauthorized
];
const $fd2ed04371a16208$var$validateErrorStatus = (status)=>{
    return status !== undefined && $fd2ed04371a16208$var$validErrorStatuses.includes(status);
};
const $fd2ed04371a16208$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$fd2ed04371a16208$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
}; /**
    * Public API — exported externally. Do not add props without external support intent.
    */ 
const $fd2ed04371a16208$var$CustomUnresolvedAction = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { testId: t1, onlyShowIfAction: t2, Container: Container, ...props } = t0;
    const testId = t1 === undefined ? "custom-unresolved-action" : t1;
    const onlyShowIfAction = t2 === undefined ? false : t2;
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $fd2ed04371a16208$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const t3 = `${testId}-errored-view-message`;
    const t4 = hasAction ? 0 : undefined;
    let t5;
    if ($[0] !== messageDescriptor || $[1] !== values) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...messageDescriptor,
            values: values
        });
        $[0] = messageDescriptor;
        $[1] = values;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: t3,
            tabIndex: t4,
            xcss: $fd2ed04371a16208$var$styles.message
        }, t5);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const message = t6;
    let t7;
    if ($[7] !== data.onClick || $[8] !== hasAction || $[9] !== message) {
        t7 = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            onClick: data.onClick,
            style: {
                color: "inherit",
                font: "inherit",
                textAlign: "inherit"
            },
            xcss: $fd2ed04371a16208$var$styles.button
        }, message) : message;
        $[7] = data.onClick;
        $[8] = hasAction;
        $[9] = message;
        $[10] = t7;
    } else t7 = $[10];
    const component = t7;
    let t8;
    if ($[11] !== Container || $[12] !== component) {
        t8 = Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, component) : component;
        $[11] = Container;
        $[12] = component;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $fUfR2.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $fd2ed04371a16208$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $fd2ed04371a16208$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $fd2ed04371a16208$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, component) : component;
};
var $fd2ed04371a16208$export$2e2bcd8739ae039 = $fd2ed04371a16208$var$CustomUnresolvedAction;
module.exports["default"] = $fd2ed04371a16208$export$2e2bcd8739ae039;

});

parcelRegister("2gWqY", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("6cbph")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("4wLtQ")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("iNImz")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("LrBxG")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("bWsCB")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("azCqP")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("kexiH")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("e8W8a")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("3nul2")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("jKoRo")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("bmx11")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jI5eg")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("8iOdP")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("jW9GW")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("1WqHG")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("ful5o")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("41AV3")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("ikM9T")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("8YJtM")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("6Ed8U")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("2ZgNz")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("iuEuh")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2GDee")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("h2WFd")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("49WiA")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("aGsNO")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("emfmd")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("a0Yyn")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("b8mrt")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("jpKes")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("hIbqn")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("b16ZX")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("gHW9t")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("bG0uM")).default);
$parcel$export(module.exports, "HostName", () => (parcelRequire("8OVDp")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("zH0mb")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("6LJqp")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("e4NSt")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("4SEPT")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("lOpcG")).default);

var $6cbph = parcelRequire("6cbph");


var $4wLtQ = parcelRequire("4wLtQ");


var $iNImz = parcelRequire("iNImz");


var $LrBxG = parcelRequire("LrBxG");


var $bWsCB = parcelRequire("bWsCB");


var $azCqP = parcelRequire("azCqP");


var $kexiH = parcelRequire("kexiH");


var $e8W8a = parcelRequire("e8W8a");


var $3nul2 = parcelRequire("3nul2");


var $jKoRo = parcelRequire("jKoRo");


var $bmx11 = parcelRequire("bmx11");


var $jI5eg = parcelRequire("jI5eg");


var $8iOdP = parcelRequire("8iOdP");


var $jW9GW = parcelRequire("jW9GW");


var $1WqHG = parcelRequire("1WqHG");


var $ful5o = parcelRequire("ful5o");


var $41AV3 = parcelRequire("41AV3");


var $ikM9T = parcelRequire("ikM9T");


var $8YJtM = parcelRequire("8YJtM");


var $6Ed8U = parcelRequire("6Ed8U");


var $2ZgNz = parcelRequire("2ZgNz");


var $iuEuh = parcelRequire("iuEuh");


var $2GDee = parcelRequire("2GDee");


var $h2WFd = parcelRequire("h2WFd");


var $49WiA = parcelRequire("49WiA");


var $aGsNO = parcelRequire("aGsNO");


var $emfmd = parcelRequire("emfmd");


var $a0Yyn = parcelRequire("a0Yyn");


var $b8mrt = parcelRequire("b8mrt");


var $jpKes = parcelRequire("jpKes");


var $hIbqn = parcelRequire("hIbqn");


var $b16ZX = parcelRequire("b16ZX");


var $gHW9t = parcelRequire("gHW9t");


var $bG0uM = parcelRequire("bG0uM");


var $8OVDp = parcelRequire("8OVDp");


var $zH0mb = parcelRequire("zH0mb");


var $6LJqp = parcelRequire("6LJqp");


var $e4NSt = parcelRequire("e4NSt");


var $4SEPT = parcelRequire("4SEPT");


var $lOpcG = parcelRequire("lOpcG");


});

parcelRegister("hJgLA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4wH3g = parcelRequire("4wH3g");


var $5TXU5 = parcelRequire("5TXU5");

const $ecdac2a9be051ad6$export$9d642f65a919fb93 = {
    [(0, $5TXU5.SmartLinkSize).Small]: 'none',
    [(0, $5TXU5.SmartLinkSize).Medium]: 'compact',
    [(0, $5TXU5.SmartLinkSize).Large]: 'compact',
    [(0, $5TXU5.SmartLinkSize).XLarge]: 'default'
};
const $ecdac2a9be051ad6$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...descriptor,
            values: values
        });
    }
};
const $ecdac2a9be051ad6$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $ecdac2a9be051ad6$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $ecdac2a9be051ad6$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $ecdac2a9be051ad6$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1.75;
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $ecdac2a9be051ad6$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $ecdac2a9be051ad6$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $ecdac2a9be051ad6$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
module.exports["sizeToButtonSpacing"] = $ecdac2a9be051ad6$export$9d642f65a919fb93;
module.exports["getFormattedMessage"] = $ecdac2a9be051ad6$export$f1aa79f2218fb713;
module.exports["getFormattedMessageAsString"] = $ecdac2a9be051ad6$export$66ecb50a9dd1768;
module.exports["getIconWidth"] = $ecdac2a9be051ad6$export$fb10bc5609c6347e;
module.exports["importIcon"] = $ecdac2a9be051ad6$export$6dc831e1a0a7a851;
module.exports["getMaxLines"] = $ecdac2a9be051ad6$export$c2293adf1794c09;
module.exports["getPrimitivesInlineSpaceBySize"] = $ecdac2a9be051ad6$export$475c391af8171fec;
module.exports["hasWhiteSpace"] = $ecdac2a9be051ad6$export$619e376a425cb759;

});

parcelRegister("iFRRf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $7642E = parcelRequire("7642E");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $7CgcZ = parcelRequire("7CgcZ");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

const $536366acab81aece$var$getIconImportFn = (icon, size)=>{
    const item = (0, $ivUmx.getLazyIcons)()[icon];
    if ((0, $ivUmx.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $536366acab81aece$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $536366acab81aece$var$getBlogIcon = ()=>(parcelRequire("7r4Rz")).default;

const $536366acab81aece$var$getDocumentIcon = ()=>(parcelRequire("9SMct")).default;

const $536366acab81aece$var$getLiveDocumentIcon = ()=>(parcelRequire("GFtWS")).default;
const $536366acab81aece$var$isCoreIcon = (icon)=>{
    return [
        (0, $5TXU5.IconType).Project,
        (0, $5TXU5.IconType).Template,
        (0, $5TXU5.IconType).Forbidden,
        (0, $5TXU5.IconType).Default,
        (0, $5TXU5.IconType).Error,
        (0, $5TXU5.IconType).Attachment,
        (0, $5TXU5.IconType).CheckItem,
        (0, $5TXU5.IconType).Component,
        (0, $5TXU5.IconType).Comment,
        (0, $5TXU5.IconType).View,
        (0, $5TXU5.IconType).React,
        (0, $5TXU5.IconType).Vote,
        (0, $5TXU5.IconType).PriorityUndefined,
        (0, $5TXU5.IconType).ProgrammingLanguage,
        (0, $5TXU5.IconType).Subscriber,
        (0, $5TXU5.IconType).SubTasksProgress
    ].includes(icon);
};
const $536366acab81aece$var$AtlaskitIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(68);
    const { icon: icon, label: label, testId: testId, size: t1, isTiledIcon: isTiledIcon } = t0;
    const size = t1 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t1;
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            {
                let t2;
                if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                    t2 = $536366acab81aece$var$getDocumentIcon();
                    $[0] = t2;
                } else t2 = $[0];
                const DocumentIcon = t2;
                const t3 = label ?? "document";
                let t4;
                if ($[1] !== isTiledIcon || $[2] !== size || $[3] !== t3 || $[4] !== testId) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                        label: t3,
                        testId: testId,
                        size: size,
                        isTiledIcon: isTiledIcon
                    });
                    $[1] = isTiledIcon;
                    $[2] = size;
                    $[3] = t3;
                    $[4] = testId;
                    $[5] = t4;
                } else t4 = $[5];
                return t4;
            }
        case (0, $5TXU5.IconType).Blog:
            {
                let t2;
                if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                    t2 = $536366acab81aece$var$getBlogIcon();
                    $[6] = t2;
                } else t2 = $[6];
                const BlogIcon = t2;
                const t3 = label ?? "blog";
                let t4;
                if ($[7] !== isTiledIcon || $[8] !== size || $[9] !== t3 || $[10] !== testId) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BlogIcon, {
                        label: t3,
                        testId: testId,
                        size: size,
                        isTiledIcon: isTiledIcon
                    });
                    $[7] = isTiledIcon;
                    $[8] = size;
                    $[9] = t3;
                    $[10] = testId;
                    $[11] = t4;
                } else t4 = $[11];
                return t4;
            }
        case (0, $5TXU5.IconType).LiveDocument:
            {
                let t2;
                if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                    t2 = $536366acab81aece$var$getLiveDocumentIcon();
                    $[12] = t2;
                } else t2 = $[12];
                const LiveDocumentIcon = t2;
                const t3 = label ?? "live-doc";
                let t4;
                if ($[13] !== isTiledIcon || $[14] !== size || $[15] !== t3 || $[16] !== testId) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LiveDocumentIcon, {
                        label: t3,
                        testId: testId,
                        size: size,
                        isTiledIcon: isTiledIcon
                    });
                    $[13] = isTiledIcon;
                    $[14] = size;
                    $[15] = t3;
                    $[16] = testId;
                    $[17] = t4;
                } else t4 = $[17];
                return t4;
            }
    }
    let t2;
    let t3;
    if ($[18] !== icon || $[19] !== size) {
        t3 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
            if (!importFn) {
                t3 = null;
                break bb0;
            }
            t2 = $536366acab81aece$var$importIcon(importFn);
        }
        $[18] = icon;
        $[19] = size;
        $[20] = t2;
        $[21] = t3;
    } else {
        t2 = $[20];
        t3 = $[21];
    }
    if (t3 !== Symbol.for("react.early_return_sentinel")) return t3;
    const ImportedIcon = t2;
    if ($536366acab81aece$var$isCoreIcon(icon) && (0, $dh538.fg)("platform_sl_icons_refactor")) {
        let color;
        if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $5TXU5.SmartLinkSize).Small:
            case (0, $5TXU5.SmartLinkSize).Medium:
                {
                    let t4;
                    if ($[22] !== ImportedIcon || $[23] !== color || $[24] !== label || $[25] !== testId) {
                        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                            label: label,
                            testId: testId,
                            color: color
                        });
                        $[22] = ImportedIcon;
                        $[23] = color;
                        $[24] = label;
                        $[25] = testId;
                        $[26] = t4;
                    } else t4 = $[26];
                    return t4;
                }
            case (0, $5TXU5.SmartLinkSize).Large:
            case (0, $5TXU5.SmartLinkSize).XLarge:
                {
                    let appearance;
                    if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) appearance = "redBold";
                    else appearance = "grayBold";
                    let t4;
                    if ($[27] !== size) {
                        t4 = (0, $7CgcZ.transformSmartLinkSizeToIconTileSize)(size);
                        $[27] = size;
                        $[28] = t4;
                    } else t4 = $[28];
                    const iconTileSize = t4;
                    if (iconTileSize) {
                        let t5;
                        if ($[29] !== ImportedIcon || $[30] !== isTiledIcon) {
                            t5 = isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                                    ...iconProps,
                                    spacing: "spacious"
                                }) : ImportedIcon;
                            $[29] = ImportedIcon;
                            $[30] = isTiledIcon;
                            $[31] = t5;
                        } else t5 = $[31];
                        const t6 = label ?? "";
                        let t7;
                        if ($[32] !== appearance || $[33] !== iconTileSize || $[34] !== t5 || $[35] !== t6) {
                            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
                                appearance: appearance,
                                icon: t5,
                                size: iconTileSize,
                                label: t6
                            });
                            $[32] = appearance;
                            $[33] = iconTileSize;
                            $[34] = t5;
                            $[35] = t6;
                            $[36] = t7;
                        } else t7 = $[36];
                        return t7;
                    } else {
                        let t5;
                        if ($[37] !== ImportedIcon || $[38] !== color || $[39] !== label || $[40] !== testId) {
                            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                                label: label,
                                testId: testId,
                                color: color
                            });
                            $[37] = ImportedIcon;
                            $[38] = color;
                            $[39] = label;
                            $[40] = testId;
                            $[41] = t5;
                        } else t5 = $[41];
                        return t5;
                    }
                }
        }
    }
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            {
                let t4;
                if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = (0, $dh538.fg)("billplat_a11y_icon_label_fix") ? {
                        label: ""
                    } : undefined;
                    $[42] = t4;
                } else t4 = $[42];
                const t5 = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? "small" : "xxsmall";
                let t6;
                if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
                    t6 = (0, $dh538.fg)("navx-1895-new-logo-design") ? {
                        shouldUseNewLogoDesign: true
                    } : undefined;
                    $[43] = t6;
                } else t6 = $[43];
                let t7;
                if ($[44] !== t5 || $[45] !== testId) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
                        appearance: "brand",
                        testId: testId,
                        ...t4,
                        size: t5,
                        ...t6
                    });
                    $[44] = t5;
                    $[45] = testId;
                    $[46] = t7;
                } else t7 = $[46];
                return t7;
            }
        case (0, $5TXU5.IconType).Jira:
            {
                let t4;
                if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = (0, $dh538.fg)("billplat_a11y_icon_label_fix") ? {
                        label: ""
                    } : undefined;
                    $[47] = t4;
                } else t4 = $[47];
                const t5 = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? "small" : "xxsmall";
                let t6;
                if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
                    t6 = (0, $dh538.fg)("navx-1895-new-logo-design") ? {
                        shouldUseNewLogoDesign: true
                    } : undefined;
                    $[48] = t6;
                } else t6 = $[48];
                let t7;
                if ($[49] !== t5 || $[50] !== testId) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                        appearance: "brand",
                        testId: testId,
                        ...t4,
                        size: t5,
                        ...t6
                    });
                    $[49] = t5;
                    $[50] = testId;
                    $[51] = t7;
                } else t7 = $[51];
                return t7;
            }
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            {
                if ((0, $dh538.fg)("platform_sl_icons_refactor")) {
                    let t4;
                    if ($[52] !== ImportedIcon || $[53] !== isTiledIcon || $[54] !== label || $[55] !== size || $[56] !== testId) {
                        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                            label: label,
                            testId: testId,
                            size: size,
                            isTiledIcon: isTiledIcon
                        });
                        $[52] = ImportedIcon;
                        $[53] = isTiledIcon;
                        $[54] = label;
                        $[55] = size;
                        $[56] = testId;
                        $[57] = t4;
                    } else t4 = $[57];
                    return t4;
                }
                let t4;
                if ($[58] !== ImportedIcon || $[59] !== label || $[60] !== testId) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                        label: label,
                        testId: testId,
                        color: "var(--ds-icon-danger, #C9372C)"
                    });
                    $[58] = ImportedIcon;
                    $[59] = label;
                    $[60] = testId;
                    $[61] = t4;
                } else t4 = $[61];
                return t4;
            }
        default:
            {
                let t4;
                if ($[62] !== ImportedIcon || $[63] !== isTiledIcon || $[64] !== label || $[65] !== size || $[66] !== testId) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                        label: label,
                        testId: testId,
                        size: size,
                        isTiledIcon: isTiledIcon
                    });
                    $[62] = ImportedIcon;
                    $[63] = isTiledIcon;
                    $[64] = label;
                    $[65] = size;
                    $[66] = testId;
                    $[67] = t4;
                } else t4 = $[67];
                return t4;
            }
    }
} : ({ icon: icon, label: label, testId: testId, size: size = (0, $5TXU5.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    // Intentionally keep these three icon types synchronous and outside lazy imports.
    // These icons should be present in SSR markup so hydration does not cause a
    // visible empty-state-then-pop-in transition in Smart Link consumers.
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            {
                const DocumentIcon = $536366acab81aece$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5TXU5.IconType).Blog:
            {
                const BlogIcon = $536366acab81aece$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5TXU5.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $536366acab81aece$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $536366acab81aece$var$importIcon(importFn);
    if ($536366acab81aece$var$isCoreIcon(icon) && (0, $dh538.fg)('platform_sl_icons_refactor')) {
        let color;
        if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $5TXU5.SmartLinkSize).Small:
            case (0, $5TXU5.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $5TXU5.SmartLinkSize).Large:
            case (0, $5TXU5.SmartLinkSize).XLarge:
                let appearance;
                if (icon === (0, $5TXU5.IconType).Error || icon === (0, $5TXU5.IconType).Forbidden) appearance = 'redBold';
                else appearance = 'grayBold';
                const iconTileSize = (0, $7CgcZ.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $dh538.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $dh538.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            if ((0, $dh538.fg)('platform_sl_icons_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $536366acab81aece$export$2e2bcd8739ae039 = $536366acab81aece$var$AtlaskitIcon;
module.exports["default"] = $536366acab81aece$export$2e2bcd8739ae039;

});

parcelRegister("9AUBM", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $fUfR2 = parcelRequire("fUfR2");


var $l17Fn = parcelRequire("l17Fn");


var $b6b6P = parcelRequire("b6b6P");


var $iFRRf = parcelRequire("iFRRf");


var $1iDg7 = parcelRequire("1iDg7");


var $hJgLA = parcelRequire("hJgLA");

const $951dc084d4c33fc9$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $951dc084d4c33fc9$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $951dc084d4c33fc9$var$messageMapper = {
    [(0, $5TXU5.IconType).PriorityBlocker]: (0, $afp1H.messages).priority_blocker,
    [(0, $5TXU5.IconType).PriorityCritical]: (0, $afp1H.messages).priority_critical,
    [(0, $5TXU5.IconType).PriorityHigh]: (0, $afp1H.messages).priority_high,
    [(0, $5TXU5.IconType).PriorityHighest]: (0, $afp1H.messages).priority_highest,
    [(0, $5TXU5.IconType).PriorityLow]: (0, $afp1H.messages).priority_low,
    [(0, $5TXU5.IconType).PriorityLowest]: (0, $afp1H.messages).priority_lowest,
    [(0, $5TXU5.IconType).PriorityMajor]: (0, $afp1H.messages).priority_major,
    [(0, $5TXU5.IconType).PriorityMedium]: (0, $afp1H.messages).priority_medium,
    [(0, $5TXU5.IconType).PriorityMinor]: (0, $afp1H.messages).priority_minor,
    [(0, $5TXU5.IconType).PriorityTrivial]: (0, $afp1H.messages).priority_trivial,
    [(0, $5TXU5.IconType).PriorityUndefined]: (0, $afp1H.messages).priority_undefined
};
const $951dc084d4c33fc9$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $951dc084d4c33fc9$var$messageMapper[icon];
        if (descriptor) return (0, $hJgLA.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $951dc084d4c33fc9$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iFRRf.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $951dc084d4c33fc9$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6b6P.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $951dc084d4c33fc9$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(27);
    const { appearance: t1, hideIcon: t2, icon: icon, label: label, name: name, testId: t3, url: url, color: color, hideLabel: t4 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const hideIcon = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "smart-element-badge" : t3;
    const hideLabel = t4 === undefined ? false : t4;
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const { product: product } = (0, $l17Fn.default)();
    let t5;
    if ($[0] !== icon || $[1] !== label) {
        t5 = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
        $[0] = icon;
        $[1] = label;
        $[2] = t5;
    } else t5 = $[2];
    const formattedMessageOrLabel = t5;
    let t6;
    if ($[3] !== icon || $[4] !== testId || $[5] !== ui?.hideLoadingSkeleton || $[6] !== url) {
        t6 = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
        $[3] = icon;
        $[4] = testId;
        $[5] = ui?.hideLoadingSkeleton;
        $[6] = url;
        $[7] = t6;
    } else t6 = $[7];
    const badgeIcon = t6;
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === "CONFLUENCE";
    let t7;
    if ($[8] !== color) {
        t7 = {
            color: color
        };
        $[8] = color;
        $[9] = t7;
    } else t7 = $[9];
    const t8 = $951dc084d4c33fc9$var$colorMap[appearance];
    let t9;
    if ($[10] !== t8) {
        t9 = (0, $gMc0m.default)([
            $951dc084d4c33fc9$var$styles.container,
            t8
        ]);
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== badgeIcon || $[13] !== hideIcon) {
        t10 = !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $951dc084d4c33fc9$var$styles.icon
        }, badgeIcon);
        $[12] = badgeIcon;
        $[13] = hideIcon;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== formattedMessageOrLabel || $[16] !== shouldHideLabel || $[17] !== testId) {
        t11 = !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            testId: `${testId}-label`,
            xcss: $951dc084d4c33fc9$var$styles.text
        }, formattedMessageOrLabel);
        $[15] = formattedMessageOrLabel;
        $[16] = shouldHideLabel;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== name || $[20] !== ref || $[21] !== t10 || $[22] !== t11 || $[23] !== t7 || $[24] !== t9 || $[25] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-smart-element": name,
            "data-smart-element-badge": true,
            "data-testid": testId,
            ref: ref,
            style: t7,
            className: t9
        }, t10, t11);
        $[19] = name;
        $[20] = ref;
        $[21] = t10;
        $[22] = t11;
        $[23] = t7;
        $[24] = t9;
        $[25] = testId;
        $[26] = t12;
    } else t12 = $[26];
    return t12;
} : ({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const { product: product } = (0, $l17Fn.default)();
    const formattedMessageOrLabel = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === 'CONFLUENCE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $gMc0m.default)([
            $951dc084d4c33fc9$var$styles.container,
            $951dc084d4c33fc9$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $951dc084d4c33fc9$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $951dc084d4c33fc9$var$styles.text
    }, formattedMessageOrLabel));
});
const $951dc084d4c33fc9$var$_default_1 = (0, $1iDg7.withOverrideCss)($951dc084d4c33fc9$var$BaseBadgeRefreshNew);
var $951dc084d4c33fc9$export$2e2bcd8739ae039 = $951dc084d4c33fc9$var$_default_1;
const $951dc084d4c33fc9$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};
module.exports["default"] = $951dc084d4c33fc9$export$2e2bcd8739ae039;
module.exports["toBadgeProps"] = $951dc084d4c33fc9$export$a2fb457791942ba4;

});

parcelRegister("jlQ9A", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("6FZ6a")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("jLXEH")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("dVBHR")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cLh5D")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("9l03X")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("2vLbR")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("apOlf")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("lVA2Y")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("fl0WE")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("loGLq")).default);
$parcel$export(module.exports, "RovoChatAction", () => (parcelRequire("1MuZd")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9Gqdx")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("j5Rp4")).default);

var $6FZ6a = parcelRequire("6FZ6a");


var $jLXEH = parcelRequire("jLXEH");


var $dVBHR = parcelRequire("dVBHR");


var $cLh5D = parcelRequire("cLh5D");


var $9l03X = parcelRequire("9l03X");


var $2vLbR = parcelRequire("2vLbR");


var $apOlf = parcelRequire("apOlf");


var $lVA2Y = parcelRequire("lVA2Y");


var $fl0WE = parcelRequire("fl0WE");


var $loGLq = parcelRequire("loGLq");


var $1MuZd = parcelRequire("1MuZd");


var $9Gqdx = parcelRequire("9Gqdx");


var $j5Rp4 = parcelRequire("j5Rp4");


});

parcelRegister("6bBFP", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c30cfb4c0c886f9b$export$6118ed0013927eb2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children, isFadeIn: t1, minHeight: t2, show: show, showTransition: t3 } = t0;
    const isFadeIn = t1 === undefined ? false : t1;
    const minHeight = t2 === undefined ? 0 : t2;
    const showTransition = t3 === undefined ? false : t3;
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    const transition = isFadeIn ? "height, opacity" : "height";
    let t4;
    if ($[0] !== show) {
        t4 = ()=>{
            if (show && ref.current) setHeight(ref.current.scrollHeight);
            else setHeight(0);
        };
        $[0] = show;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== children || $[3] !== show) {
        t5 = [
            children,
            show
        ];
        $[2] = children;
        $[3] = show;
        $[4] = t5;
    } else t5 = $[4];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[5] !== children || $[6] !== height || $[7] !== minHeight || $[8] !== show || $[9] !== showTransition || $[10] !== transition) {
        t6 = show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            style: {
                height: height,
                minHeight: minHeight,
                lineHeight: 0,
                overflow: "hidden",
                opacity: height > 0 ? 1 : 0,
                transitionProperty: showTransition ? transition : "none",
                transitionDuration: "0.3s"
            },
            ref: ref
        }, children) : null;
        $[5] = children;
        $[6] = height;
        $[7] = minHeight;
        $[8] = show;
        $[9] = showTransition;
        $[10] = transition;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $42omo.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $c30cfb4c0c886f9b$export$2e2bcd8739ae039 = $c30cfb4c0c886f9b$export$6118ed0013927eb2;
module.exports["default"] = $c30cfb4c0c886f9b$export$2e2bcd8739ae039;

});

parcelRegister("6er8q", function(module, exports) {

var $fRJCL = parcelRequire("fRJCL");

function $a3affc9488ff134f$export$935a1f551ec13075(profileData) {
    if (!profileData) return 0;
    let count = 0;
    if (profileData.accountId) count += 1;
    if (profileData.thirdPartyIntegrations && profileData.thirdPartyIntegrations.length > 0) count += 1;
    return count;
}
const $a3affc9488ff134f$export$feb180212387929b = ()=>Math.round((0, $fRJCL.getPageTime)());
const $a3affc9488ff134f$export$6ad9e7706a4ee0f8 = (error)=>{
    const statusCode = $a3affc9488ff134f$var$readNumericField(error, 'statusCode') ?? $a3affc9488ff134f$var$readNumericField(error, 'status') ?? $a3affc9488ff134f$var$readRelayExtensionsStatusCode(error);
    if (statusCode === 404 || $a3affc9488ff134f$var$isNotFoundLikeError(error, statusCode)) return statusCode !== undefined ? {
        errorType: 'NotFound',
        statusCode: statusCode
    } : {
        errorType: 'NotFound'
    };
    return statusCode !== undefined ? {
        errorType: 'default',
        statusCode: statusCode
    } : {
        errorType: 'default'
    };
};
/**
 * Relay surfaces network errors as `{ errors: [{ extensions: { statusCode, errorType, ... } }] }`.
 * Reads the first error's `extensions.statusCode` so the SLO classification works against the
 * common Relay error envelope, not just hand-rolled `{ statusCode }` objects.
 */ const $a3affc9488ff134f$var$readRelayExtensionsStatusCode = (error)=>{
    if (!error || typeof error !== 'object' || !('errors' in error)) return undefined;
    const errors = error.errors;
    if (!Array.isArray(errors) || errors.length === 0) return undefined;
    const first = errors[0];
    if (!first || typeof first !== 'object' || !('extensions' in first)) return undefined;
    const extensions = first.extensions;
    if (!extensions || typeof extensions !== 'object') return undefined;
    return $a3affc9488ff134f$var$readNumericField(extensions, 'statusCode') ?? $a3affc9488ff134f$var$readNumericField(extensions, 'status');
};
const $a3affc9488ff134f$var$readNumericField = (error, field)=>{
    if (error && typeof error === 'object' && field in error) {
        const value = error[field];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
    }
    return undefined;
};
/** Returns true for unambiguous not-found signals. Message-pattern matching is last-resort — only used when statusCode is absent to avoid misclassifying generic errors (e.g. a 500 whose message contains "not found"). */ const $a3affc9488ff134f$var$isNotFoundLikeError = (error, statusCode)=>{
    if (!error || typeof error !== 'object') return false;
    const code = $a3affc9488ff134f$var$readStringField(error, 'code');
    if (code && /NOT_FOUND/i.test(code)) return true;
    // Only match message patterns when there is no statusCode — a 500 with "not found" in its message must not be misclassified as NotFound.
    if (statusCode === undefined) {
        const message = $a3affc9488ff134f$var$readStringField(error, 'message');
        if (message && /\bnot\s*found\b/i.test(message)) return true;
    }
    return false;
};
const $a3affc9488ff134f$var$readStringField = (error, field)=>{
    if (field in error) {
        const value = error[field];
        if (typeof value === 'string') return value;
    }
    return undefined;
};
module.exports["countRenderedActions"] = $a3affc9488ff134f$export$935a1f551ec13075;
module.exports["firedAt"] = $a3affc9488ff134f$export$feb180212387929b;
module.exports["getErrorAttributes"] = $a3affc9488ff134f$export$6ad9e7706a4ee0f8;

});

parcelRegister("e8zaz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $8en9F = parcelRequire("8en9F");

// Cast payload superset to `never` so `fireEvent` accepts extra SLO fields.
const $6fdfc7a6d3326b98$var$asExtendedPayload = (payload)=>payload;
function $6fdfc7a6d3326b98$export$97ec6f6769110fe4() {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return ()=>{
        fireEvent('operational.profilecard.triggered.request', {
            firedAt: (0, $6er8q.firedAt)()
        });
    };
}
function $6fdfc7a6d3326b98$export$f7831696c122c106() {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.spinner', {
            firedAt: (0, $6er8q.firedAt)()
        });
    }, [
        fireEvent
    ]);
}
function $6fdfc7a6d3326b98$export$38eb2c63ddf3e3a3(hasProfileData) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasProfileData || firedRef.current) return;
        firedRef.current = true;
        fireEvent('operational.profilecard.succeeded.request', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0
        });
    }, [
        hasProfileData,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $6fdfc7a6d3326b98$export$20c24f03e0a7c8fc(profileData) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    const profileDataRef = (0, $42omo.useRef)(profileData);
    profileDataRef.current = profileData;
    (0, $42omo.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.content', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            numActions: (0, $6er8q.countRenderedActions)(profileDataRef.current)
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $6fdfc7a6d3326b98$export$5fc91356da713d06(error) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (error === undefined || firedRef.current) return;
        firedRef.current = true;
        const attributes = error === null ? {
            errorType: 'NotFound'
        } : (0, $6er8q.getErrorAttributes)(error);
        if (attributes.errorType === 'NotFound') {
            fireEvent('operational.profilecard.succeeded.request', {
                firedAt: (0, $6er8q.firedAt)(),
                duration: getDurationSinceInteraction() ?? 0
            });
            return;
        }
        fireEvent('operational.profilecard.failed.request', $6fdfc7a6d3326b98$var$asExtendedPayload({
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            // schema requires `errorMessage`; send the classified type to avoid PII.
            errorMessage: attributes.errorType,
            errorType: attributes.errorType,
            ...attributes.statusCode !== undefined ? {
                errorStatusCode: attributes.statusCode
            } : {}
        }));
    }, [
        error,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
module.exports["useFireTriggeredRequest"] = $6fdfc7a6d3326b98$export$97ec6f6769110fe4;
module.exports["useFireRenderedSpinner"] = $6fdfc7a6d3326b98$export$f7831696c122c106;
module.exports["useFireRequestSucceeded"] = $6fdfc7a6d3326b98$export$38eb2c63ddf3e3a3;
module.exports["useFireContentRendered"] = $6fdfc7a6d3326b98$export$20c24f03e0a7c8fc;
module.exports["useFireRequestFailed"] = $6fdfc7a6d3326b98$export$5fc91356da713d06;

});

parcelRegister("8en9F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fRJCL = parcelRequire("fRJCL");

const $ecfee26886c7524c$var$noopContext = {
    markInteractionStart: ()=>{},
    getDurationSinceInteraction: ()=>undefined
};
const $ecfee26886c7524c$var$CardOpenTimerContext = /*#__PURE__*/ (0, $42omo.createContext)($ecfee26886c7524c$var$noopContext);
function $ecfee26886c7524c$export$8f61ff484d9ed897({ children: children }) {
    const outer = (0, $42omo.useContext)($ecfee26886c7524c$var$CardOpenTimerContext);
    const interactionStartRef = (0, $42omo.useRef)(null);
    const markInteractionStart = (0, $42omo.useCallback)(()=>{
        // Re-arm per interaction so successive opens each measure from their own t=0.
        interactionStartRef.current = (0, $fRJCL.getPageTime)();
    }, []);
    const getDurationSinceInteraction = (0, $42omo.useCallback)(()=>{
        if (interactionStartRef.current === null) return undefined;
        return Math.max(0, (0, $fRJCL.getPageTime)() - interactionStartRef.current);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            markInteractionStart: markInteractionStart,
            getDurationSinceInteraction: getDurationSinceInteraction
        }), [
        markInteractionStart,
        getDurationSinceInteraction
    ]);
    if (outer !== $ecfee26886c7524c$var$noopContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecfee26886c7524c$var$CardOpenTimerContext.Provider, {
        value: value
    }, children);
}
function $ecfee26886c7524c$export$d0c3a3e820a371d6() {
    return (0, $42omo.useContext)($ecfee26886c7524c$var$CardOpenTimerContext);
}
module.exports["CardOpenTimerProvider"] = $ecfee26886c7524c$export$8f61ff484d9ed897;
module.exports["useCardOpenTimer"] = $ecfee26886c7524c$export$d0c3a3e820a371d6;

});

parcelRegister("ikcEb", function(module, exports) {

var $42omo = parcelRequire("42omo");

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */ const $833045f18b03491e$export$ff993edec5f1dba3 = ()=>undefined;
const $833045f18b03491e$export$24fd9e960a1a443b = /*#__PURE__*/ (0, $42omo.createContext)({
    cloudId: '',
    townsquareApp: undefined,
    onProfileClick: undefined,
    getTestId: $833045f18b03491e$export$ff993edec5f1dba3
});
module.exports["defaultGetTestId"] = $833045f18b03491e$export$ff993edec5f1dba3;
module.exports["UserProfileCardContext"] = $833045f18b03491e$export$24fd9e960a1a443b;

});

parcelRegister("cptht", function(module, exports) {
/**
 * Default testId used by the user profile card when the consumer does not pass one.
 * Centralised so the `getTestId` factory in `UserProfileCard` and
 * `UserProfileCardWithTrigger` agrees on what counts as "default".
 */ const $dbc7f2b779db36c7$export$d0c64eda5f53987e = 'user-profile-card';
const $dbc7f2b779db36c7$export$51b2da6fcb5ae549 = (userId, testId)=>{
    const baseTestId = `user-profile-card-${userId}`;
    const isDefaultTestId = !testId || testId === $dbc7f2b779db36c7$export$d0c64eda5f53987e;
    const suffixModifier = isDefaultTestId ? '' : `--${testId}`;
    return (suffix)=>userId ? `${baseTestId}-${suffix}${suffixModifier}` : undefined;
};
module.exports["makeGetTestId"] = $dbc7f2b779db36c7$export$51b2da6fcb5ae549;

});

parcelRegister("kGcl2", function(module, exports) {
/* CardPopupWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $373dad8f5d7298cd$var$styles = {
    wrapper: "_2rko1mok _1reo15vq _18m915vq _1bsb1gwv _16qs1nax"
};
function $373dad8f5d7298cd$export$aefd550f0f72fff8({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $373dad8f5d7298cd$var$styles.wrapper,
        backgroundColor: "elevation.surface.overlay"
    }, children);
}
module.exports["CardPopupWrapper"] = $373dad8f5d7298cd$export$aefd550f0f72fff8;

});

parcelRegister("9mMJ0", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2Pg7f = parcelRequire("2Pg7f");


var $5TXU5 = parcelRequire("5TXU5");


var $afp1H = parcelRequire("afp1H");


var $hJgLA = parcelRequire("hJgLA");

const $9a89fd087e8e9b91$var$styles = null;
const $9a89fd087e8e9b91$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).assigned_to, personName);
        case (0, $5TXU5.ElementName).OwnedByGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).owned_by, personName);
        case (0, $5TXU5.ElementName).AuthorGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).created_by, personName);
        default:
            return personName;
    }
};
const $9a89fd087e8e9b91$var$BaseAvatarGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { items: t1, maxCount: t2, name: name, className: className, testId: t3, showNamePrefix: t4, showFallbackAvatar: t5 } = t0;
    let t6;
    if ($[0] !== t1) {
        t6 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t6;
    } else t6 = $[1];
    const items = t6;
    const maxCount = t2 === undefined ? 4 : t2;
    const testId = t3 === undefined ? "smart-element-avatar-group" : t3;
    const showNamePrefix = t4 === undefined ? false : t4;
    const showFallbackAvatar = t5 === undefined ? true : t5;
    const intl = (0, $aXWIB.useIntl)();
    let t7;
    bb0: {
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                {
                    let t8;
                    if ($[2] !== intl) {
                        t8 = (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned);
                        $[2] = intl;
                        $[3] = t8;
                    } else t8 = $[3];
                    let t9;
                    if ($[4] !== t8) {
                        t9 = [
                            {
                                name: t8
                            }
                        ];
                        $[4] = t8;
                        $[5] = t9;
                    } else t9 = $[5];
                    t7 = t9;
                    break bb0;
                }
            default:
                {
                    let t8;
                    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                        t8 = [];
                        $[6] = t8;
                    } else t8 = $[6];
                    t7 = t8;
                    break bb0;
                }
        }
        if (name && items.length === 1 && showNamePrefix) {
            let t8;
            if ($[7] !== intl || $[8] !== items || $[9] !== name) {
                let t9;
                if ($[11] !== intl || $[12] !== name) {
                    t9 = (person)=>({
                            ...person,
                            name: $9a89fd087e8e9b91$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
                        });
                    $[11] = intl;
                    $[12] = name;
                    $[13] = t9;
                } else t9 = $[13];
                t8 = items.map(t9);
                $[7] = intl;
                $[8] = items;
                $[9] = name;
                $[10] = t8;
            } else t8 = $[10];
            t7 = t8;
            break bb0;
        }
        t7 = items;
    }
    const data = t7;
    if (!data.length) return null;
    let t8;
    if ($[14] !== className) {
        t8 = (0, $gMc0m.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ]);
        $[14] = className;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== data || $[17] !== maxCount || $[18] !== testId) {
        t9 = /*#__PURE__*/ $42omo.createElement((0, $2Pg7f.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        });
        $[16] = data;
        $[17] = maxCount;
        $[18] = testId;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== name || $[21] !== t8 || $[22] !== t9 || $[23] !== testId) {
        t10 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-avatar-group": true,
            "data-testid": testId,
            className: t8
        }, t9);
        $[20] = name;
        $[21] = t8;
        $[22] = t9;
        $[23] = testId;
        $[24] = t10;
    } else t10 = $[24];
    return t10;
} : ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $aXWIB.useIntl)();
    const data = (0, $42omo.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $9a89fd087e8e9b91$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2Pg7f.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $9a89fd087e8e9b91$export$2e2bcd8739ae039 = $9a89fd087e8e9b91$var$BaseAvatarGroup;
const $9a89fd087e8e9b91$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
module.exports["default"] = $9a89fd087e8e9b91$export$2e2bcd8739ae039;
module.exports["toAvatarGroupProps"] = $9a89fd087e8e9b91$export$91ba8651475968bd;

});

parcelRegister("6wR2f", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4ULqR = parcelRequire("4ULqR");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $afp1H = parcelRequire("afp1H");

const $bbe6fa3f8ea6e4e4$var$styles = null;
const $bbe6fa3f8ea6e4e4$var$ABSOLUTE_DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};
const $bbe6fa3f8ea6e4e4$var$isValidTimeZone = (timeZone)=>{
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
const $bbe6fa3f8ea6e4e4$var$formatAbsoluteDateWithOptionalTimeZone = ({ date: date, formatDate: formatDate, timeZone: timeZone })=>{
    if (!timeZone || !$bbe6fa3f8ea6e4e4$var$isValidTimeZone(timeZone)) return formatDate(date, $bbe6fa3f8ea6e4e4$var$ABSOLUTE_DATE_FORMAT);
    return formatDate(date, {
        ...$bbe6fa3f8ea6e4e4$var$ABSOLUTE_DATE_FORMAT,
        timeZone: timeZone
    });
};
const $bbe6fa3f8ea6e4e4$var$typeToDescriptorMap = {
    created: {
        relative: (0, $afp1H.messages).created_on_relative,
        absolute: (0, $afp1H.messages).created_on_absolute
    },
    modified: {
        relative: (0, $afp1H.messages).modified_on_relative,
        absolute: (0, $afp1H.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $afp1H.messages).sent_on_relative,
        absolute: (0, $afp1H.messages).sent_on_absolute
    }
};
const $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { date: date, name: name, className: className, type: type, testId: t1, text: text, hideDatePrefix: t2, color: color, fontSize: fontSize, timeZone: timeZone } = t0;
    const testId = t1 === undefined ? "smart-element-date-time" : t1;
    const hideDatePrefix = t2 === undefined ? false : t2;
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = "absolute";
        let t3;
        if ($[0] !== date || $[1] !== formatDate || $[2] !== timeZone) {
            t3 = (0, $dh538.fg)("dfo_issue_view_remote_data_srr_group") ? $bbe6fa3f8ea6e4e4$var$formatAbsoluteDateWithOptionalTimeZone({
                date: date,
                formatDate: formatDate,
                timeZone: timeZone
            }) : formatDate(date, {
                month: "short",
                day: "numeric",
                year: "numeric"
            });
            $[0] = date;
            $[1] = formatDate;
            $[2] = timeZone;
            $[3] = t3;
        } else t3 = $[3];
        context = t3;
    } else {
        let t3;
        if ($[4] !== date || $[5] !== formatRelativeTime) {
            const { value: value, unit: unit } = (0, $4ULqR.selectUnit)(date, Date.now());
            typeVariant = "relative";
            t3 = formatRelativeTime(value, unit, {
                numeric: "auto"
            });
            $[4] = date;
            $[5] = formatRelativeTime;
            $[6] = t3;
            $[7] = typeVariant;
        } else {
            t3 = $[6];
            typeVariant = $[7];
        }
        context = t3;
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else {
        const t3 = $bbe6fa3f8ea6e4e4$var$typeToDescriptorMap[type][typeVariant];
        let t4;
        if ($[8] !== context) {
            t4 = {
                context: context
            };
            $[8] = context;
            $[9] = t4;
        } else t4 = $[9];
        let t5;
        if ($[10] !== t3 || $[11] !== t4) {
            t5 = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                ...t3,
                values: t4
            });
            $[10] = t3;
            $[11] = t4;
            $[12] = t5;
        } else t5 = $[12];
        content = t5;
    }
    let t3;
    if ($[13] !== color) {
        t3 = {
            color: color
        };
        $[13] = color;
        $[14] = t3;
    } else t3 = $[14];
    const t4 = fontSize !== undefined && $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap[fontSize];
    let t5;
    if ($[15] !== className || $[16] !== t4) {
        t5 = (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            t4,
            className
        ]);
        $[15] = className;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== content || $[19] !== name || $[20] !== t3 || $[21] !== t5 || $[22] !== testId) {
        t6 = /*#__PURE__*/ $42omo.createElement("span", {
            style: t3,
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-date-time": true,
            "data-testid": testId,
            className: t5
        }, content);
        $[18] = content;
        $[19] = name;
        $[20] = t3;
        $[21] = t5;
        $[22] = testId;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize, timeZone: timeZone })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = (0, $dh538.fg)('dfo_issue_view_remote_data_srr_group') ? $bbe6fa3f8ea6e4e4$var$formatAbsoluteDateWithOptionalTimeZone({
            date: date,
            formatDate: formatDate,
            timeZone: timeZone
        }) : formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $4ULqR.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
        ...$bbe6fa3f8ea6e4e4$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $42omo.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $bbe6fa3f8ea6e4e4$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039 = $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement;
const $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
module.exports["default"] = $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039;
module.exports["toDateTimeProps"] = $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3;

});

parcelRegister("8bb8e", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $5TXU5 = parcelRequire("5TXU5");


var $4gM1A = parcelRequire("4gM1A");


var $hJgLA = parcelRequire("hJgLA");

const $eb4f16a03665d341$var$DEFAULT_MAX_LINES = 2;
const $eb4f16a03665d341$var$MAXIMUM_MAX_LINES = 2;
const $eb4f16a03665d341$var$MINIMUM_MAX_LINES = 1;
const $eb4f16a03665d341$var$containerStyles = null;
const $eb4f16a03665d341$var$getMaxLines = (maxLines)=>{
    if (maxLines > $eb4f16a03665d341$var$MAXIMUM_MAX_LINES) return $eb4f16a03665d341$var$DEFAULT_MAX_LINES;
    if (maxLines < $eb4f16a03665d341$var$MINIMUM_MAX_LINES) return $eb4f16a03665d341$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $eb4f16a03665d341$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $eb4f16a03665d341$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8wadc _k48pi7a9 _vwz41j6v"
};
const $eb4f16a03665d341$var$baseAnchorStyle = null;
const $eb4f16a03665d341$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $eb4f16a03665d341$var$anchorConstantsStyles = null;
const $eb4f16a03665d341$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $eb4f16a03665d341$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uewadc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
const $eb4f16a03665d341$var$BaseLinkElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { hideTooltip: hideTooltip, maxLines: t1, name: name, className: className, size: t2, testId: t3, text: text, theme: t4, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: t5, anchorRef: anchorRef } = t0;
    const maxLines = t1 === undefined ? $eb4f16a03665d341$var$DEFAULT_MAX_LINES : t1;
    const size = t2 === undefined ? (0, $5TXU5.SmartLinkSize).Medium : t2;
    const testId = t3 === undefined ? "smart-element-link" : t3;
    const theme = t4 === undefined ? (0, $5TXU5.SmartLinkTheme).Link : t4;
    const target = t5 === undefined ? "_blank" : t5;
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = text ? (0, $hJgLA.hasWhiteSpace)(text) : false;
    const t6 = $eb4f16a03665d341$var$linkStyleSizeMap[size];
    const t7 = $eb4f16a03665d341$var$anchorLineClampMap[$eb4f16a03665d341$var$getMaxLines(maxLines)];
    const t8 = $eb4f16a03665d341$var$workBreakStyleMap[hasSpace ? "true" : "false"];
    let t9;
    if ($[0] !== maxLines || $[1] !== size) {
        t9 = $eb4f16a03665d341$var$getMaxLines(maxLines) === 1 && $eb4f16a03665d341$var$anchorLinkLineHeight1Map[size];
        $[0] = maxLines;
        $[1] = size;
        $[2] = t9;
    } else t9 = $[2];
    let t10;
    if ($[3] !== maxLines || $[4] !== size) {
        t10 = $eb4f16a03665d341$var$getMaxLines(maxLines) === 2 && $eb4f16a03665d341$var$anchorLinkLineHeight2Map[size];
        $[3] = maxLines;
        $[4] = size;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = $eb4f16a03665d341$var$themeStyleMap[theme];
    let t12;
    if ($[6] !== className || $[7] !== t10 || $[8] !== t11 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
        t12 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            t6,
            t7,
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            t8,
            t9,
            t10,
            t11,
            className
        ]);
        $[6] = className;
        $[7] = t10;
        $[8] = t11;
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
        $[12] = t9;
        $[13] = t12;
    } else t12 = $[13];
    let t13;
    if ($[14] !== target) {
        t13 = target !== "_self" && {
            target: target
        };
        $[14] = target;
        $[15] = t13;
    } else t13 = $[15];
    let t14;
    if ($[16] !== anchorRef || $[17] !== name || $[18] !== onAuxClick || $[19] !== onClick || $[20] !== onContextMenu || $[21] !== onMouseDown || $[22] !== t12 || $[23] !== t13 || $[24] !== testId || $[25] !== text || $[26] !== url) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            "data-smart-element": name,
            "data-smart-element-link": true,
            "data-testid": testId,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: onMouseDown,
            href: url,
            className: t12,
            ...t13,
            ref: anchorRef
        }, text);
        $[16] = anchorRef;
        $[17] = name;
        $[18] = onAuxClick;
        $[19] = onClick;
        $[20] = onContextMenu;
        $[21] = onMouseDown;
        $[22] = t12;
        $[23] = t13;
        $[24] = testId;
        $[25] = text;
        $[26] = url;
        $[27] = t14;
    } else t14 = $[27];
    const anchor = t14;
    let t15;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]);
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== anchor || $[30] !== hideTooltip || $[31] !== testId || $[32] !== text || $[33] !== url) {
        t16 = hideTooltip || text === undefined ? anchor : $eb4f16a03665d341$var$withTooltip(anchor, url?.includes(text) ? url : text, testId);
        $[29] = anchor;
        $[30] = hideTooltip;
        $[31] = testId;
        $[32] = text;
        $[33] = url;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: t15
        }, t16);
        $[35] = t16;
        $[36] = t17;
    } else t17 = $[36];
    return t17;
} : ({ hideTooltip: hideTooltip, maxLines: maxLines = $eb4f16a03665d341$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5TXU5.SmartLinkTheme).Link, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = (0, $42omo.useMemo)(()=>text ? (0, $hJgLA.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $eb4f16a03665d341$var$linkStyleSizeMap[size],
            $eb4f16a03665d341$var$anchorLineClampMap[$eb4f16a03665d341$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $eb4f16a03665d341$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 1 && $eb4f16a03665d341$var$anchorLinkLineHeight1Map[size],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 2 && $eb4f16a03665d341$var$anchorLinkLineHeight2Map[size],
            $eb4f16a03665d341$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $eb4f16a03665d341$var$withTooltip(anchor, url?.includes(text) ? url : text, testId));
};
var $eb4f16a03665d341$export$2e2bcd8739ae039 = $eb4f16a03665d341$var$BaseLinkElement;
const $eb4f16a03665d341$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
module.exports["default"] = $eb4f16a03665d341$export$2e2bcd8739ae039;

});

parcelRegister("7f92O", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $ho4zm = parcelRequire("ho4zm");


var $fUfR2 = parcelRequire("fUfR2");


var $cS65x = parcelRequire("cS65x");

const $7edf4af2ffda473e$var$styles = null;
const $7edf4af2ffda473e$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $7edf4af2ffda473e$var$BaseLozengeElement = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { action: action, appearance: t1, className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: t2, isDateTag: isDateTag, trailingMetric: trailingMetric } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const testId = t2 === undefined ? "smart-element-lozenge" : t2;
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    let t3;
    if ($[0] !== action || $[1] !== appearance || $[2] !== isDateTag || $[3] !== maxWidth || $[4] !== onAfterChanged || $[5] !== style || $[6] !== testId || $[7] !== text || $[8] !== trailingMetric || $[9] !== ui?.zIndex) {
        t3 = action ? /*#__PURE__*/ $42omo.createElement((0, $cS65x.default), {
            action: action,
            appearance: appearance,
            maxWidth: maxWidth,
            testId: testId,
            text: text,
            zIndex: ui?.zIndex,
            onAfterChanged: onAfterChanged,
            ...trailingMetric && (0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") ? {
                trailingMetric: trailingMetric
            } : undefined
        }) : isDateTag ? /*#__PURE__*/ $42omo.createElement((0, $ho4zm.default), {
            text: text,
            migration_fallback: "lozenge"
        }) : /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: style,
            testId: `${testId}-lozenge`,
            ...trailingMetric && (0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") ? {
                trailingMetric: trailingMetric
            } : undefined
        }, text);
        $[0] = action;
        $[1] = appearance;
        $[2] = isDateTag;
        $[3] = maxWidth;
        $[4] = onAfterChanged;
        $[5] = style;
        $[6] = testId;
        $[7] = text;
        $[8] = trailingMetric;
        $[9] = ui?.zIndex;
        $[10] = t3;
    } else t3 = $[10];
    const lozenge = t3;
    let t4;
    if ($[11] !== className || $[12] !== isDateTag) {
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ]);
        $[11] = className;
        $[12] = isDateTag;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== lozenge || $[15] !== name || $[16] !== t4 || $[17] !== testId) {
        t5 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-smart-element": name,
            "data-smart-element-lozenge": true,
            "data-testid": testId,
            className: t4
        }, lozenge);
        $[14] = lozenge;
        $[15] = name;
        $[16] = t4;
        $[17] = testId;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $42omo.createElement((0, $cS65x.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $42omo.createElement((0, $ho4zm.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ])
    }, lozenge);
};
var $7edf4af2ffda473e$export$2e2bcd8739ae039 = $7edf4af2ffda473e$var$BaseLozengeElement;
const $7edf4af2ffda473e$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
module.exports["default"] = $7edf4af2ffda473e$export$2e2bcd8739ae039;
module.exports["toDateLozengeProps"] = $7edf4af2ffda473e$export$8f9f58f7bac50fbe;

});

parcelRegister("1iDg7", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8ddce3b50e63e6e3$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $42omo.useRef)(null);
        (0, $42omo.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}
module.exports["withOverrideCss"] = $8ddce3b50e63e6e3$export$e0bdcacb944f1da6;

});

parcelRegister("g98dH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $htjmD = parcelRequire("htjmD");


var $eIleF = parcelRequire("eIleF");

const $b01bbbcb1713fd75$var$useInvoke = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    let t0;
    if ($[0] !== clientExt) {
        t0 = async (req, cb)=>{
            const response = await clientExt.invoke(req);
            return cb ? cb(response) : response;
        };
        $[0] = clientExt;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    return (0, $42omo.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b01bbbcb1713fd75$export$2e2bcd8739ae039 = $b01bbbcb1713fd75$var$useInvoke;
module.exports["default"] = $b01bbbcb1713fd75$export$2e2bcd8739ae039;

});

parcelRegister("8i8ID", function(module, exports) {

var $lgqac = parcelRequire("lgqac");

const $e9aefac4b34acc2c$export$65b3f792dff0bd60 = (err)=>{
    if (!$e9aefac4b34acc2c$export$1694272377fa07d8(err)) return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $lgqac.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    }
};
const $e9aefac4b34acc2c$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
module.exports["getInvokeFailureReason"] = $e9aefac4b34acc2c$export$65b3f792dff0bd60;
module.exports["isInvokeCustomError"] = $e9aefac4b34acc2c$export$1694272377fa07d8;

});

parcelRegister("4ULqR", function(module, exports) {
var $39412f7225a31c87$var$__assign = undefined && undefined.__assign || function() {
    $39412f7225a31c87$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39412f7225a31c87$var$__assign.apply(this, arguments);
};
var $39412f7225a31c87$var$MS_PER_SECOND = 1e3;
var $39412f7225a31c87$var$SECS_PER_MIN = 60;
var $39412f7225a31c87$var$SECS_PER_HOUR = $39412f7225a31c87$var$SECS_PER_MIN * 60;
var $39412f7225a31c87$var$SECS_PER_DAY = $39412f7225a31c87$var$SECS_PER_HOUR * 24;
var $39412f7225a31c87$var$SECS_PER_WEEK = $39412f7225a31c87$var$SECS_PER_DAY * 7;
function $39412f7225a31c87$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $39412f7225a31c87$var$__assign($39412f7225a31c87$var$__assign({}, $39412f7225a31c87$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $39412f7225a31c87$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $39412f7225a31c87$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $39412f7225a31c87$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $39412f7225a31c87$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $39412f7225a31c87$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $39412f7225a31c87$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};
module.exports["selectUnit"] = $39412f7225a31c87$export$b8f7189986dd5395;

});

parcelRegister("cS65x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");


var $dh538 = parcelRequire("dh538");


var $kKODE = parcelRequire("kKODE");


var $eJ92v = parcelRequire("eJ92v");


var $g98dH = parcelRequire("g98dH");


var $8i8ID = parcelRequire("8i8ID");


var $7DSoa = parcelRequire("7DSoa");


var $cOlaT = parcelRequire("cOlaT");


var $lgqac = parcelRequire("lgqac");


var $b7GIg = parcelRequire("b7GIg");


var $667Mo = parcelRequire("667Mo");


var $7uUCV = parcelRequire("7uUCV");


var $bTJCs = parcelRequire("bTJCs");


var $58trk = parcelRequire("58trk");


var $dXPIV = parcelRequire("dXPIV");

const $7fab12f071167d36$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $7fab12f071167d36$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    const [selected, setSelected] = (0, $42omo.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $42omo.useState)(false);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [items, setItems] = (0, $42omo.useState)();
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)();
    const reload = (0, $7DSoa.default)();
    const invoke = (0, $g98dH.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $42omo.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $eJ92v.default));
                const validItems = typeof text === 'string' ? $7fab12f071167d36$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $bTJCs.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $bTJCs.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXPIV.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $42omo.useCallback)(async (id, text_0, appearance_0)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $cOlaT.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance_0,
                    text: text_0
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload({
                    url: url,
                    isReloading: true,
                    id: linkId
                });
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8i8ID.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $42omo.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uUCV.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58trk.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $7fab12f071167d36$var$_default_1 = (0, $b7GIg.default)($7fab12f071167d36$var$LozengeAction);
var $7fab12f071167d36$export$2e2bcd8739ae039 = $7fab12f071167d36$var$_default_1;
module.exports["default"] = $7fab12f071167d36$export$2e2bcd8739ae039;

});

parcelRegister("htjmD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gmi3X = parcelRequire("gmi3X");


var $1vH0y = parcelRequire("1vH0y");


var $1Okf1 = parcelRequire("1Okf1");

const $6bb10922c4ae303f$export$303ede4eed148855 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (cardClient)=>{
    const $ = (0, $frIzR.c)(4);
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    let t0;
    if ($[0] !== resolverUrl) {
        t0 = async (data)=>{
            try {
                return await (0, $gmi3X.request)("post", `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (t1) {
                const err = t1;
                if (err && err.json && typeof err.json === "function") {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, $1vH0y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        };
        $[0] = resolverUrl;
        $[1] = t0;
    } else t0 = $[1];
    const invoke = t0;
    let t1;
    if ($[2] !== invoke) {
        t1 = {
            invoke: invoke
        };
        $[2] = invoke;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (cardClient)=>{
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    const invoke = (0, $42omo.useCallback)(async (data)=>{
        try {
            return await (0, $gmi3X.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $1vH0y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $42omo.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};
module.exports["useSmartLinkClientExtension"] = $6bb10922c4ae303f$export$303ede4eed148855;

});

parcelRegister("eJ92v", function(module, exports) {
const $de46c47a4ecd1eb4$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $de46c47a4ecd1eb4$export$2e2bcd8739ae039 = $de46c47a4ecd1eb4$var$extractLozengeActionItems;
module.exports["default"] = $de46c47a4ecd1eb4$export$2e2bcd8739ae039;

});

parcelRegister("cOlaT", function(module, exports) {
const $fa24a5eb3eb20317$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $fa24a5eb3eb20317$export$2e2bcd8739ae039 = $fa24a5eb3eb20317$var$createStatusUpdateRequest;
module.exports["default"] = $fa24a5eb3eb20317$export$2e2bcd8739ae039;

});

parcelRegister("b7GIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $5nBzc = parcelRequire("5nBzc");

const $d9e0a5eb52a0a8a6$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                appearance: props?.appearance,
                isBold: true,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props?.trailingMetric
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text,
            props?.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
var $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039 = $d9e0a5eb52a0a8a6$var$withErrorBoundary;
module.exports["default"] = $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039;

});

parcelRegister("667Mo", function(module, exports) {
const $e47eb447ef32ebf8$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $e47eb447ef32ebf8$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};
module.exports["unknownLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2a568ff99500df53;
module.exports["permissionLoadErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$2de2d0ccc17b915f;
module.exports["unknownUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$c1c05f9d51f7c467;
module.exports["validationUpdateErrorAnalyticsPayload"] = $e47eb447ef32ebf8$export$618660b8f2aa87e2;

});

parcelRegister("7uUCV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $a3fRD = parcelRequire("a3fRD");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $9oOnT = parcelRequire("9oOnT");


var $hJgLA = parcelRequire("hJgLA");

const $86481dd22f22993b$var$MAX_LINE_NUMBER = 8;
const $86481dd22f22993b$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $86481dd22f22993b$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $86481dd22f22993b$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const invoke = (0, $9oOnT.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $42omo.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $7sObp.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $hJgLA.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $86481dd22f22993b$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $86481dd22f22993b$var$styles.openIssueInJiraStyles
        }, (0, $dh538.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $gMc0m.default)([
            $86481dd22f22993b$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
        testId: `${testId}-error`
    }, content)));
};
var $86481dd22f22993b$export$2e2bcd8739ae039 = $86481dd22f22993b$var$LozengeActionError;
module.exports["default"] = $86481dd22f22993b$export$2e2bcd8739ae039;

});

parcelRegister("bTJCs", function(module, exports) {

var $afp1H = parcelRequire("afp1H");

const $3b4344c10bfc2ba3$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $afp1H.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $afp1H.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $afp1H.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $afp1H.messages)['status_change_update_error']
    }
};
module.exports["LozengeActionErrorMessages"] = $3b4344c10bfc2ba3$export$4f2e371a667ad688;

});

parcelRegister("58trk", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ahaN7 = parcelRequire("ahaN7");


var $k5ktp = parcelRequire("k5ktp");

const $7734c527fca28b11$var$dropdownItemGroupStyles = null;
const $7734c527fca28b11$var$LozengeActionItemsGroup = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { items: items, testId: testId, onClick: onClick } = t0;
    const t1 = `${testId}-item-group`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== items || $[2] !== onClick || $[3] !== testId) {
        let t4;
        if ($[5] !== onClick || $[6] !== testId) {
            t4 = (item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $k5ktp.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                });
            $[5] = onClick;
            $[6] = testId;
            $[7] = t4;
        } else t4 = $[7];
        t3 = items.map(t4);
        $[1] = items;
        $[2] = onClick;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t1 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": t1,
            className: t2
        }, t4);
        $[10] = t1;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), null, items.map((item, idx)=>/*#__PURE__*/ $42omo.createElement((0, $k5ktp.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $7734c527fca28b11$export$2e2bcd8739ae039 = $7734c527fca28b11$var$LozengeActionItemsGroup;
module.exports["default"] = $7734c527fca28b11$export$2e2bcd8739ae039;

});

parcelRegister("dXPIV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $5nBzc = parcelRequire("5nBzc");

var $9E7O8 = parcelRequire("9E7O8");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $afp1H = parcelRequire("afp1H");

const $7e3c19665a3fd574$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w",
    lozengeDropdownContainer: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $7e3c19665a3fd574$var$textStyles = null;
const $7e3c19665a3fd574$var$triggerLozengeStyles = null;
const $7e3c19665a3fd574$var$triggerButtonStyles = null;
const $7e3c19665a3fd574$var$LozengeActionTrigger = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(46);
    let appearance;
    let isOpen;
    let maxWidth;
    let props;
    let testId;
    let text;
    let trailingMetric;
    let triggerRef;
    if ($[0] !== t0) {
        ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = isOpen;
        $[3] = maxWidth;
        $[4] = props;
        $[5] = testId;
        $[6] = text;
        $[7] = trailingMetric;
        $[8] = triggerRef;
    } else {
        appearance = $[1];
        isOpen = $[2];
        maxWidth = $[3];
        props = $[4];
        testId = $[5];
        text = $[6];
        trailingMetric = $[7];
        triggerRef = $[8];
    }
    const intl = (0, $aXWIB.useIntl)();
    const [isPressing, setIsPressing] = (0, $42omo.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $42omo.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $42omo.useState)(undefined);
    let t1;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsPressing(true);
        $[9] = t1;
    } else t1 = $[9];
    const onMouseOrKeyDown = t1;
    let t2;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsPressing(false);
        $[10] = t2;
    } else t2 = $[10];
    const onMouseOrKeyUp = t2;
    let t3;
    let t4;
    if ($[11] !== isOpen || $[12] !== isPressing) {
        t3 = ()=>{
            if (isPressing) {
                setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
                setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
            } else if (isOpen) {
                setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
                setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
            } else {
                setLozengeBackgroundColor(undefined);
                setLozengeForegroundColor(undefined);
            }
        };
        t4 = [
            isPressing,
            isOpen
        ];
        $[11] = isOpen;
        $[12] = isPressing;
        $[13] = t3;
        $[14] = t4;
    } else {
        t3 = $[13];
        t4 = $[14];
    }
    (0, $42omo.useEffect)(t3, t4);
    const t5 = (isOpen || isPressing) && $7e3c19665a3fd574$var$styles.lozengeContainerSelected;
    let t6;
    if ($[15] !== t5) {
        t6 = (0, $1bHXt.cx)($7e3c19665a3fd574$var$styles.lozengeContainer, t5);
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== lozengeBackgroundColor || $[18] !== lozengeForegroundColor) {
        t7 = {
            backgroundColor: lozengeBackgroundColor,
            color: lozengeForegroundColor
        };
        $[17] = lozengeBackgroundColor;
        $[18] = lozengeForegroundColor;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c1txw"
        ]);
        t9 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]);
        $[20] = t8;
        $[21] = t9;
    } else {
        t8 = $[20];
        t9 = $[21];
    }
    let t10;
    if ($[22] !== text) {
        t10 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t9
        }, text);
        $[22] = text;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $7e3c19665a3fd574$var$styles.chevronDown
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        }));
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10) {
        t12 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t8
        }, t10, t11);
        $[25] = t10;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== appearance || $[28] !== maxWidth || $[29] !== t12 || $[30] !== t7) {
        t13 = /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: t7
        }, t12);
        $[27] = appearance;
        $[28] = maxWidth;
        $[29] = t12;
        $[30] = t7;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== t13 || $[33] !== t6) {
        t14 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: t6,
            as: "span"
        }, t13);
        $[32] = t13;
        $[33] = t6;
        $[34] = t14;
    } else t14 = $[34];
    const lozenge = t14;
    let t15;
    if ($[35] !== appearance || $[36] !== intl || $[37] !== isOpen || $[38] !== lozenge || $[39] !== maxWidth || $[40] !== props || $[41] !== testId || $[42] !== text || $[43] !== trailingMetric || $[44] !== triggerRef) {
        t15 = (0, $dh538.fg)("platform-dst-lozenge-tag-badge-visual-uplifts") ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $7e3c19665a3fd574$var$styles.lozengeDropdownContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $9E7O8.default), {
            ...props,
            appearance: appearance,
            trailingMetric: trailingMetric,
            "data-action-open": isOpen,
            "data-testid": `${testId}--trigger`,
            maxWidth: maxWidth,
            testId: testId,
            ref: triggerRef,
            "aria-label": intl.formatMessage((0, $afp1H.messages).change_status, {
                status: text
            })
        }, text)) : /*#__PURE__*/ $42omo.createElement("button", {
            type: "button",
            ...props,
            "data-action-open": isOpen,
            "data-testid": `${testId}--trigger`,
            style: {
                maxWidth: maxWidth
            },
            onMouseDown: onMouseOrKeyDown,
            onMouseUp: onMouseOrKeyUp,
            onKeyDown: onMouseOrKeyDown,
            onKeyUp: onMouseOrKeyUp,
            ref: triggerRef,
            "aria-label": intl.formatMessage((0, $afp1H.messages).change_status, {
                status: text
            }),
            className: (0, $gMc0m.default)([
                "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
            ])
        }, lozenge);
        $[35] = appearance;
        $[36] = intl;
        $[37] = isOpen;
        $[38] = lozenge;
        $[39] = maxWidth;
        $[40] = props;
        $[41] = testId;
        $[42] = text;
        $[43] = trailingMetric;
        $[44] = triggerRef;
        $[45] = t15;
    } else t15 = $[45];
    return t15;
} : ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isPressing, setIsPressing] = (0, $42omo.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $42omo.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $42omo.useState)(undefined);
    const onMouseOrKeyDown = (0, $42omo.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $42omo.useCallback)(()=>setIsPressing(false), []);
    (0, $42omo.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)($7e3c19665a3fd574$var$styles.lozengeContainer, (isOpen || isPressing) && $7e3c19665a3fd574$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $7e3c19665a3fd574$var$styles.chevronDown
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $7e3c19665a3fd574$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $9E7O8.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $afp1H.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $42omo.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $afp1H.messages).change_status, {
            status: text
        }),
        className: (0, $gMc0m.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $7e3c19665a3fd574$export$2e2bcd8739ae039 = $7e3c19665a3fd574$var$LozengeActionTrigger;
module.exports["default"] = $7e3c19665a3fd574$export$2e2bcd8739ae039;

});

parcelRegister("k5ktp", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dAYOx = parcelRequire("dAYOx");


var $5nBzc = parcelRequire("5nBzc");

const $c9439470310c10a2$var$LozengeActionItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { appearance: appearance, id: id, onClick: onClick, testId: testId, text: text } = t0;
    let t1;
    if ($[0] !== appearance || $[1] !== id || $[2] !== onClick || $[3] !== text) {
        t1 = (e)=>{
            e.stopPropagation();
            if (onClick) onClick(id, text, appearance);
        };
        $[0] = appearance;
        $[1] = id;
        $[2] = onClick;
        $[3] = text;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    const handleMouseEnter = $c9439470310c10a2$var$_temp;
    let t2;
    if ($[5] !== appearance || $[6] !== text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: appearance,
            isBold: true
        }, text);
        $[5] = appearance;
        $[6] = text;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== handleClick || $[9] !== t2 || $[10] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            onFocus: handleMouseEnter,
            onMouseEnter: handleMouseEnter,
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: handleClick,
            testId: testId
        }, t2));
        $[8] = handleClick;
        $[9] = t2;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $42omo.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((e_0)=>{
        e_0.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $c9439470310c10a2$export$2e2bcd8739ae039 = $c9439470310c10a2$var$LozengeActionItem;
function $c9439470310c10a2$var$_temp(e_0) {
    e_0.currentTarget?.firstElementChild?.focus();
}
module.exports["default"] = $c9439470310c10a2$export$2e2bcd8739ae039;

});


$parcel$global.rlb("gyh6H")
//# sourceMappingURL=RelatedLinksModal.946ef305.js.map
